import { jsxs, jsx, Fragment } from 'react/jsx-runtime';
import * as e from 'react';
import e__default, { createElement, Component, createRef, useRef, useMemo, forwardRef, useState } from 'react';
import n from 'date-fns/isDate';
import o from 'date-fns/isValid';
import a from 'date-fns/format';
import s from 'date-fns/addMinutes';
import i from 'date-fns/addHours';
import p from 'date-fns/addDays';
import c from 'date-fns/addWeeks';
import l from 'date-fns/addMonths';
import d from 'date-fns/addQuarters';
import u from 'date-fns/addYears';
import h from 'date-fns/subDays';
import m from 'date-fns/subWeeks';
import f from 'date-fns/subMonths';
import y from 'date-fns/subQuarters';
import v from 'date-fns/subYears';
import D from 'date-fns/getSeconds';
import g from 'date-fns/getMinutes';
import k from 'date-fns/getHours';
import w from 'date-fns/getDay';
import b from 'date-fns/getDate';
import S from 'date-fns/getISOWeek';
import C from 'date-fns/getMonth';
import _ from 'date-fns/getQuarter';
import M from 'date-fns/getYear';
import P from 'date-fns/getTime';
import E from 'date-fns/setSeconds';
import N from 'date-fns/setMinutes';
import x from 'date-fns/setHours';
import Y from 'date-fns/setMonth';
import T from 'date-fns/setQuarter';
import I from 'date-fns/setYear';
import O from 'date-fns/min';
import R from 'date-fns/max';
import L from 'date-fns/differenceInCalendarDays';
import F from 'date-fns/differenceInCalendarMonths';
import A from 'date-fns/differenceInCalendarYears';
import W from 'date-fns/startOfDay';
import K from 'date-fns/startOfWeek';
import B from 'date-fns/startOfMonth';
import Q from 'date-fns/startOfQuarter';
import H from 'date-fns/startOfYear';
import j from 'date-fns/endOfDay';
import 'date-fns/endOfWeek';
import V from 'date-fns/endOfMonth';
import q from 'date-fns/endOfYear';
import U from 'date-fns/isEqual';
import z from 'date-fns/isSameDay';
import $ from 'date-fns/isSameMonth';
import G from 'date-fns/isSameYear';
import J from 'date-fns/isSameQuarter';
import X from 'date-fns/isAfter';
import Z from 'date-fns/isBefore';
import ee from 'date-fns/isWithinInterval';
import te from 'date-fns/toDate';
import re from 'date-fns/parse';
import ne from 'date-fns/parseISO';
import * as ReactDOM from 'react-dom';
import ReactDOM__default, { findDOMNode } from 'react-dom';
import ce from 'date-fns/set';
import { defaultBaseline, defaultFonts, uniqueId, safeRest } from '@wds/utils';
import { IconArrowLeft, IconArrowRight, IconClock, IconCalendar, IconCaretDown, IconCheck } from '@wds/icons';
import { Input } from '@wds/input';
import { InputGroup, InputGroupAddon } from '@wds/input-group';
import { createMemoStyles } from '@wds/styles';
import { getYear, addWeeks, format } from 'date-fns';
import { Box } from '@wds/box';
import { Typography } from '@wds/typography';
import { SITE_WIDE_LOCALE_CODES } from '@sm/locale';
import en from 'date-fns/locale/en-US';
import zhTW from 'date-fns/locale/zh-TW';
import ptBR from 'date-fns/locale/pt-BR';
import da from 'date-fns/locale/da';
import nl from 'date-fns/locale/nl';
import fi from 'date-fns/locale/fi';
import fr from 'date-fns/locale/fr';
import de$1 from 'date-fns/locale/de';
import it$1 from 'date-fns/locale/it';
import ja from 'date-fns/locale/ja';
import ko from 'date-fns/locale/ko';
import nn from 'date-fns/locale/nn';
import ru from 'date-fns/locale/ru';
import es from 'date-fns/locale/es';
import sv from 'date-fns/locale/sv';
import tr$1 from 'date-fns/locale/tr';
import { Button } from '@wds/button';
import { Label } from '@wds/label';
import { Responsive } from '@wds/responsive';
import { Menu } from '@wds/menu';

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise, SuppressedError, Symbol, Iterator */


var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

typeof SuppressedError === "function" ? SuppressedError : function (error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};

function getDefaultExportFromCjs (x) {
	return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}

var classnames = {exports: {}};

/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/

(function (module) {
	/* global define */

	(function () {

		var hasOwn = {}.hasOwnProperty;

		function classNames () {
			var classes = '';

			for (var i = 0; i < arguments.length; i++) {
				var arg = arguments[i];
				if (arg) {
					classes = appendClass(classes, parseValue(arg));
				}
			}

			return classes;
		}

		function parseValue (arg) {
			if (typeof arg === 'string' || typeof arg === 'number') {
				return arg;
			}

			if (typeof arg !== 'object') {
				return '';
			}

			if (Array.isArray(arg)) {
				return classNames.apply(null, arg);
			}

			if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes('[native code]')) {
				return arg.toString();
			}

			var classes = '';

			for (var key in arg) {
				if (hasOwn.call(arg, key) && arg[key]) {
					classes = appendClass(classes, key);
				}
			}

			return classes;
		}

		function appendClass (value, newClass) {
			if (!newClass) {
				return value;
			}
		
			if (value) {
				return value + ' ' + newClass;
			}
		
			return value + newClass;
		}

		if (module.exports) {
			classNames.default = classNames;
			module.exports = classNames;
		} else {
			window.classNames = classNames;
		}
	}()); 
} (classnames));

var classnamesExports = classnames.exports;
var r = /*@__PURE__*/getDefaultExportFromCjs(classnamesExports);

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;

  _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}/**
 * Check whether some DOM node is our Component's node.
 */
function isNodeFound(current, componentNode, ignoreClass) {
  if (current === componentNode) {
    return true;
  } // SVG <use/> elements do not technically reside in the rendered DOM, so
  // they do not have classList directly, but they offer a link to their
  // corresponding element, which can have classList. This extra check is for
  // that case.
  // See: http://www.w3.org/TR/SVG11/struct.html#InterfaceSVGUseElement
  // Discussion: https://github.com/Pomax/react-onclickoutside/pull/17


  if (current.correspondingElement) {
    return current.correspondingElement.classList.contains(ignoreClass);
  }

  return current.classList.contains(ignoreClass);
}
/**
 * Try to find our node in a hierarchy of nodes, returning the document
 * node as highest node if our node is not found in the path up.
 */

function findHighest(current, componentNode, ignoreClass) {
  if (current === componentNode) {
    return true;
  } // If source=local then this event came from 'somewhere'
  // inside and should be ignored. We could handle this with
  // a layered approach, too, but that requires going back to
  // thinking in terms of Dom node nesting, running counter
  // to React's 'you shouldn't care about the DOM' philosophy.
  // Also cover shadowRoot node by checking current.host


  while (current.parentNode || current.host) {
    // Only check normal node without shadowRoot
    if (current.parentNode && isNodeFound(current, componentNode, ignoreClass)) {
      return true;
    }

    current = current.parentNode || current.host;
  }

  return current;
}
/**
 * Check if the browser scrollbar was clicked
 */

function clickedScrollbar(evt) {
  return document.documentElement.clientWidth <= evt.clientX || document.documentElement.clientHeight <= evt.clientY;
}// ideally will get replaced with external dep
// when rafrex/detect-passive-events#4 and rafrex/detect-passive-events#5 get merged in
var testPassiveEventSupport = function testPassiveEventSupport() {
  if (typeof window === 'undefined' || typeof window.addEventListener !== 'function') {
    return;
  }

  var passive = false;
  var options = Object.defineProperty({}, 'passive', {
    get: function get() {
      passive = true;
    }
  });

  var noop = function noop() {};

  window.addEventListener('testPassiveEventSupport', noop, options);
  window.removeEventListener('testPassiveEventSupport', noop, options);
  return passive;
};function autoInc(seed) {
  if (seed === void 0) {
    seed = 0;
  }

  return function () {
    return ++seed;
  };
}

var uid = autoInc();var passiveEventSupport;
var handlersMap = {};
var enabledInstances = {};
var touchEvents = ['touchstart', 'touchmove'];
var IGNORE_CLASS_NAME = 'ignore-react-onclickoutside';
/**
 * Options for addEventHandler and removeEventHandler
 */

function getEventHandlerOptions(instance, eventName) {
  var handlerOptions = {};
  var isTouchEvent = touchEvents.indexOf(eventName) !== -1;

  if (isTouchEvent && passiveEventSupport) {
    handlerOptions.passive = !instance.props.preventDefault;
  }

  return handlerOptions;
}
/**
 * This function generates the HOC function that you'll use
 * in order to impart onOutsideClick listening to an
 * arbitrary component. It gets called at the end of the
 * bootstrapping code to yield an instance of the
 * onClickOutsideHOC function defined inside setupHOC().
 */


function onClickOutsideHOC(WrappedComponent, config) {
  var _class, _temp;

  var componentName = WrappedComponent.displayName || WrappedComponent.name || 'Component';
  return _temp = _class = /*#__PURE__*/function (_Component) {
    _inheritsLoose(onClickOutside, _Component);

    function onClickOutside(props) {
      var _this;

      _this = _Component.call(this, props) || this;

      _this.__outsideClickHandler = function (event) {
        if (typeof _this.__clickOutsideHandlerProp === 'function') {
          _this.__clickOutsideHandlerProp(event);

          return;
        }

        var instance = _this.getInstance();

        if (typeof instance.props.handleClickOutside === 'function') {
          instance.props.handleClickOutside(event);
          return;
        }

        if (typeof instance.handleClickOutside === 'function') {
          instance.handleClickOutside(event);
          return;
        }

        throw new Error("WrappedComponent: " + componentName + " lacks a handleClickOutside(event) function for processing outside click events.");
      };

      _this.__getComponentNode = function () {
        var instance = _this.getInstance();

        if (typeof instance.setClickOutsideRef === 'function') {
          return instance.setClickOutsideRef();
        }

        return findDOMNode(instance);
      };

      _this.enableOnClickOutside = function () {
        if (typeof document === 'undefined' || enabledInstances[_this._uid]) {
          return;
        }

        if (typeof passiveEventSupport === 'undefined') {
          passiveEventSupport = testPassiveEventSupport();
        }

        enabledInstances[_this._uid] = true;
        var events = _this.props.eventTypes;

        if (!events.forEach) {
          events = [events];
        }

        handlersMap[_this._uid] = function (event) {
          if (_this.componentNode === null) return;
          if (_this.initTimeStamp > event.timeStamp) return;

          if (_this.props.preventDefault) {
            event.preventDefault();
          }

          if (_this.props.stopPropagation) {
            event.stopPropagation();
          }

          if (_this.props.excludeScrollbar && clickedScrollbar(event)) return;
          var current = event.composed && event.composedPath && event.composedPath().shift() || event.target;

          if (findHighest(current, _this.componentNode, _this.props.outsideClickIgnoreClass) !== document) {
            return;
          }

          _this.__outsideClickHandler(event);
        };

        events.forEach(function (eventName) {
          document.addEventListener(eventName, handlersMap[_this._uid], getEventHandlerOptions(_assertThisInitialized(_this), eventName));
        });
      };

      _this.disableOnClickOutside = function () {
        delete enabledInstances[_this._uid];
        var fn = handlersMap[_this._uid];

        if (fn && typeof document !== 'undefined') {
          var events = _this.props.eventTypes;

          if (!events.forEach) {
            events = [events];
          }

          events.forEach(function (eventName) {
            return document.removeEventListener(eventName, fn, getEventHandlerOptions(_assertThisInitialized(_this), eventName));
          });
          delete handlersMap[_this._uid];
        }
      };

      _this.getRef = function (ref) {
        return _this.instanceRef = ref;
      };

      _this._uid = uid();
      _this.initTimeStamp = performance.now();
      return _this;
    }
    /**
     * Access the WrappedComponent's instance.
     */


    var _proto = onClickOutside.prototype;

    _proto.getInstance = function getInstance() {
      if (WrappedComponent.prototype && !WrappedComponent.prototype.isReactComponent) {
        return this;
      }

      var ref = this.instanceRef;
      return ref.getInstance ? ref.getInstance() : ref;
    };

    /**
     * Add click listeners to the current document,
     * linked to this component's state.
     */
    _proto.componentDidMount = function componentDidMount() {
      // If we are in an environment without a DOM such
      // as shallow rendering or snapshots then we exit
      // early to prevent any unhandled errors being thrown.
      if (typeof document === 'undefined' || !document.createElement) {
        return;
      }

      this.getInstance();

      this.componentNode = this.__getComponentNode(); // return early so we dont initiate onClickOutside

      if (this.props.disableOnClickOutside) return;
      this.enableOnClickOutside();
    };

    _proto.componentDidUpdate = function componentDidUpdate() {
      this.componentNode = this.__getComponentNode();
    }
    /**
     * Remove all document's event listeners for this component
     */
    ;

    _proto.componentWillUnmount = function componentWillUnmount() {
      this.disableOnClickOutside();
    }
    /**
     * Can be called to explicitly enable event listening
     * for clicks and touches outside of this element.
     */
    ;

    /**
     * Pass-through render
     */
    _proto.render = function render() {
      // eslint-disable-next-line no-unused-vars
      var _this$props = this.props;
          _this$props.excludeScrollbar;
          var props = _objectWithoutPropertiesLoose(_this$props, ["excludeScrollbar"]);

      if (WrappedComponent.prototype && WrappedComponent.prototype.isReactComponent) {
        props.ref = this.getRef;
      } else {
        props.wrappedRef = this.getRef;
      }

      props.disableOnClickOutside = this.disableOnClickOutside;
      props.enableOnClickOutside = this.enableOnClickOutside;
      return createElement(WrappedComponent, props);
    };

    return onClickOutside;
  }(Component), _class.displayName = "OnClickOutside(" + componentName + ")", _class.defaultProps = {
    eventTypes: ['mousedown', 'touchstart'],
    excludeScrollbar: false,
    outsideClickIgnoreClass: IGNORE_CLASS_NAME,
    preventDefault: false,
    stopPropagation: false
  }, _class.getClass = function () {
    return WrappedComponent.getClass ? WrappedComponent.getClass() : WrappedComponent;
  }, _temp;
}

var ManagerReferenceNodeContext = e.createContext();
var ManagerReferenceNodeSetterContext = e.createContext();
function Manager(_ref) {
  var children = _ref.children;

  var _React$useState = e.useState(null),
      referenceNode = _React$useState[0],
      setReferenceNode = _React$useState[1];

  var hasUnmounted = e.useRef(false);
  e.useEffect(function () {
    return function () {
      hasUnmounted.current = true;
    };
  }, []);
  var handleSetReferenceNode = e.useCallback(function (node) {
    if (!hasUnmounted.current) {
      setReferenceNode(node);
    }
  }, []);
  return /*#__PURE__*/e.createElement(ManagerReferenceNodeContext.Provider, {
    value: referenceNode
  }, /*#__PURE__*/e.createElement(ManagerReferenceNodeSetterContext.Provider, {
    value: handleSetReferenceNode
  }, children));
}

/**
 * Takes an argument and if it's an array, returns the first item in the array,
 * otherwise returns the argument. Used for Preact compatibility.
 */
var unwrapArray = function unwrapArray(arg) {
  return Array.isArray(arg) ? arg[0] : arg;
};
/**
 * Takes a maybe-undefined function and arbitrary args and invokes the function
 * only if it is defined.
 */

var safeInvoke = function safeInvoke(fn) {
  if (typeof fn === 'function') {
    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    return fn.apply(void 0, args);
  }
};
/**
 * Sets a ref using either a ref callback or a ref object
 */

var setRef = function setRef(ref, node) {
  // if its a function call it
  if (typeof ref === 'function') {
    return safeInvoke(ref, node);
  } // otherwise we should treat it as a ref object
  else if (ref != null) {
      ref.current = node;
    }
};
/**
 * Simple ponyfill for Object.fromEntries
 */

var fromEntries = function fromEntries(entries) {
  return entries.reduce(function (acc, _ref) {
    var key = _ref[0],
        value = _ref[1];
    acc[key] = value;
    return acc;
  }, {});
};
/**
 * Small wrapper around `useLayoutEffect` to get rid of the warning on SSR envs
 */

var useIsomorphicLayoutEffect = typeof window !== 'undefined' && window.document && window.document.createElement ? e.useLayoutEffect : e.useEffect;

var top = 'top';
var bottom = 'bottom';
var right = 'right';
var left = 'left';
var auto = 'auto';
var basePlacements = [top, bottom, right, left];
var start = 'start';
var end = 'end';
var clippingParents = 'clippingParents';
var viewport = 'viewport';
var popper = 'popper';
var reference = 'reference';
var variationPlacements = /*#__PURE__*/basePlacements.reduce(function (acc, placement) {
  return acc.concat([placement + "-" + start, placement + "-" + end]);
}, []);
var placements = /*#__PURE__*/[].concat(basePlacements, [auto]).reduce(function (acc, placement) {
  return acc.concat([placement, placement + "-" + start, placement + "-" + end]);
}, []); // modifiers that need to read the DOM

var beforeRead = 'beforeRead';
var read = 'read';
var afterRead = 'afterRead'; // pure-logic modifiers

var beforeMain = 'beforeMain';
var main = 'main';
var afterMain = 'afterMain'; // modifier with the purpose to write to the DOM (or write into a framework state)

var beforeWrite = 'beforeWrite';
var write = 'write';
var afterWrite = 'afterWrite';
var modifierPhases = [beforeRead, read, afterRead, beforeMain, main, afterMain, beforeWrite, write, afterWrite];

function getNodeName(element) {
  return element ? (element.nodeName || '').toLowerCase() : null;
}

function getWindow(node) {
  if (node == null) {
    return window;
  }

  if (node.toString() !== '[object Window]') {
    var ownerDocument = node.ownerDocument;
    return ownerDocument ? ownerDocument.defaultView || window : window;
  }

  return node;
}

function isElement(node) {
  var OwnElement = getWindow(node).Element;
  return node instanceof OwnElement || node instanceof Element;
}

function isHTMLElement(node) {
  var OwnElement = getWindow(node).HTMLElement;
  return node instanceof OwnElement || node instanceof HTMLElement;
}

function isShadowRoot(node) {
  // IE 11 has no ShadowRoot
  if (typeof ShadowRoot === 'undefined') {
    return false;
  }

  var OwnElement = getWindow(node).ShadowRoot;
  return node instanceof OwnElement || node instanceof ShadowRoot;
}

// and applies them to the HTMLElements such as popper and arrow

function applyStyles(_ref) {
  var state = _ref.state;
  Object.keys(state.elements).forEach(function (name) {
    var style = state.styles[name] || {};
    var attributes = state.attributes[name] || {};
    var element = state.elements[name]; // arrow is optional + virtual elements

    if (!isHTMLElement(element) || !getNodeName(element)) {
      return;
    } // Flow doesn't support to extend this property, but it's the most
    // effective way to apply styles to an HTMLElement
    // $FlowFixMe[cannot-write]


    Object.assign(element.style, style);
    Object.keys(attributes).forEach(function (name) {
      var value = attributes[name];

      if (value === false) {
        element.removeAttribute(name);
      } else {
        element.setAttribute(name, value === true ? '' : value);
      }
    });
  });
}

function effect$2(_ref2) {
  var state = _ref2.state;
  var initialStyles = {
    popper: {
      position: state.options.strategy,
      left: '0',
      top: '0',
      margin: '0'
    },
    arrow: {
      position: 'absolute'
    },
    reference: {}
  };
  Object.assign(state.elements.popper.style, initialStyles.popper);
  state.styles = initialStyles;

  if (state.elements.arrow) {
    Object.assign(state.elements.arrow.style, initialStyles.arrow);
  }

  return function () {
    Object.keys(state.elements).forEach(function (name) {
      var element = state.elements[name];
      var attributes = state.attributes[name] || {};
      var styleProperties = Object.keys(state.styles.hasOwnProperty(name) ? state.styles[name] : initialStyles[name]); // Set all values to an empty string to unset them

      var style = styleProperties.reduce(function (style, property) {
        style[property] = '';
        return style;
      }, {}); // arrow is optional + virtual elements

      if (!isHTMLElement(element) || !getNodeName(element)) {
        return;
      }

      Object.assign(element.style, style);
      Object.keys(attributes).forEach(function (attribute) {
        element.removeAttribute(attribute);
      });
    });
  };
} // eslint-disable-next-line import/no-unused-modules


var applyStyles$1 = {
  name: 'applyStyles',
  enabled: true,
  phase: 'write',
  fn: applyStyles,
  effect: effect$2,
  requires: ['computeStyles']
};

function getBasePlacement(placement) {
  return placement.split('-')[0];
}

var max = Math.max;
var min = Math.min;
var round = Math.round;

function getUAString() {
  var uaData = navigator.userAgentData;

  if (uaData != null && uaData.brands && Array.isArray(uaData.brands)) {
    return uaData.brands.map(function (item) {
      return item.brand + "/" + item.version;
    }).join(' ');
  }

  return navigator.userAgent;
}

function isLayoutViewport() {
  return !/^((?!chrome|android).)*safari/i.test(getUAString());
}

function getBoundingClientRect(element, includeScale, isFixedStrategy) {
  if (includeScale === void 0) {
    includeScale = false;
  }

  if (isFixedStrategy === void 0) {
    isFixedStrategy = false;
  }

  var clientRect = element.getBoundingClientRect();
  var scaleX = 1;
  var scaleY = 1;

  if (includeScale && isHTMLElement(element)) {
    scaleX = element.offsetWidth > 0 ? round(clientRect.width) / element.offsetWidth || 1 : 1;
    scaleY = element.offsetHeight > 0 ? round(clientRect.height) / element.offsetHeight || 1 : 1;
  }

  var _ref = isElement(element) ? getWindow(element) : window,
      visualViewport = _ref.visualViewport;

  var addVisualOffsets = !isLayoutViewport() && isFixedStrategy;
  var x = (clientRect.left + (addVisualOffsets && visualViewport ? visualViewport.offsetLeft : 0)) / scaleX;
  var y = (clientRect.top + (addVisualOffsets && visualViewport ? visualViewport.offsetTop : 0)) / scaleY;
  var width = clientRect.width / scaleX;
  var height = clientRect.height / scaleY;
  return {
    width: width,
    height: height,
    top: y,
    right: x + width,
    bottom: y + height,
    left: x,
    x: x,
    y: y
  };
}

// means it doesn't take into account transforms.

function getLayoutRect(element) {
  var clientRect = getBoundingClientRect(element); // Use the clientRect sizes if it's not been transformed.
  // Fixes https://github.com/popperjs/popper-core/issues/1223

  var width = element.offsetWidth;
  var height = element.offsetHeight;

  if (Math.abs(clientRect.width - width) <= 1) {
    width = clientRect.width;
  }

  if (Math.abs(clientRect.height - height) <= 1) {
    height = clientRect.height;
  }

  return {
    x: element.offsetLeft,
    y: element.offsetTop,
    width: width,
    height: height
  };
}

function contains(parent, child) {
  var rootNode = child.getRootNode && child.getRootNode(); // First, attempt with faster native method

  if (parent.contains(child)) {
    return true;
  } // then fallback to custom implementation with Shadow DOM support
  else if (rootNode && isShadowRoot(rootNode)) {
      var next = child;

      do {
        if (next && parent.isSameNode(next)) {
          return true;
        } // $FlowFixMe[prop-missing]: need a better way to handle this...


        next = next.parentNode || next.host;
      } while (next);
    } // Give up, the result is false


  return false;
}

function getComputedStyle(element) {
  return getWindow(element).getComputedStyle(element);
}

function isTableElement(element) {
  return ['table', 'td', 'th'].indexOf(getNodeName(element)) >= 0;
}

function getDocumentElement(element) {
  // $FlowFixMe[incompatible-return]: assume body is always available
  return ((isElement(element) ? element.ownerDocument : // $FlowFixMe[prop-missing]
  element.document) || window.document).documentElement;
}

function getParentNode(element) {
  if (getNodeName(element) === 'html') {
    return element;
  }

  return (// this is a quicker (but less type safe) way to save quite some bytes from the bundle
    // $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    element.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    element.parentNode || ( // DOM Element detected
    isShadowRoot(element) ? element.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    getDocumentElement(element) // fallback

  );
}

function getTrueOffsetParent(element) {
  if (!isHTMLElement(element) || // https://github.com/popperjs/popper-core/issues/837
  getComputedStyle(element).position === 'fixed') {
    return null;
  }

  return element.offsetParent;
} // `.offsetParent` reports `null` for fixed elements, while absolute elements
// return the containing block


function getContainingBlock(element) {
  var isFirefox = /firefox/i.test(getUAString());
  var isIE = /Trident/i.test(getUAString());

  if (isIE && isHTMLElement(element)) {
    // In IE 9, 10 and 11 fixed elements containing block is always established by the viewport
    var elementCss = getComputedStyle(element);

    if (elementCss.position === 'fixed') {
      return null;
    }
  }

  var currentNode = getParentNode(element);

  if (isShadowRoot(currentNode)) {
    currentNode = currentNode.host;
  }

  while (isHTMLElement(currentNode) && ['html', 'body'].indexOf(getNodeName(currentNode)) < 0) {
    var css = getComputedStyle(currentNode); // This is non-exhaustive but covers the most common CSS properties that
    // create a containing block.
    // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block

    if (css.transform !== 'none' || css.perspective !== 'none' || css.contain === 'paint' || ['transform', 'perspective'].indexOf(css.willChange) !== -1 || isFirefox && css.willChange === 'filter' || isFirefox && css.filter && css.filter !== 'none') {
      return currentNode;
    } else {
      currentNode = currentNode.parentNode;
    }
  }

  return null;
} // Gets the closest ancestor positioned element. Handles some edge cases,
// such as table ancestors and cross browser bugs.


function getOffsetParent(element) {
  var window = getWindow(element);
  var offsetParent = getTrueOffsetParent(element);

  while (offsetParent && isTableElement(offsetParent) && getComputedStyle(offsetParent).position === 'static') {
    offsetParent = getTrueOffsetParent(offsetParent);
  }

  if (offsetParent && (getNodeName(offsetParent) === 'html' || getNodeName(offsetParent) === 'body' && getComputedStyle(offsetParent).position === 'static')) {
    return window;
  }

  return offsetParent || getContainingBlock(element) || window;
}

function getMainAxisFromPlacement(placement) {
  return ['top', 'bottom'].indexOf(placement) >= 0 ? 'x' : 'y';
}

function within(min$1, value, max$1) {
  return max(min$1, min(value, max$1));
}
function withinMaxClamp(min, value, max) {
  var v = within(min, value, max);
  return v > max ? max : v;
}

function getFreshSideObject() {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  };
}

function mergePaddingObject(paddingObject) {
  return Object.assign({}, getFreshSideObject(), paddingObject);
}

function expandToHashMap(value, keys) {
  return keys.reduce(function (hashMap, key) {
    hashMap[key] = value;
    return hashMap;
  }, {});
}

var toPaddingObject = function toPaddingObject(padding, state) {
  padding = typeof padding === 'function' ? padding(Object.assign({}, state.rects, {
    placement: state.placement
  })) : padding;
  return mergePaddingObject(typeof padding !== 'number' ? padding : expandToHashMap(padding, basePlacements));
};

function arrow(_ref) {
  var _state$modifiersData$;

  var state = _ref.state,
      name = _ref.name,
      options = _ref.options;
  var arrowElement = state.elements.arrow;
  var popperOffsets = state.modifiersData.popperOffsets;
  var basePlacement = getBasePlacement(state.placement);
  var axis = getMainAxisFromPlacement(basePlacement);
  var isVertical = [left, right].indexOf(basePlacement) >= 0;
  var len = isVertical ? 'height' : 'width';

  if (!arrowElement || !popperOffsets) {
    return;
  }

  var paddingObject = toPaddingObject(options.padding, state);
  var arrowRect = getLayoutRect(arrowElement);
  var minProp = axis === 'y' ? top : left;
  var maxProp = axis === 'y' ? bottom : right;
  var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets[axis] - state.rects.popper[len];
  var startDiff = popperOffsets[axis] - state.rects.reference[axis];
  var arrowOffsetParent = getOffsetParent(arrowElement);
  var clientSize = arrowOffsetParent ? axis === 'y' ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
  var centerToReference = endDiff / 2 - startDiff / 2; // Make sure the arrow doesn't overflow the popper if the center point is
  // outside of the popper bounds

  var min = paddingObject[minProp];
  var max = clientSize - arrowRect[len] - paddingObject[maxProp];
  var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
  var offset = within(min, center, max); // Prevents breaking syntax highlighting...

  var axisProp = axis;
  state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset, _state$modifiersData$.centerOffset = offset - center, _state$modifiersData$);
}

function effect$1(_ref2) {
  var state = _ref2.state,
      options = _ref2.options;
  var _options$element = options.element,
      arrowElement = _options$element === void 0 ? '[data-popper-arrow]' : _options$element;

  if (arrowElement == null) {
    return;
  } // CSS selector


  if (typeof arrowElement === 'string') {
    arrowElement = state.elements.popper.querySelector(arrowElement);

    if (!arrowElement) {
      return;
    }
  }

  if (!contains(state.elements.popper, arrowElement)) {
    return;
  }

  state.elements.arrow = arrowElement;
} // eslint-disable-next-line import/no-unused-modules


var arrow$1 = {
  name: 'arrow',
  enabled: true,
  phase: 'main',
  fn: arrow,
  effect: effect$1,
  requires: ['popperOffsets'],
  requiresIfExists: ['preventOverflow']
};

function getVariation(placement) {
  return placement.split('-')[1];
}

var unsetSides = {
  top: 'auto',
  right: 'auto',
  bottom: 'auto',
  left: 'auto'
}; // Round the offsets to the nearest suitable subpixel based on the DPR.
// Zooming can change the DPR, but it seems to report a value that will
// cleanly divide the values into the appropriate subpixels.

function roundOffsetsByDPR(_ref, win) {
  var x = _ref.x,
      y = _ref.y;
  var dpr = win.devicePixelRatio || 1;
  return {
    x: round(x * dpr) / dpr || 0,
    y: round(y * dpr) / dpr || 0
  };
}

function mapToStyles(_ref2) {
  var _Object$assign2;

  var popper = _ref2.popper,
      popperRect = _ref2.popperRect,
      placement = _ref2.placement,
      variation = _ref2.variation,
      offsets = _ref2.offsets,
      position = _ref2.position,
      gpuAcceleration = _ref2.gpuAcceleration,
      adaptive = _ref2.adaptive,
      roundOffsets = _ref2.roundOffsets,
      isFixed = _ref2.isFixed;
  var _offsets$x = offsets.x,
      x = _offsets$x === void 0 ? 0 : _offsets$x,
      _offsets$y = offsets.y,
      y = _offsets$y === void 0 ? 0 : _offsets$y;

  var _ref3 = typeof roundOffsets === 'function' ? roundOffsets({
    x: x,
    y: y
  }) : {
    x: x,
    y: y
  };

  x = _ref3.x;
  y = _ref3.y;
  var hasX = offsets.hasOwnProperty('x');
  var hasY = offsets.hasOwnProperty('y');
  var sideX = left;
  var sideY = top;
  var win = window;

  if (adaptive) {
    var offsetParent = getOffsetParent(popper);
    var heightProp = 'clientHeight';
    var widthProp = 'clientWidth';

    if (offsetParent === getWindow(popper)) {
      offsetParent = getDocumentElement(popper);

      if (getComputedStyle(offsetParent).position !== 'static' && position === 'absolute') {
        heightProp = 'scrollHeight';
        widthProp = 'scrollWidth';
      }
    } // $FlowFixMe[incompatible-cast]: force type refinement, we compare offsetParent with window above, but Flow doesn't detect it


    offsetParent = offsetParent;

    if (placement === top || (placement === left || placement === right) && variation === end) {
      sideY = bottom;
      var offsetY = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.height : // $FlowFixMe[prop-missing]
      offsetParent[heightProp];
      y -= offsetY - popperRect.height;
      y *= gpuAcceleration ? 1 : -1;
    }

    if (placement === left || (placement === top || placement === bottom) && variation === end) {
      sideX = right;
      var offsetX = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.width : // $FlowFixMe[prop-missing]
      offsetParent[widthProp];
      x -= offsetX - popperRect.width;
      x *= gpuAcceleration ? 1 : -1;
    }
  }

  var commonStyles = Object.assign({
    position: position
  }, adaptive && unsetSides);

  var _ref4 = roundOffsets === true ? roundOffsetsByDPR({
    x: x,
    y: y
  }, getWindow(popper)) : {
    x: x,
    y: y
  };

  x = _ref4.x;
  y = _ref4.y;

  if (gpuAcceleration) {
    var _Object$assign;

    return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? '0' : '', _Object$assign[sideX] = hasX ? '0' : '', _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
  }

  return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : '', _Object$assign2[sideX] = hasX ? x + "px" : '', _Object$assign2.transform = '', _Object$assign2));
}

function computeStyles(_ref5) {
  var state = _ref5.state,
      options = _ref5.options;
  var _options$gpuAccelerat = options.gpuAcceleration,
      gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat,
      _options$adaptive = options.adaptive,
      adaptive = _options$adaptive === void 0 ? true : _options$adaptive,
      _options$roundOffsets = options.roundOffsets,
      roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;
  var commonStyles = {
    placement: getBasePlacement(state.placement),
    variation: getVariation(state.placement),
    popper: state.elements.popper,
    popperRect: state.rects.popper,
    gpuAcceleration: gpuAcceleration,
    isFixed: state.options.strategy === 'fixed'
  };

  if (state.modifiersData.popperOffsets != null) {
    state.styles.popper = Object.assign({}, state.styles.popper, mapToStyles(Object.assign({}, commonStyles, {
      offsets: state.modifiersData.popperOffsets,
      position: state.options.strategy,
      adaptive: adaptive,
      roundOffsets: roundOffsets
    })));
  }

  if (state.modifiersData.arrow != null) {
    state.styles.arrow = Object.assign({}, state.styles.arrow, mapToStyles(Object.assign({}, commonStyles, {
      offsets: state.modifiersData.arrow,
      position: 'absolute',
      adaptive: false,
      roundOffsets: roundOffsets
    })));
  }

  state.attributes.popper = Object.assign({}, state.attributes.popper, {
    'data-popper-placement': state.placement
  });
} // eslint-disable-next-line import/no-unused-modules


var computeStyles$1 = {
  name: 'computeStyles',
  enabled: true,
  phase: 'beforeWrite',
  fn: computeStyles,
  data: {}
};

var passive = {
  passive: true
};

function effect(_ref) {
  var state = _ref.state,
      instance = _ref.instance,
      options = _ref.options;
  var _options$scroll = options.scroll,
      scroll = _options$scroll === void 0 ? true : _options$scroll,
      _options$resize = options.resize,
      resize = _options$resize === void 0 ? true : _options$resize;
  var window = getWindow(state.elements.popper);
  var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);

  if (scroll) {
    scrollParents.forEach(function (scrollParent) {
      scrollParent.addEventListener('scroll', instance.update, passive);
    });
  }

  if (resize) {
    window.addEventListener('resize', instance.update, passive);
  }

  return function () {
    if (scroll) {
      scrollParents.forEach(function (scrollParent) {
        scrollParent.removeEventListener('scroll', instance.update, passive);
      });
    }

    if (resize) {
      window.removeEventListener('resize', instance.update, passive);
    }
  };
} // eslint-disable-next-line import/no-unused-modules


var eventListeners = {
  name: 'eventListeners',
  enabled: true,
  phase: 'write',
  fn: function fn() {},
  effect: effect,
  data: {}
};

var hash$1 = {
  left: 'right',
  right: 'left',
  bottom: 'top',
  top: 'bottom'
};
function getOppositePlacement(placement) {
  return placement.replace(/left|right|bottom|top/g, function (matched) {
    return hash$1[matched];
  });
}

var hash = {
  start: 'end',
  end: 'start'
};
function getOppositeVariationPlacement(placement) {
  return placement.replace(/start|end/g, function (matched) {
    return hash[matched];
  });
}

function getWindowScroll(node) {
  var win = getWindow(node);
  var scrollLeft = win.pageXOffset;
  var scrollTop = win.pageYOffset;
  return {
    scrollLeft: scrollLeft,
    scrollTop: scrollTop
  };
}

function getWindowScrollBarX(element) {
  // If <html> has a CSS width greater than the viewport, then this will be
  // incorrect for RTL.
  // Popper 1 is broken in this case and never had a bug report so let's assume
  // it's not an issue. I don't think anyone ever specifies width on <html>
  // anyway.
  // Browsers where the left scrollbar doesn't cause an issue report `0` for
  // this (e.g. Edge 2019, IE11, Safari)
  return getBoundingClientRect(getDocumentElement(element)).left + getWindowScroll(element).scrollLeft;
}

function getViewportRect(element, strategy) {
  var win = getWindow(element);
  var html = getDocumentElement(element);
  var visualViewport = win.visualViewport;
  var width = html.clientWidth;
  var height = html.clientHeight;
  var x = 0;
  var y = 0;

  if (visualViewport) {
    width = visualViewport.width;
    height = visualViewport.height;
    var layoutViewport = isLayoutViewport();

    if (layoutViewport || !layoutViewport && strategy === 'fixed') {
      x = visualViewport.offsetLeft;
      y = visualViewport.offsetTop;
    }
  }

  return {
    width: width,
    height: height,
    x: x + getWindowScrollBarX(element),
    y: y
  };
}

// of the `<html>` and `<body>` rect bounds if horizontally scrollable

function getDocumentRect(element) {
  var _element$ownerDocumen;

  var html = getDocumentElement(element);
  var winScroll = getWindowScroll(element);
  var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
  var width = max(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
  var height = max(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
  var x = -winScroll.scrollLeft + getWindowScrollBarX(element);
  var y = -winScroll.scrollTop;

  if (getComputedStyle(body || html).direction === 'rtl') {
    x += max(html.clientWidth, body ? body.clientWidth : 0) - width;
  }

  return {
    width: width,
    height: height,
    x: x,
    y: y
  };
}

function isScrollParent(element) {
  // Firefox wants us to check `-x` and `-y` variations as well
  var _getComputedStyle = getComputedStyle(element),
      overflow = _getComputedStyle.overflow,
      overflowX = _getComputedStyle.overflowX,
      overflowY = _getComputedStyle.overflowY;

  return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}

function getScrollParent(node) {
  if (['html', 'body', '#document'].indexOf(getNodeName(node)) >= 0) {
    // $FlowFixMe[incompatible-return]: assume body is always available
    return node.ownerDocument.body;
  }

  if (isHTMLElement(node) && isScrollParent(node)) {
    return node;
  }

  return getScrollParent(getParentNode(node));
}

/*
given a DOM element, return the list of all scroll parents, up the list of ancesors
until we get to the top window object. This list is what we attach scroll listeners
to, because if any of these parent elements scroll, we'll need to re-calculate the
reference element's position.
*/

function listScrollParents(element, list) {
  var _element$ownerDocumen;

  if (list === void 0) {
    list = [];
  }

  var scrollParent = getScrollParent(element);
  var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
  var win = getWindow(scrollParent);
  var target = isBody ? [win].concat(win.visualViewport || [], isScrollParent(scrollParent) ? scrollParent : []) : scrollParent;
  var updatedList = list.concat(target);
  return isBody ? updatedList : // $FlowFixMe[incompatible-call]: isBody tells us target will be an HTMLElement here
  updatedList.concat(listScrollParents(getParentNode(target)));
}

function rectToClientRect(rect) {
  return Object.assign({}, rect, {
    left: rect.x,
    top: rect.y,
    right: rect.x + rect.width,
    bottom: rect.y + rect.height
  });
}

function getInnerBoundingClientRect(element, strategy) {
  var rect = getBoundingClientRect(element, false, strategy === 'fixed');
  rect.top = rect.top + element.clientTop;
  rect.left = rect.left + element.clientLeft;
  rect.bottom = rect.top + element.clientHeight;
  rect.right = rect.left + element.clientWidth;
  rect.width = element.clientWidth;
  rect.height = element.clientHeight;
  rect.x = rect.left;
  rect.y = rect.top;
  return rect;
}

function getClientRectFromMixedType(element, clippingParent, strategy) {
  return clippingParent === viewport ? rectToClientRect(getViewportRect(element, strategy)) : isElement(clippingParent) ? getInnerBoundingClientRect(clippingParent, strategy) : rectToClientRect(getDocumentRect(getDocumentElement(element)));
} // A "clipping parent" is an overflowable container with the characteristic of
// clipping (or hiding) overflowing elements with a position different from
// `initial`


function getClippingParents(element) {
  var clippingParents = listScrollParents(getParentNode(element));
  var canEscapeClipping = ['absolute', 'fixed'].indexOf(getComputedStyle(element).position) >= 0;
  var clipperElement = canEscapeClipping && isHTMLElement(element) ? getOffsetParent(element) : element;

  if (!isElement(clipperElement)) {
    return [];
  } // $FlowFixMe[incompatible-return]: https://github.com/facebook/flow/issues/1414


  return clippingParents.filter(function (clippingParent) {
    return isElement(clippingParent) && contains(clippingParent, clipperElement) && getNodeName(clippingParent) !== 'body';
  });
} // Gets the maximum area that the element is visible in due to any number of
// clipping parents


function getClippingRect(element, boundary, rootBoundary, strategy) {
  var mainClippingParents = boundary === 'clippingParents' ? getClippingParents(element) : [].concat(boundary);
  var clippingParents = [].concat(mainClippingParents, [rootBoundary]);
  var firstClippingParent = clippingParents[0];
  var clippingRect = clippingParents.reduce(function (accRect, clippingParent) {
    var rect = getClientRectFromMixedType(element, clippingParent, strategy);
    accRect.top = max(rect.top, accRect.top);
    accRect.right = min(rect.right, accRect.right);
    accRect.bottom = min(rect.bottom, accRect.bottom);
    accRect.left = max(rect.left, accRect.left);
    return accRect;
  }, getClientRectFromMixedType(element, firstClippingParent, strategy));
  clippingRect.width = clippingRect.right - clippingRect.left;
  clippingRect.height = clippingRect.bottom - clippingRect.top;
  clippingRect.x = clippingRect.left;
  clippingRect.y = clippingRect.top;
  return clippingRect;
}

function computeOffsets(_ref) {
  var reference = _ref.reference,
      element = _ref.element,
      placement = _ref.placement;
  var basePlacement = placement ? getBasePlacement(placement) : null;
  var variation = placement ? getVariation(placement) : null;
  var commonX = reference.x + reference.width / 2 - element.width / 2;
  var commonY = reference.y + reference.height / 2 - element.height / 2;
  var offsets;

  switch (basePlacement) {
    case top:
      offsets = {
        x: commonX,
        y: reference.y - element.height
      };
      break;

    case bottom:
      offsets = {
        x: commonX,
        y: reference.y + reference.height
      };
      break;

    case right:
      offsets = {
        x: reference.x + reference.width,
        y: commonY
      };
      break;

    case left:
      offsets = {
        x: reference.x - element.width,
        y: commonY
      };
      break;

    default:
      offsets = {
        x: reference.x,
        y: reference.y
      };
  }

  var mainAxis = basePlacement ? getMainAxisFromPlacement(basePlacement) : null;

  if (mainAxis != null) {
    var len = mainAxis === 'y' ? 'height' : 'width';

    switch (variation) {
      case start:
        offsets[mainAxis] = offsets[mainAxis] - (reference[len] / 2 - element[len] / 2);
        break;

      case end:
        offsets[mainAxis] = offsets[mainAxis] + (reference[len] / 2 - element[len] / 2);
        break;
    }
  }

  return offsets;
}

function detectOverflow(state, options) {
  if (options === void 0) {
    options = {};
  }

  var _options = options,
      _options$placement = _options.placement,
      placement = _options$placement === void 0 ? state.placement : _options$placement,
      _options$strategy = _options.strategy,
      strategy = _options$strategy === void 0 ? state.strategy : _options$strategy,
      _options$boundary = _options.boundary,
      boundary = _options$boundary === void 0 ? clippingParents : _options$boundary,
      _options$rootBoundary = _options.rootBoundary,
      rootBoundary = _options$rootBoundary === void 0 ? viewport : _options$rootBoundary,
      _options$elementConte = _options.elementContext,
      elementContext = _options$elementConte === void 0 ? popper : _options$elementConte,
      _options$altBoundary = _options.altBoundary,
      altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary,
      _options$padding = _options.padding,
      padding = _options$padding === void 0 ? 0 : _options$padding;
  var paddingObject = mergePaddingObject(typeof padding !== 'number' ? padding : expandToHashMap(padding, basePlacements));
  var altContext = elementContext === popper ? reference : popper;
  var popperRect = state.rects.popper;
  var element = state.elements[altBoundary ? altContext : elementContext];
  var clippingClientRect = getClippingRect(isElement(element) ? element : element.contextElement || getDocumentElement(state.elements.popper), boundary, rootBoundary, strategy);
  var referenceClientRect = getBoundingClientRect(state.elements.reference);
  var popperOffsets = computeOffsets({
    reference: referenceClientRect,
    element: popperRect,
    strategy: 'absolute',
    placement: placement
  });
  var popperClientRect = rectToClientRect(Object.assign({}, popperRect, popperOffsets));
  var elementClientRect = elementContext === popper ? popperClientRect : referenceClientRect; // positive = overflowing the clipping rect
  // 0 or negative = within the clipping rect

  var overflowOffsets = {
    top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
    bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
    left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
    right: elementClientRect.right - clippingClientRect.right + paddingObject.right
  };
  var offsetData = state.modifiersData.offset; // Offsets can be applied only to the popper element

  if (elementContext === popper && offsetData) {
    var offset = offsetData[placement];
    Object.keys(overflowOffsets).forEach(function (key) {
      var multiply = [right, bottom].indexOf(key) >= 0 ? 1 : -1;
      var axis = [top, bottom].indexOf(key) >= 0 ? 'y' : 'x';
      overflowOffsets[key] += offset[axis] * multiply;
    });
  }

  return overflowOffsets;
}

function computeAutoPlacement(state, options) {
  if (options === void 0) {
    options = {};
  }

  var _options = options,
      placement = _options.placement,
      boundary = _options.boundary,
      rootBoundary = _options.rootBoundary,
      padding = _options.padding,
      flipVariations = _options.flipVariations,
      _options$allowedAutoP = _options.allowedAutoPlacements,
      allowedAutoPlacements = _options$allowedAutoP === void 0 ? placements : _options$allowedAutoP;
  var variation = getVariation(placement);
  var placements$1 = variation ? flipVariations ? variationPlacements : variationPlacements.filter(function (placement) {
    return getVariation(placement) === variation;
  }) : basePlacements;
  var allowedPlacements = placements$1.filter(function (placement) {
    return allowedAutoPlacements.indexOf(placement) >= 0;
  });

  if (allowedPlacements.length === 0) {
    allowedPlacements = placements$1;
  } // $FlowFixMe[incompatible-type]: Flow seems to have problems with two array unions...


  var overflows = allowedPlacements.reduce(function (acc, placement) {
    acc[placement] = detectOverflow(state, {
      placement: placement,
      boundary: boundary,
      rootBoundary: rootBoundary,
      padding: padding
    })[getBasePlacement(placement)];
    return acc;
  }, {});
  return Object.keys(overflows).sort(function (a, b) {
    return overflows[a] - overflows[b];
  });
}

function getExpandedFallbackPlacements(placement) {
  if (getBasePlacement(placement) === auto) {
    return [];
  }

  var oppositePlacement = getOppositePlacement(placement);
  return [getOppositeVariationPlacement(placement), oppositePlacement, getOppositeVariationPlacement(oppositePlacement)];
}

function flip(_ref) {
  var state = _ref.state,
      options = _ref.options,
      name = _ref.name;

  if (state.modifiersData[name]._skip) {
    return;
  }

  var _options$mainAxis = options.mainAxis,
      checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis,
      _options$altAxis = options.altAxis,
      checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis,
      specifiedFallbackPlacements = options.fallbackPlacements,
      padding = options.padding,
      boundary = options.boundary,
      rootBoundary = options.rootBoundary,
      altBoundary = options.altBoundary,
      _options$flipVariatio = options.flipVariations,
      flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio,
      allowedAutoPlacements = options.allowedAutoPlacements;
  var preferredPlacement = state.options.placement;
  var basePlacement = getBasePlacement(preferredPlacement);
  var isBasePlacement = basePlacement === preferredPlacement;
  var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [getOppositePlacement(preferredPlacement)] : getExpandedFallbackPlacements(preferredPlacement));
  var placements = [preferredPlacement].concat(fallbackPlacements).reduce(function (acc, placement) {
    return acc.concat(getBasePlacement(placement) === auto ? computeAutoPlacement(state, {
      placement: placement,
      boundary: boundary,
      rootBoundary: rootBoundary,
      padding: padding,
      flipVariations: flipVariations,
      allowedAutoPlacements: allowedAutoPlacements
    }) : placement);
  }, []);
  var referenceRect = state.rects.reference;
  var popperRect = state.rects.popper;
  var checksMap = new Map();
  var makeFallbackChecks = true;
  var firstFittingPlacement = placements[0];

  for (var i = 0; i < placements.length; i++) {
    var placement = placements[i];

    var _basePlacement = getBasePlacement(placement);

    var isStartVariation = getVariation(placement) === start;
    var isVertical = [top, bottom].indexOf(_basePlacement) >= 0;
    var len = isVertical ? 'width' : 'height';
    var overflow = detectOverflow(state, {
      placement: placement,
      boundary: boundary,
      rootBoundary: rootBoundary,
      altBoundary: altBoundary,
      padding: padding
    });
    var mainVariationSide = isVertical ? isStartVariation ? right : left : isStartVariation ? bottom : top;

    if (referenceRect[len] > popperRect[len]) {
      mainVariationSide = getOppositePlacement(mainVariationSide);
    }

    var altVariationSide = getOppositePlacement(mainVariationSide);
    var checks = [];

    if (checkMainAxis) {
      checks.push(overflow[_basePlacement] <= 0);
    }

    if (checkAltAxis) {
      checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
    }

    if (checks.every(function (check) {
      return check;
    })) {
      firstFittingPlacement = placement;
      makeFallbackChecks = false;
      break;
    }

    checksMap.set(placement, checks);
  }

  if (makeFallbackChecks) {
    // `2` may be desired in some cases – research later
    var numberOfChecks = flipVariations ? 3 : 1;

    var _loop = function _loop(_i) {
      var fittingPlacement = placements.find(function (placement) {
        var checks = checksMap.get(placement);

        if (checks) {
          return checks.slice(0, _i).every(function (check) {
            return check;
          });
        }
      });

      if (fittingPlacement) {
        firstFittingPlacement = fittingPlacement;
        return "break";
      }
    };

    for (var _i = numberOfChecks; _i > 0; _i--) {
      var _ret = _loop(_i);

      if (_ret === "break") break;
    }
  }

  if (state.placement !== firstFittingPlacement) {
    state.modifiersData[name]._skip = true;
    state.placement = firstFittingPlacement;
    state.reset = true;
  }
} // eslint-disable-next-line import/no-unused-modules


var flip$1 = {
  name: 'flip',
  enabled: true,
  phase: 'main',
  fn: flip,
  requiresIfExists: ['offset'],
  data: {
    _skip: false
  }
};

function getSideOffsets(overflow, rect, preventedOffsets) {
  if (preventedOffsets === void 0) {
    preventedOffsets = {
      x: 0,
      y: 0
    };
  }

  return {
    top: overflow.top - rect.height - preventedOffsets.y,
    right: overflow.right - rect.width + preventedOffsets.x,
    bottom: overflow.bottom - rect.height + preventedOffsets.y,
    left: overflow.left - rect.width - preventedOffsets.x
  };
}

function isAnySideFullyClipped(overflow) {
  return [top, right, bottom, left].some(function (side) {
    return overflow[side] >= 0;
  });
}

function hide(_ref) {
  var state = _ref.state,
      name = _ref.name;
  var referenceRect = state.rects.reference;
  var popperRect = state.rects.popper;
  var preventedOffsets = state.modifiersData.preventOverflow;
  var referenceOverflow = detectOverflow(state, {
    elementContext: 'reference'
  });
  var popperAltOverflow = detectOverflow(state, {
    altBoundary: true
  });
  var referenceClippingOffsets = getSideOffsets(referenceOverflow, referenceRect);
  var popperEscapeOffsets = getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
  var isReferenceHidden = isAnySideFullyClipped(referenceClippingOffsets);
  var hasPopperEscaped = isAnySideFullyClipped(popperEscapeOffsets);
  state.modifiersData[name] = {
    referenceClippingOffsets: referenceClippingOffsets,
    popperEscapeOffsets: popperEscapeOffsets,
    isReferenceHidden: isReferenceHidden,
    hasPopperEscaped: hasPopperEscaped
  };
  state.attributes.popper = Object.assign({}, state.attributes.popper, {
    'data-popper-reference-hidden': isReferenceHidden,
    'data-popper-escaped': hasPopperEscaped
  });
} // eslint-disable-next-line import/no-unused-modules


var hide$1 = {
  name: 'hide',
  enabled: true,
  phase: 'main',
  requiresIfExists: ['preventOverflow'],
  fn: hide
};

function distanceAndSkiddingToXY(placement, rects, offset) {
  var basePlacement = getBasePlacement(placement);
  var invertDistance = [left, top].indexOf(basePlacement) >= 0 ? -1 : 1;

  var _ref = typeof offset === 'function' ? offset(Object.assign({}, rects, {
    placement: placement
  })) : offset,
      skidding = _ref[0],
      distance = _ref[1];

  skidding = skidding || 0;
  distance = (distance || 0) * invertDistance;
  return [left, right].indexOf(basePlacement) >= 0 ? {
    x: distance,
    y: skidding
  } : {
    x: skidding,
    y: distance
  };
}

function offset(_ref2) {
  var state = _ref2.state,
      options = _ref2.options,
      name = _ref2.name;
  var _options$offset = options.offset,
      offset = _options$offset === void 0 ? [0, 0] : _options$offset;
  var data = placements.reduce(function (acc, placement) {
    acc[placement] = distanceAndSkiddingToXY(placement, state.rects, offset);
    return acc;
  }, {});
  var _data$state$placement = data[state.placement],
      x = _data$state$placement.x,
      y = _data$state$placement.y;

  if (state.modifiersData.popperOffsets != null) {
    state.modifiersData.popperOffsets.x += x;
    state.modifiersData.popperOffsets.y += y;
  }

  state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules


var offset$1 = {
  name: 'offset',
  enabled: true,
  phase: 'main',
  requires: ['popperOffsets'],
  fn: offset
};

function popperOffsets(_ref) {
  var state = _ref.state,
      name = _ref.name;
  // Offsets are the actual position the popper needs to have to be
  // properly positioned near its reference element
  // This is the most basic placement, and will be adjusted by
  // the modifiers in the next step
  state.modifiersData[name] = computeOffsets({
    reference: state.rects.reference,
    element: state.rects.popper,
    strategy: 'absolute',
    placement: state.placement
  });
} // eslint-disable-next-line import/no-unused-modules


var popperOffsets$1 = {
  name: 'popperOffsets',
  enabled: true,
  phase: 'read',
  fn: popperOffsets,
  data: {}
};

function getAltAxis(axis) {
  return axis === 'x' ? 'y' : 'x';
}

function preventOverflow(_ref) {
  var state = _ref.state,
      options = _ref.options,
      name = _ref.name;
  var _options$mainAxis = options.mainAxis,
      checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis,
      _options$altAxis = options.altAxis,
      checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis,
      boundary = options.boundary,
      rootBoundary = options.rootBoundary,
      altBoundary = options.altBoundary,
      padding = options.padding,
      _options$tether = options.tether,
      tether = _options$tether === void 0 ? true : _options$tether,
      _options$tetherOffset = options.tetherOffset,
      tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
  var overflow = detectOverflow(state, {
    boundary: boundary,
    rootBoundary: rootBoundary,
    padding: padding,
    altBoundary: altBoundary
  });
  var basePlacement = getBasePlacement(state.placement);
  var variation = getVariation(state.placement);
  var isBasePlacement = !variation;
  var mainAxis = getMainAxisFromPlacement(basePlacement);
  var altAxis = getAltAxis(mainAxis);
  var popperOffsets = state.modifiersData.popperOffsets;
  var referenceRect = state.rects.reference;
  var popperRect = state.rects.popper;
  var tetherOffsetValue = typeof tetherOffset === 'function' ? tetherOffset(Object.assign({}, state.rects, {
    placement: state.placement
  })) : tetherOffset;
  var normalizedTetherOffsetValue = typeof tetherOffsetValue === 'number' ? {
    mainAxis: tetherOffsetValue,
    altAxis: tetherOffsetValue
  } : Object.assign({
    mainAxis: 0,
    altAxis: 0
  }, tetherOffsetValue);
  var offsetModifierState = state.modifiersData.offset ? state.modifiersData.offset[state.placement] : null;
  var data = {
    x: 0,
    y: 0
  };

  if (!popperOffsets) {
    return;
  }

  if (checkMainAxis) {
    var _offsetModifierState$;

    var mainSide = mainAxis === 'y' ? top : left;
    var altSide = mainAxis === 'y' ? bottom : right;
    var len = mainAxis === 'y' ? 'height' : 'width';
    var offset = popperOffsets[mainAxis];
    var min$1 = offset + overflow[mainSide];
    var max$1 = offset - overflow[altSide];
    var additive = tether ? -popperRect[len] / 2 : 0;
    var minLen = variation === start ? referenceRect[len] : popperRect[len];
    var maxLen = variation === start ? -popperRect[len] : -referenceRect[len]; // We need to include the arrow in the calculation so the arrow doesn't go
    // outside the reference bounds

    var arrowElement = state.elements.arrow;
    var arrowRect = tether && arrowElement ? getLayoutRect(arrowElement) : {
      width: 0,
      height: 0
    };
    var arrowPaddingObject = state.modifiersData['arrow#persistent'] ? state.modifiersData['arrow#persistent'].padding : getFreshSideObject();
    var arrowPaddingMin = arrowPaddingObject[mainSide];
    var arrowPaddingMax = arrowPaddingObject[altSide]; // If the reference length is smaller than the arrow length, we don't want
    // to include its full size in the calculation. If the reference is small
    // and near the edge of a boundary, the popper can overflow even if the
    // reference is not overflowing as well (e.g. virtual elements with no
    // width or height)

    var arrowLen = within(0, referenceRect[len], arrowRect[len]);
    var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis : minLen - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis;
    var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis : maxLen + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis;
    var arrowOffsetParent = state.elements.arrow && getOffsetParent(state.elements.arrow);
    var clientOffset = arrowOffsetParent ? mainAxis === 'y' ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
    var offsetModifierValue = (_offsetModifierState$ = offsetModifierState == null ? void 0 : offsetModifierState[mainAxis]) != null ? _offsetModifierState$ : 0;
    var tetherMin = offset + minOffset - offsetModifierValue - clientOffset;
    var tetherMax = offset + maxOffset - offsetModifierValue;
    var preventedOffset = within(tether ? min(min$1, tetherMin) : min$1, offset, tether ? max(max$1, tetherMax) : max$1);
    popperOffsets[mainAxis] = preventedOffset;
    data[mainAxis] = preventedOffset - offset;
  }

  if (checkAltAxis) {
    var _offsetModifierState$2;

    var _mainSide = mainAxis === 'x' ? top : left;

    var _altSide = mainAxis === 'x' ? bottom : right;

    var _offset = popperOffsets[altAxis];

    var _len = altAxis === 'y' ? 'height' : 'width';

    var _min = _offset + overflow[_mainSide];

    var _max = _offset - overflow[_altSide];

    var isOriginSide = [top, left].indexOf(basePlacement) !== -1;

    var _offsetModifierValue = (_offsetModifierState$2 = offsetModifierState == null ? void 0 : offsetModifierState[altAxis]) != null ? _offsetModifierState$2 : 0;

    var _tetherMin = isOriginSide ? _min : _offset - referenceRect[_len] - popperRect[_len] - _offsetModifierValue + normalizedTetherOffsetValue.altAxis;

    var _tetherMax = isOriginSide ? _offset + referenceRect[_len] + popperRect[_len] - _offsetModifierValue - normalizedTetherOffsetValue.altAxis : _max;

    var _preventedOffset = tether && isOriginSide ? withinMaxClamp(_tetherMin, _offset, _tetherMax) : within(tether ? _tetherMin : _min, _offset, tether ? _tetherMax : _max);

    popperOffsets[altAxis] = _preventedOffset;
    data[altAxis] = _preventedOffset - _offset;
  }

  state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules


var preventOverflow$1 = {
  name: 'preventOverflow',
  enabled: true,
  phase: 'main',
  fn: preventOverflow,
  requiresIfExists: ['offset']
};

function getHTMLElementScroll(element) {
  return {
    scrollLeft: element.scrollLeft,
    scrollTop: element.scrollTop
  };
}

function getNodeScroll(node) {
  if (node === getWindow(node) || !isHTMLElement(node)) {
    return getWindowScroll(node);
  } else {
    return getHTMLElementScroll(node);
  }
}

function isElementScaled(element) {
  var rect = element.getBoundingClientRect();
  var scaleX = round(rect.width) / element.offsetWidth || 1;
  var scaleY = round(rect.height) / element.offsetHeight || 1;
  return scaleX !== 1 || scaleY !== 1;
} // Returns the composite rect of an element relative to its offsetParent.
// Composite means it takes into account transforms as well as layout.


function getCompositeRect(elementOrVirtualElement, offsetParent, isFixed) {
  if (isFixed === void 0) {
    isFixed = false;
  }

  var isOffsetParentAnElement = isHTMLElement(offsetParent);
  var offsetParentIsScaled = isHTMLElement(offsetParent) && isElementScaled(offsetParent);
  var documentElement = getDocumentElement(offsetParent);
  var rect = getBoundingClientRect(elementOrVirtualElement, offsetParentIsScaled, isFixed);
  var scroll = {
    scrollLeft: 0,
    scrollTop: 0
  };
  var offsets = {
    x: 0,
    y: 0
  };

  if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
    if (getNodeName(offsetParent) !== 'body' || // https://github.com/popperjs/popper-core/issues/1078
    isScrollParent(documentElement)) {
      scroll = getNodeScroll(offsetParent);
    }

    if (isHTMLElement(offsetParent)) {
      offsets = getBoundingClientRect(offsetParent, true);
      offsets.x += offsetParent.clientLeft;
      offsets.y += offsetParent.clientTop;
    } else if (documentElement) {
      offsets.x = getWindowScrollBarX(documentElement);
    }
  }

  return {
    x: rect.left + scroll.scrollLeft - offsets.x,
    y: rect.top + scroll.scrollTop - offsets.y,
    width: rect.width,
    height: rect.height
  };
}

function order(modifiers) {
  var map = new Map();
  var visited = new Set();
  var result = [];
  modifiers.forEach(function (modifier) {
    map.set(modifier.name, modifier);
  }); // On visiting object, check for its dependencies and visit them recursively

  function sort(modifier) {
    visited.add(modifier.name);
    var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
    requires.forEach(function (dep) {
      if (!visited.has(dep)) {
        var depModifier = map.get(dep);

        if (depModifier) {
          sort(depModifier);
        }
      }
    });
    result.push(modifier);
  }

  modifiers.forEach(function (modifier) {
    if (!visited.has(modifier.name)) {
      // check for visited object
      sort(modifier);
    }
  });
  return result;
}

function orderModifiers(modifiers) {
  // order based on dependencies
  var orderedModifiers = order(modifiers); // order based on phase

  return modifierPhases.reduce(function (acc, phase) {
    return acc.concat(orderedModifiers.filter(function (modifier) {
      return modifier.phase === phase;
    }));
  }, []);
}

function debounce(fn) {
  var pending;
  return function () {
    if (!pending) {
      pending = new Promise(function (resolve) {
        Promise.resolve().then(function () {
          pending = undefined;
          resolve(fn());
        });
      });
    }

    return pending;
  };
}

function mergeByName(modifiers) {
  var merged = modifiers.reduce(function (merged, current) {
    var existing = merged[current.name];
    merged[current.name] = existing ? Object.assign({}, existing, current, {
      options: Object.assign({}, existing.options, current.options),
      data: Object.assign({}, existing.data, current.data)
    }) : current;
    return merged;
  }, {}); // IE11 does not support Object.values

  return Object.keys(merged).map(function (key) {
    return merged[key];
  });
}

var DEFAULT_OPTIONS = {
  placement: 'bottom',
  modifiers: [],
  strategy: 'absolute'
};

function areValidElements() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  return !args.some(function (element) {
    return !(element && typeof element.getBoundingClientRect === 'function');
  });
}

function popperGenerator(generatorOptions) {
  if (generatorOptions === void 0) {
    generatorOptions = {};
  }

  var _generatorOptions = generatorOptions,
      _generatorOptions$def = _generatorOptions.defaultModifiers,
      defaultModifiers = _generatorOptions$def === void 0 ? [] : _generatorOptions$def,
      _generatorOptions$def2 = _generatorOptions.defaultOptions,
      defaultOptions = _generatorOptions$def2 === void 0 ? DEFAULT_OPTIONS : _generatorOptions$def2;
  return function createPopper(reference, popper, options) {
    if (options === void 0) {
      options = defaultOptions;
    }

    var state = {
      placement: 'bottom',
      orderedModifiers: [],
      options: Object.assign({}, DEFAULT_OPTIONS, defaultOptions),
      modifiersData: {},
      elements: {
        reference: reference,
        popper: popper
      },
      attributes: {},
      styles: {}
    };
    var effectCleanupFns = [];
    var isDestroyed = false;
    var instance = {
      state: state,
      setOptions: function setOptions(setOptionsAction) {
        var options = typeof setOptionsAction === 'function' ? setOptionsAction(state.options) : setOptionsAction;
        cleanupModifierEffects();
        state.options = Object.assign({}, defaultOptions, state.options, options);
        state.scrollParents = {
          reference: isElement(reference) ? listScrollParents(reference) : reference.contextElement ? listScrollParents(reference.contextElement) : [],
          popper: listScrollParents(popper)
        }; // Orders the modifiers based on their dependencies and `phase`
        // properties

        var orderedModifiers = orderModifiers(mergeByName([].concat(defaultModifiers, state.options.modifiers))); // Strip out disabled modifiers

        state.orderedModifiers = orderedModifiers.filter(function (m) {
          return m.enabled;
        });
        runModifierEffects();
        return instance.update();
      },
      // Sync update – it will always be executed, even if not necessary. This
      // is useful for low frequency updates where sync behavior simplifies the
      // logic.
      // For high frequency updates (e.g. `resize` and `scroll` events), always
      // prefer the async Popper#update method
      forceUpdate: function forceUpdate() {
        if (isDestroyed) {
          return;
        }

        var _state$elements = state.elements,
            reference = _state$elements.reference,
            popper = _state$elements.popper; // Don't proceed if `reference` or `popper` are not valid elements
        // anymore

        if (!areValidElements(reference, popper)) {
          return;
        } // Store the reference and popper rects to be read by modifiers


        state.rects = {
          reference: getCompositeRect(reference, getOffsetParent(popper), state.options.strategy === 'fixed'),
          popper: getLayoutRect(popper)
        }; // Modifiers have the ability to reset the current update cycle. The
        // most common use case for this is the `flip` modifier changing the
        // placement, which then needs to re-run all the modifiers, because the
        // logic was previously ran for the previous placement and is therefore
        // stale/incorrect

        state.reset = false;
        state.placement = state.options.placement; // On each update cycle, the `modifiersData` property for each modifier
        // is filled with the initial data specified by the modifier. This means
        // it doesn't persist and is fresh on each update.
        // To ensure persistent data, use `${name}#persistent`

        state.orderedModifiers.forEach(function (modifier) {
          return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
        });

        for (var index = 0; index < state.orderedModifiers.length; index++) {
          if (state.reset === true) {
            state.reset = false;
            index = -1;
            continue;
          }

          var _state$orderedModifie = state.orderedModifiers[index],
              fn = _state$orderedModifie.fn,
              _state$orderedModifie2 = _state$orderedModifie.options,
              _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2,
              name = _state$orderedModifie.name;

          if (typeof fn === 'function') {
            state = fn({
              state: state,
              options: _options,
              name: name,
              instance: instance
            }) || state;
          }
        }
      },
      // Async and optimistically optimized update – it will not be executed if
      // not necessary (debounced to run at most once-per-tick)
      update: debounce(function () {
        return new Promise(function (resolve) {
          instance.forceUpdate();
          resolve(state);
        });
      }),
      destroy: function destroy() {
        cleanupModifierEffects();
        isDestroyed = true;
      }
    };

    if (!areValidElements(reference, popper)) {
      return instance;
    }

    instance.setOptions(options).then(function (state) {
      if (!isDestroyed && options.onFirstUpdate) {
        options.onFirstUpdate(state);
      }
    }); // Modifiers have the ability to execute arbitrary code before the first
    // update cycle runs. They will be executed in the same order as the update
    // cycle. This is useful when a modifier adds some persistent data that
    // other modifiers need to use, but the modifier is run after the dependent
    // one.

    function runModifierEffects() {
      state.orderedModifiers.forEach(function (_ref) {
        var name = _ref.name,
            _ref$options = _ref.options,
            options = _ref$options === void 0 ? {} : _ref$options,
            effect = _ref.effect;

        if (typeof effect === 'function') {
          var cleanupFn = effect({
            state: state,
            name: name,
            instance: instance,
            options: options
          });

          var noopFn = function noopFn() {};

          effectCleanupFns.push(cleanupFn || noopFn);
        }
      });
    }

    function cleanupModifierEffects() {
      effectCleanupFns.forEach(function (fn) {
        return fn();
      });
      effectCleanupFns = [];
    }

    return instance;
  };
}

var defaultModifiers = [eventListeners, popperOffsets$1, computeStyles$1, applyStyles$1, offset$1, flip$1, preventOverflow$1, arrow$1, hide$1];
var createPopper = /*#__PURE__*/popperGenerator({
  defaultModifiers: defaultModifiers
}); // eslint-disable-next-line import/no-unused-modules

/* global Map:readonly, Set:readonly, ArrayBuffer:readonly */

var hasElementType = typeof Element !== 'undefined';
var hasMap = typeof Map === 'function';
var hasSet = typeof Set === 'function';
var hasArrayBuffer = typeof ArrayBuffer === 'function' && !!ArrayBuffer.isView;

// Note: We **don't** need `envHasBigInt64Array` in fde es6/index.js

function equal(a, b) {
  // START: fast-deep-equal es6/index.js 3.1.3
  if (a === b) return true;

  if (a && b && typeof a == 'object' && typeof b == 'object') {
    if (a.constructor !== b.constructor) return false;

    var length, i, keys;
    if (Array.isArray(a)) {
      length = a.length;
      if (length != b.length) return false;
      for (i = length; i-- !== 0;)
        if (!equal(a[i], b[i])) return false;
      return true;
    }

    // START: Modifications:
    // 1. Extra `has<Type> &&` helpers in initial condition allow es6 code
    //    to co-exist with es5.
    // 2. Replace `for of` with es5 compliant iteration using `for`.
    //    Basically, take:
    //
    //    ```js
    //    for (i of a.entries())
    //      if (!b.has(i[0])) return false;
    //    ```
    //
    //    ... and convert to:
    //
    //    ```js
    //    it = a.entries();
    //    while (!(i = it.next()).done)
    //      if (!b.has(i.value[0])) return false;
    //    ```
    //
    //    **Note**: `i` access switches to `i.value`.
    var it;
    if (hasMap && (a instanceof Map) && (b instanceof Map)) {
      if (a.size !== b.size) return false;
      it = a.entries();
      while (!(i = it.next()).done)
        if (!b.has(i.value[0])) return false;
      it = a.entries();
      while (!(i = it.next()).done)
        if (!equal(i.value[1], b.get(i.value[0]))) return false;
      return true;
    }

    if (hasSet && (a instanceof Set) && (b instanceof Set)) {
      if (a.size !== b.size) return false;
      it = a.entries();
      while (!(i = it.next()).done)
        if (!b.has(i.value[0])) return false;
      return true;
    }
    // END: Modifications

    if (hasArrayBuffer && ArrayBuffer.isView(a) && ArrayBuffer.isView(b)) {
      length = a.length;
      if (length != b.length) return false;
      for (i = length; i-- !== 0;)
        if (a[i] !== b[i]) return false;
      return true;
    }

    if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
    // START: Modifications:
    // Apply guards for `Object.create(null)` handling. See:
    // - https://github.com/FormidableLabs/react-fast-compare/issues/64
    // - https://github.com/epoberezkin/fast-deep-equal/issues/49
    if (a.valueOf !== Object.prototype.valueOf && typeof a.valueOf === 'function' && typeof b.valueOf === 'function') return a.valueOf() === b.valueOf();
    if (a.toString !== Object.prototype.toString && typeof a.toString === 'function' && typeof b.toString === 'function') return a.toString() === b.toString();
    // END: Modifications

    keys = Object.keys(a);
    length = keys.length;
    if (length !== Object.keys(b).length) return false;

    for (i = length; i-- !== 0;)
      if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;
    // END: fast-deep-equal

    // START: react-fast-compare
    // custom handling for DOM elements
    if (hasElementType && a instanceof Element) return false;

    // custom handling for React/Preact
    for (i = length; i-- !== 0;) {
      if ((keys[i] === '_owner' || keys[i] === '__v' || keys[i] === '__o') && a.$$typeof) {
        // React-specific: avoid traversing React elements' _owner
        // Preact-specific: avoid traversing Preact elements' __v and __o
        //    __v = $_original / $_vnode
        //    __o = $_owner
        // These properties contain circular references and are not needed when
        // comparing the actual elements (and not their owners)
        // .$$typeof and ._store on just reasonable markers of elements

        continue;
      }

      // all other properties should be traversed as usual
      if (!equal(a[keys[i]], b[keys[i]])) return false;
    }
    // END: react-fast-compare

    // START: fast-deep-equal
    return true;
  }

  return a !== a && b !== b;
}
// end fast-deep-equal

var reactFastCompare = function isEqual(a, b) {
  try {
    return equal(a, b);
  } catch (error) {
    if (((error.message || '').match(/stack|recursion/i))) {
      // warn on circular references, don't crash
      // browsers give this different errors name and messages:
      // chrome/safari: "RangeError", "Maximum call stack size exceeded"
      // firefox: "InternalError", too much recursion"
      // edge: "Error", "Out of stack space"
      console.warn('react-fast-compare cannot handle circular refs');
      return false;
    }
    // some other error. we should definitely know about these
    throw error;
  }
};

var isEqual = /*@__PURE__*/getDefaultExportFromCjs(reactFastCompare);

var EMPTY_MODIFIERS$1 = [];
var usePopper = function usePopper(referenceElement, popperElement, options) {
  if (options === void 0) {
    options = {};
  }

  var prevOptions = e.useRef(null);
  var optionsWithDefaults = {
    onFirstUpdate: options.onFirstUpdate,
    placement: options.placement || 'bottom',
    strategy: options.strategy || 'absolute',
    modifiers: options.modifiers || EMPTY_MODIFIERS$1
  };

  var _React$useState = e.useState({
    styles: {
      popper: {
        position: optionsWithDefaults.strategy,
        left: '0',
        top: '0'
      },
      arrow: {
        position: 'absolute'
      }
    },
    attributes: {}
  }),
      state = _React$useState[0],
      setState = _React$useState[1];

  var updateStateModifier = e.useMemo(function () {
    return {
      name: 'updateState',
      enabled: true,
      phase: 'write',
      fn: function fn(_ref) {
        var state = _ref.state;
        var elements = Object.keys(state.elements);
        ReactDOM.flushSync(function () {
          setState({
            styles: fromEntries(elements.map(function (element) {
              return [element, state.styles[element] || {}];
            })),
            attributes: fromEntries(elements.map(function (element) {
              return [element, state.attributes[element]];
            }))
          });
        });
      },
      requires: ['computeStyles']
    };
  }, []);
  var popperOptions = e.useMemo(function () {
    var newOptions = {
      onFirstUpdate: optionsWithDefaults.onFirstUpdate,
      placement: optionsWithDefaults.placement,
      strategy: optionsWithDefaults.strategy,
      modifiers: [].concat(optionsWithDefaults.modifiers, [updateStateModifier, {
        name: 'applyStyles',
        enabled: false
      }])
    };

    if (isEqual(prevOptions.current, newOptions)) {
      return prevOptions.current || newOptions;
    } else {
      prevOptions.current = newOptions;
      return newOptions;
    }
  }, [optionsWithDefaults.onFirstUpdate, optionsWithDefaults.placement, optionsWithDefaults.strategy, optionsWithDefaults.modifiers, updateStateModifier]);
  var popperInstanceRef = e.useRef();
  useIsomorphicLayoutEffect(function () {
    if (popperInstanceRef.current) {
      popperInstanceRef.current.setOptions(popperOptions);
    }
  }, [popperOptions]);
  useIsomorphicLayoutEffect(function () {
    if (referenceElement == null || popperElement == null) {
      return;
    }

    var createPopper$1 = options.createPopper || createPopper;
    var popperInstance = createPopper$1(referenceElement, popperElement, popperOptions);
    popperInstanceRef.current = popperInstance;
    return function () {
      popperInstance.destroy();
      popperInstanceRef.current = null;
    };
  }, [referenceElement, popperElement, options.createPopper]);
  return {
    state: popperInstanceRef.current ? popperInstanceRef.current.state : null,
    styles: state.styles,
    attributes: state.attributes,
    update: popperInstanceRef.current ? popperInstanceRef.current.update : null,
    forceUpdate: popperInstanceRef.current ? popperInstanceRef.current.forceUpdate : null
  };
};

var NOOP = function NOOP() {
  return void 0;
};

var NOOP_PROMISE = function NOOP_PROMISE() {
  return Promise.resolve(null);
};

var EMPTY_MODIFIERS = [];
function Popper(_ref) {
  var _ref$placement = _ref.placement,
      placement = _ref$placement === void 0 ? 'bottom' : _ref$placement,
      _ref$strategy = _ref.strategy,
      strategy = _ref$strategy === void 0 ? 'absolute' : _ref$strategy,
      _ref$modifiers = _ref.modifiers,
      modifiers = _ref$modifiers === void 0 ? EMPTY_MODIFIERS : _ref$modifiers,
      referenceElement = _ref.referenceElement,
      onFirstUpdate = _ref.onFirstUpdate,
      innerRef = _ref.innerRef,
      children = _ref.children;
  var referenceNode = e.useContext(ManagerReferenceNodeContext);

  var _React$useState = e.useState(null),
      popperElement = _React$useState[0],
      setPopperElement = _React$useState[1];

  var _React$useState2 = e.useState(null),
      arrowElement = _React$useState2[0],
      setArrowElement = _React$useState2[1];

  e.useEffect(function () {
    setRef(innerRef, popperElement);
  }, [innerRef, popperElement]);
  var options = e.useMemo(function () {
    return {
      placement: placement,
      strategy: strategy,
      onFirstUpdate: onFirstUpdate,
      modifiers: [].concat(modifiers, [{
        name: 'arrow',
        enabled: arrowElement != null,
        options: {
          element: arrowElement
        }
      }])
    };
  }, [placement, strategy, onFirstUpdate, modifiers, arrowElement]);

  var _usePopper = usePopper(referenceElement || referenceNode, popperElement, options),
      state = _usePopper.state,
      styles = _usePopper.styles,
      forceUpdate = _usePopper.forceUpdate,
      update = _usePopper.update;

  var childrenProps = e.useMemo(function () {
    return {
      ref: setPopperElement,
      style: styles.popper,
      placement: state ? state.placement : placement,
      hasPopperEscaped: state && state.modifiersData.hide ? state.modifiersData.hide.hasPopperEscaped : null,
      isReferenceHidden: state && state.modifiersData.hide ? state.modifiersData.hide.isReferenceHidden : null,
      arrowProps: {
        style: styles.arrow,
        ref: setArrowElement
      },
      forceUpdate: forceUpdate || NOOP,
      update: update || NOOP_PROMISE
    };
  }, [setPopperElement, setArrowElement, placement, state, styles, update, forceUpdate]);
  return unwrapArray(children)(childrenProps);
}

/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var __DEV__ = process.env.NODE_ENV !== 'production';

var warning = function() {};

if (__DEV__) {
  var printWarning = function printWarning(format, args) {
    var len = arguments.length;
    args = new Array(len > 1 ? len - 1 : 0);
    for (var key = 1; key < len; key++) {
      args[key - 1] = arguments[key];
    }
    var argIndex = 0;
    var message = 'Warning: ' +
      format.replace(/%s/g, function() {
        return args[argIndex++];
      });
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };

  warning = function(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    if (format === undefined) {
      throw new Error(
          '`warning(condition, format, ...args)` requires a warning ' +
          'message argument'
      );
    }
    if (!condition) {
      printWarning.apply(null, [format].concat(args));
    }
  };
}

var warning_1 = warning;

var warning$1 = /*@__PURE__*/getDefaultExportFromCjs(warning_1);

function Reference(_ref) {
  var children = _ref.children,
      innerRef = _ref.innerRef;
  var setReferenceNode = e.useContext(ManagerReferenceNodeSetterContext);
  var refHandler = e.useCallback(function (node) {
    setRef(innerRef, node);
    safeInvoke(setReferenceNode, node);
  }, [innerRef, setReferenceNode]); // ran on unmount
  // eslint-disable-next-line react-hooks/exhaustive-deps

  e.useEffect(function () {
    return function () {
      return setRef(innerRef, null);
    };
  }, []);
  e.useEffect(function () {
    warning$1(Boolean(setReferenceNode), '`Reference` should not be used outside of a `Manager` component.');
  }, [setReferenceNode]);
  return unwrapArray(children)({
    ref: refHandler
  });
}

function le(e,t){var r=Object.keys(e);if(Object.getOwnPropertySymbols){var n=Object.getOwnPropertySymbols(e);t&&(n=n.filter((function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable}))),r.push.apply(r,n);}return r}function de(e){for(var t=1;t<arguments.length;t++){var r=null!=arguments[t]?arguments[t]:{};t%2?le(Object(r),!0).forEach((function(t){ye(e,t,r[t]);})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(r)):le(Object(r)).forEach((function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(r,t));}));}return e}function ue(e){return ue="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e},ue(e)}function he(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function me(e,t){for(var r=0;r<t.length;r++){var n=t[r];n.enumerable=n.enumerable||!1,n.configurable=!0,"value"in n&&(n.writable=!0),Object.defineProperty(e,_e(n.key),n);}}function fe(e,t,r){return t&&me(e.prototype,t),r&&me(e,r),Object.defineProperty(e,"prototype",{writable:!1}),e}function ye(e,t,r){return (t=_e(t))in e?Object.defineProperty(e,t,{value:r,enumerable:!0,configurable:!0,writable:!0}):e[t]=r,e}function ve(){return ve=Object.assign?Object.assign.bind():function(e){for(var t=1;t<arguments.length;t++){var r=arguments[t];for(var n in r)Object.prototype.hasOwnProperty.call(r,n)&&(e[n]=r[n]);}return e},ve.apply(this,arguments)}function De(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function");e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,writable:!0,configurable:!0}}),Object.defineProperty(e,"prototype",{writable:!1}),t&&ke(e,t);}function ge(e){return ge=Object.setPrototypeOf?Object.getPrototypeOf.bind():function(e){return e.__proto__||Object.getPrototypeOf(e)},ge(e)}function ke(e,t){return ke=Object.setPrototypeOf?Object.setPrototypeOf.bind():function(e,t){return e.__proto__=t,e},ke(e,t)}function we(e){if(void 0===e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return e}function be(e){var t=function(){if("undefined"==typeof Reflect||!Reflect.construct)return !1;if(Reflect.construct.sham)return !1;if("function"==typeof Proxy)return !0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){}))),!0}catch(e){return !1}}();return function(){var r,n=ge(e);if(t){var o=ge(this).constructor;r=Reflect.construct(n,arguments,o);}else r=n.apply(this,arguments);return function(e,t){if(t&&("object"==typeof t||"function"==typeof t))return t;if(void 0!==t)throw new TypeError("Derived constructors may only return object or undefined");return we(e)}(this,r)}}function Se(e){return function(e){if(Array.isArray(e))return Ce(e)}(e)||function(e){if("undefined"!=typeof Symbol&&null!=e[Symbol.iterator]||null!=e["@@iterator"])return Array.from(e)}(e)||function(e,t){if(!e)return;if("string"==typeof e)return Ce(e,t);var r=Object.prototype.toString.call(e).slice(8,-1);"Object"===r&&e.constructor&&(r=e.constructor.name);if("Map"===r||"Set"===r)return Array.from(e);if("Arguments"===r||/^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r))return Ce(e,t)}(e)||function(){throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")}()}function Ce(e,t){(null==t||t>e.length)&&(t=e.length);for(var r=0,n=new Array(t);r<t;r++)n[r]=e[r];return n}function _e(e){var t=function(e,t){if("object"!=typeof e||null===e)return e;var r=e[Symbol.toPrimitive];if(void 0!==r){var n=r.call(e,t||"default");if("object"!=typeof n)return n;throw new TypeError("@@toPrimitive must return a primitive value.")}return ("string"===t?String:Number)(e)}(e,"string");return "symbol"==typeof t?t:String(t)}var Me=function(e,t){switch(e){case"P":return t.date({width:"short"});case"PP":return t.date({width:"medium"});case"PPP":return t.date({width:"long"});default:return t.date({width:"full"})}},Pe=function(e,t){switch(e){case"p":return t.time({width:"short"});case"pp":return t.time({width:"medium"});case"ppp":return t.time({width:"long"});default:return t.time({width:"full"})}},Ee={p:Pe,P:function(e,t){var r,n=e.match(/(P+)(p+)?/)||[],o=n[1],a=n[2];if(!a)return Me(e,t);switch(o){case"P":r=t.dateTime({width:"short"});break;case"PP":r=t.dateTime({width:"medium"});break;case"PPP":r=t.dateTime({width:"long"});break;default:r=t.dateTime({width:"full"});}return r.replace("{{date}}",Me(o,t)).replace("{{time}}",Pe(a,t))}},Ne=12,xe=/P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;function Ye(e){var t=e?"string"==typeof e||e instanceof String?ne(e):te(e):new Date;return Te(t)?t:null}function Te(e,t){return t=t||new Date("1/1/1000"),o(e)&&!Z(e,t)}function Ie(e,t,r){if("en"===r)return a(e,t,{awareOfUnicodeTokens:!0});var n=Ge(r);return r&&!n&&console.warn('A locale object was not found for the provided string ["'.concat(r,'"].')),!n&&$e()&&Ge($e())&&(n=Ge($e())),a(e,t,{locale:n||null,awareOfUnicodeTokens:!0})}function Oe(e,t){var r=t.dateFormat,n=t.locale;return e&&Ie(e,Array.isArray(r)?r[0]:r,n)||""}function Re(e,t){var r=t.hour,n=void 0===r?0:r,o=t.minute,a=void 0===o?0:o,s=t.second;return x(N(E(e,void 0===s?0:s),a),n)}function Le(e,t,r){var n=Ge(t||$e());return K(e,{locale:n,weekStartsOn:r})}function Fe(e){return B(e)}function Ae(e){return H(e)}function We(e){return Q(e)}function Ke(){return W(Ye())}function Be(e,t){return e&&t?G(e,t):!e&&!t}function Qe(e,t){return e&&t?$(e,t):!e&&!t}function He(e,t){return e&&t?J(e,t):!e&&!t}function je(e,t){return e&&t?z(e,t):!e&&!t}function Ve(e,t){return e&&t?U(e,t):!e&&!t}function qe(e,t,r){var n,o=W(t),a=j(r);try{n=ee(e,{start:o,end:a});}catch(e){n=!1;}return n}function Ue(e,t){var r="undefined"!=typeof window?window:globalThis;r.__localeData__||(r.__localeData__={}),r.__localeData__[e]=t;}function $e(){return ("undefined"!=typeof window?window:globalThis).__localeId__}function Ge(e){if("string"==typeof e){var t="undefined"!=typeof window?window:globalThis;return t.__localeData__?t.__localeData__[e]:null}return e}function Je(e,t){return Ie(Y(Ye(),e),"LLLL",t)}function Xe(e,t){return Ie(Y(Ye(),e),"LLL",t)}function Ze(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},r=t.minDate,n=t.maxDate,o=t.excludeDates,a=t.excludeDateIntervals,s=t.includeDates,i=t.includeDateIntervals,p=t.filterDate;return it(e,{minDate:r,maxDate:n})||o&&o.some((function(t){return je(e,t)}))||a&&a.some((function(t){var r=t.start,n=t.end;return ee(e,{start:r,end:n})}))||s&&!s.some((function(t){return je(e,t)}))||i&&!i.some((function(t){var r=t.start,n=t.end;return ee(e,{start:r,end:n})}))||p&&!p(Ye(e))||!1}function et(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},r=t.excludeDates,n=t.excludeDateIntervals;return n&&n.length>0?n.some((function(t){var r=t.start,n=t.end;return ee(e,{start:r,end:n})})):r&&r.some((function(t){return je(e,t)}))||!1}function tt(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},r=t.minDate,n=t.maxDate,o=t.excludeDates,a=t.includeDates,s=t.filterDate;return it(e,{minDate:B(r),maxDate:V(n)})||o&&o.some((function(t){return Qe(e,t)}))||a&&!a.some((function(t){return Qe(e,t)}))||s&&!s(Ye(e))||!1}function rt(e,t,r,n){var o=M(e),a=C(e),s=M(t),i=C(t),p=M(n);return o===s&&o===p?a<=r&&r<=i:o<s?p===o&&a<=r||p===s&&i>=r||p<s&&p>o:void 0}function nt(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},r=t.minDate,n=t.maxDate,o=t.excludeDates,a=t.includeDates,s=t.filterDate;return it(e,{minDate:r,maxDate:n})||o&&o.some((function(t){return He(e,t)}))||a&&!a.some((function(t){return He(e,t)}))||s&&!s(Ye(e))||!1}function ot(e,t,r){if(!o(t)||!o(r))return !1;var n=M(t),a=M(r);return n<=e&&a>=e}function at(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},r=t.minDate,n=t.maxDate,o=t.excludeDates,a=t.includeDates,s=t.filterDate,i=new Date(e,0,1);return it(i,{minDate:H(r),maxDate:q(n)})||o&&o.some((function(e){return Be(i,e)}))||a&&!a.some((function(e){return Be(i,e)}))||s&&!s(Ye(i))||!1}function st(e,t,r,n){var o=M(e),a=_(e),s=M(t),i=_(t),p=M(n);return o===s&&o===p?a<=r&&r<=i:o<s?p===o&&a<=r||p===s&&i>=r||p<s&&p>o:void 0}function it(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},r=t.minDate,n=t.maxDate;return r&&L(e,r)<0||n&&L(e,n)>0}function pt(e,t){return t.some((function(t){return k(t)===k(e)&&g(t)===g(e)}))}function ct(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},r=t.excludeTimes,n=t.includeTimes,o=t.filterTime;return r&&pt(e,r)||n&&!pt(e,n)||o&&!o(e)||!1}function lt(e,t){var r=t.minTime,n=t.maxTime;if(!r||!n)throw new Error("Both minTime and maxTime props required");var o,a=Ye(),s=x(N(a,g(e)),k(e)),i=x(N(a,g(r)),k(r)),p=x(N(a,g(n)),k(n));try{o=!ee(s,{start:i,end:p});}catch(e){o=!1;}return o}function dt(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},r=t.minDate,n=t.includeDates,o=f(e,1);return r&&F(r,o)>0||n&&n.every((function(e){return F(e,o)>0}))||!1}function ut(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},r=t.maxDate,n=t.includeDates,o=l(e,1);return r&&F(o,r)>0||n&&n.every((function(e){return F(o,e)>0}))||!1}function ht(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},r=t.minDate,n=t.includeDates,o=v(e,1);return r&&A(r,o)>0||n&&n.every((function(e){return A(e,o)>0}))||!1}function mt(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},r=t.maxDate,n=t.includeDates,o=u(e,1);return r&&A(o,r)>0||n&&n.every((function(e){return A(o,e)>0}))||!1}function ft(e){var t=e.minDate,r=e.includeDates;if(r&&t){var n=r.filter((function(e){return L(e,t)>=0}));return O(n)}return r?O(r):t}function yt(e){var t=e.maxDate,r=e.includeDates;if(r&&t){var n=r.filter((function(e){return L(e,t)<=0}));return R(n)}return r?R(r):t}function vt(){for(var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:[],t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:"react-datepicker__day--highlighted",r=new Map,o=0,a=e.length;o<a;o++){var s=e[o];if(n(s)){var i=Ie(s,"MM.dd.yyyy"),p=r.get(i)||[];p.includes(t)||(p.push(t),r.set(i,p));}else if("object"===ue(s)){var c=Object.keys(s),l=c[0],d=s[c[0]];if("string"==typeof l&&d.constructor===Array)for(var u=0,h=d.length;u<h;u++){var m=Ie(d[u],"MM.dd.yyyy"),f=r.get(m)||[];f.includes(l)||(f.push(l),r.set(m,f));}}}return r}function Dt(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:[],t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:"react-datepicker__day--holidays",r=new Map;return e.forEach((function(e){var o=e.date,a=e.holidayName;if(n(o)){var s=Ie(o,"MM.dd.yyyy"),i=r.get(s)||{};if(!("className"in i)||i.className!==t||(p=i.holidayNames,c=[a],p.length!==c.length||!p.every((function(e,t){return e===c[t]})))){var p,c;i.className=t;var l=i.holidayNames;i.holidayNames=l?[].concat(Se(l),[a]):[a],r.set(s,i);}}})),r}function gt(e,t,r,n,o){for(var a=o.length,p=[],c=0;c<a;c++){var l=s(i(e,k(o[c])),g(o[c])),d=s(e,(r+1)*n);X(l,t)&&Z(l,d)&&p.push(o[c]);}return p}function kt(e){return e<10?"0".concat(e):"".concat(e)}function wt(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:Ne,r=Math.ceil(M(e)/t)*t;return {startPeriod:r-(t-1),endPeriod:r}}function bt(e){var t=e.getSeconds(),r=e.getMilliseconds();return te(e.getTime()-1e3*t-r)}function St(e,t,r,n){for(var o=[],a=0;a<2*t+1;a++){var s=e+t-a,i=!0;r&&(i=M(r)<=s),n&&i&&(i=M(n)>=s),i&&o.push(s);}return o}var Ct=onClickOutsideHOC(function(n){De(a,e__default.Component);var o=be(a);function a(r){var n;he(this,a),ye(we(n=o.call(this,r)),"renderOptions",(function(){var t=n.props.year,r=n.state.yearsList.map((function(r){return e__default.createElement("div",{className:t===r?"react-datepicker__year-option react-datepicker__year-option--selected_year":"react-datepicker__year-option",key:r,onClick:n.onChange.bind(we(n),r),"aria-selected":t===r?"true":void 0},t===r?e__default.createElement("span",{className:"react-datepicker__year-option--selected"},"✓"):"",r)})),o=n.props.minDate?M(n.props.minDate):null,a=n.props.maxDate?M(n.props.maxDate):null;return a&&n.state.yearsList.find((function(e){return e===a}))||r.unshift(e__default.createElement("div",{className:"react-datepicker__year-option",key:"upcoming",onClick:n.incrementYears},e__default.createElement("a",{className:"react-datepicker__navigation react-datepicker__navigation--years react-datepicker__navigation--years-upcoming"}))),o&&n.state.yearsList.find((function(e){return e===o}))||r.push(e__default.createElement("div",{className:"react-datepicker__year-option",key:"previous",onClick:n.decrementYears},e__default.createElement("a",{className:"react-datepicker__navigation react-datepicker__navigation--years react-datepicker__navigation--years-previous"}))),r})),ye(we(n),"onChange",(function(e){n.props.onChange(e);})),ye(we(n),"handleClickOutside",(function(){n.props.onCancel();})),ye(we(n),"shiftYears",(function(e){var t=n.state.yearsList.map((function(t){return t+e}));n.setState({yearsList:t});})),ye(we(n),"incrementYears",(function(){return n.shiftYears(1)})),ye(we(n),"decrementYears",(function(){return n.shiftYears(-1)}));var s=r.yearDropdownItemNumber,i=r.scrollableYearDropdown,p=s||(i?10:5);return n.state={yearsList:St(n.props.year,p,n.props.minDate,n.props.maxDate)},n.dropdownRef=createRef(),n}return fe(a,[{key:"componentDidMount",value:function(){var e=this.dropdownRef.current;if(e){var t=e.children?Array.from(e.children):null,r=t?t.find((function(e){return e.ariaSelected})):null;e.scrollTop=r?r.offsetTop+(r.clientHeight-e.clientHeight)/2:(e.scrollHeight-e.clientHeight)/2;}}},{key:"render",value:function(){var t=r({"react-datepicker__year-dropdown":!0,"react-datepicker__year-dropdown--scrollable":this.props.scrollableYearDropdown});return e__default.createElement("div",{className:t,ref:this.dropdownRef},this.renderOptions())}}]),a}()),_t=function(t){De(n,e__default.Component);var r=be(n);function n(){var t;he(this,n);for(var o=arguments.length,a=new Array(o),s=0;s<o;s++)a[s]=arguments[s];return ye(we(t=r.call.apply(r,[this].concat(a))),"state",{dropdownVisible:!1}),ye(we(t),"renderSelectOptions",(function(){for(var r=t.props.minDate?M(t.props.minDate):1900,n=t.props.maxDate?M(t.props.maxDate):2100,o=[],a=r;a<=n;a++)o.push(e__default.createElement("option",{key:a,value:a},a));return o})),ye(we(t),"onSelectChange",(function(e){t.onChange(e.target.value);})),ye(we(t),"renderSelectMode",(function(){return e__default.createElement("select",{value:t.props.year,className:"react-datepicker__year-select",onChange:t.onSelectChange},t.renderSelectOptions())})),ye(we(t),"renderReadView",(function(r){return e__default.createElement("div",{key:"read",style:{visibility:r?"visible":"hidden"},className:"react-datepicker__year-read-view",onClick:function(e){return t.toggleDropdown(e)}},e__default.createElement("span",{className:"react-datepicker__year-read-view--down-arrow"}),e__default.createElement("span",{className:"react-datepicker__year-read-view--selected-year"},t.props.year))})),ye(we(t),"renderDropdown",(function(){return e__default.createElement(Ct,{key:"dropdown",year:t.props.year,onChange:t.onChange,onCancel:t.toggleDropdown,minDate:t.props.minDate,maxDate:t.props.maxDate,scrollableYearDropdown:t.props.scrollableYearDropdown,yearDropdownItemNumber:t.props.yearDropdownItemNumber})})),ye(we(t),"renderScrollMode",(function(){var e=t.state.dropdownVisible,r=[t.renderReadView(!e)];return e&&r.unshift(t.renderDropdown()),r})),ye(we(t),"onChange",(function(e){t.toggleDropdown(),e!==t.props.year&&t.props.onChange(e);})),ye(we(t),"toggleDropdown",(function(e){t.setState({dropdownVisible:!t.state.dropdownVisible},(function(){t.props.adjustDateOnChange&&t.handleYearChange(t.props.date,e);}));})),ye(we(t),"handleYearChange",(function(e,r){t.onSelect(e,r),t.setOpen();})),ye(we(t),"onSelect",(function(e,r){t.props.onSelect&&t.props.onSelect(e,r);})),ye(we(t),"setOpen",(function(){t.props.setOpen&&t.props.setOpen(!0);})),t}return fe(n,[{key:"render",value:function(){var t;switch(this.props.dropdownMode){case"scroll":t=this.renderScrollMode();break;case"select":t=this.renderSelectMode();}return e__default.createElement("div",{className:"react-datepicker__year-dropdown-container react-datepicker__year-dropdown-container--".concat(this.props.dropdownMode)},t)}}]),n}(),Mt=onClickOutsideHOC(function(t){De(n,e__default.Component);var r=be(n);function n(){var t;he(this,n);for(var o=arguments.length,a=new Array(o),s=0;s<o;s++)a[s]=arguments[s];return ye(we(t=r.call.apply(r,[this].concat(a))),"isSelectedMonth",(function(e){return t.props.month===e})),ye(we(t),"renderOptions",(function(){return t.props.monthNames.map((function(r,n){return e__default.createElement("div",{className:t.isSelectedMonth(n)?"react-datepicker__month-option react-datepicker__month-option--selected_month":"react-datepicker__month-option",key:r,onClick:t.onChange.bind(we(t),n),"aria-selected":t.isSelectedMonth(n)?"true":void 0},t.isSelectedMonth(n)?e__default.createElement("span",{className:"react-datepicker__month-option--selected"},"✓"):"",r)}))})),ye(we(t),"onChange",(function(e){return t.props.onChange(e)})),ye(we(t),"handleClickOutside",(function(){return t.props.onCancel()})),t}return fe(n,[{key:"render",value:function(){return e__default.createElement("div",{className:"react-datepicker__month-dropdown"},this.renderOptions())}}]),n}()),Pt=function(t){De(n,e__default.Component);var r=be(n);function n(){var t;he(this,n);for(var o=arguments.length,a=new Array(o),s=0;s<o;s++)a[s]=arguments[s];return ye(we(t=r.call.apply(r,[this].concat(a))),"state",{dropdownVisible:!1}),ye(we(t),"renderSelectOptions",(function(t){return t.map((function(t,r){return e__default.createElement("option",{key:r,value:r},t)}))})),ye(we(t),"renderSelectMode",(function(r){return e__default.createElement("select",{value:t.props.month,className:"react-datepicker__month-select",onChange:function(e){return t.onChange(e.target.value)}},t.renderSelectOptions(r))})),ye(we(t),"renderReadView",(function(r,n){return e__default.createElement("div",{key:"read",style:{visibility:r?"visible":"hidden"},className:"react-datepicker__month-read-view",onClick:t.toggleDropdown},e__default.createElement("span",{className:"react-datepicker__month-read-view--down-arrow"}),e__default.createElement("span",{className:"react-datepicker__month-read-view--selected-month"},n[t.props.month]))})),ye(we(t),"renderDropdown",(function(r){return e__default.createElement(Mt,{key:"dropdown",month:t.props.month,monthNames:r,onChange:t.onChange,onCancel:t.toggleDropdown})})),ye(we(t),"renderScrollMode",(function(e){var r=t.state.dropdownVisible,n=[t.renderReadView(!r,e)];return r&&n.unshift(t.renderDropdown(e)),n})),ye(we(t),"onChange",(function(e){t.toggleDropdown(),e!==t.props.month&&t.props.onChange(e);})),ye(we(t),"toggleDropdown",(function(){return t.setState({dropdownVisible:!t.state.dropdownVisible})})),t}return fe(n,[{key:"render",value:function(){var t,r=this,n=[0,1,2,3,4,5,6,7,8,9,10,11].map(this.props.useShortMonthInDropdown?function(e){return Xe(e,r.props.locale)}:function(e){return Je(e,r.props.locale)});switch(this.props.dropdownMode){case"scroll":t=this.renderScrollMode(n);break;case"select":t=this.renderSelectMode(n);}return e__default.createElement("div",{className:"react-datepicker__month-dropdown-container react-datepicker__month-dropdown-container--".concat(this.props.dropdownMode)},t)}}]),n}();function Et(e,t){for(var r=[],n=Fe(e),o=Fe(t);!X(n,o);)r.push(Ye(n)),n=l(n,1);return r}var Nt=onClickOutsideHOC(function(t){De(o,e__default.Component);var n=be(o);function o(t){var r;return he(this,o),ye(we(r=n.call(this,t)),"renderOptions",(function(){return r.state.monthYearsList.map((function(t){var n=P(t),o=Be(r.props.date,t)&&Qe(r.props.date,t);return e__default.createElement("div",{className:o?"react-datepicker__month-year-option--selected_month-year":"react-datepicker__month-year-option",key:n,onClick:r.onChange.bind(we(r),n),"aria-selected":o?"true":void 0},o?e__default.createElement("span",{className:"react-datepicker__month-year-option--selected"},"✓"):"",Ie(t,r.props.dateFormat,r.props.locale))}))})),ye(we(r),"onChange",(function(e){return r.props.onChange(e)})),ye(we(r),"handleClickOutside",(function(){r.props.onCancel();})),r.state={monthYearsList:Et(r.props.minDate,r.props.maxDate)},r}return fe(o,[{key:"render",value:function(){var t=r({"react-datepicker__month-year-dropdown":!0,"react-datepicker__month-year-dropdown--scrollable":this.props.scrollableMonthYearDropdown});return e__default.createElement("div",{className:t},this.renderOptions())}}]),o}()),xt=function(t){De(n,e__default.Component);var r=be(n);function n(){var t;he(this,n);for(var o=arguments.length,a=new Array(o),s=0;s<o;s++)a[s]=arguments[s];return ye(we(t=r.call.apply(r,[this].concat(a))),"state",{dropdownVisible:!1}),ye(we(t),"renderSelectOptions",(function(){for(var r=Fe(t.props.minDate),n=Fe(t.props.maxDate),o=[];!X(r,n);){var a=P(r);o.push(e__default.createElement("option",{key:a,value:a},Ie(r,t.props.dateFormat,t.props.locale))),r=l(r,1);}return o})),ye(we(t),"onSelectChange",(function(e){t.onChange(e.target.value);})),ye(we(t),"renderSelectMode",(function(){return e__default.createElement("select",{value:P(Fe(t.props.date)),className:"react-datepicker__month-year-select",onChange:t.onSelectChange},t.renderSelectOptions())})),ye(we(t),"renderReadView",(function(r){var n=Ie(t.props.date,t.props.dateFormat,t.props.locale);return e__default.createElement("div",{key:"read",style:{visibility:r?"visible":"hidden"},className:"react-datepicker__month-year-read-view",onClick:function(e){return t.toggleDropdown(e)}},e__default.createElement("span",{className:"react-datepicker__month-year-read-view--down-arrow"}),e__default.createElement("span",{className:"react-datepicker__month-year-read-view--selected-month-year"},n))})),ye(we(t),"renderDropdown",(function(){return e__default.createElement(Nt,{key:"dropdown",date:t.props.date,dateFormat:t.props.dateFormat,onChange:t.onChange,onCancel:t.toggleDropdown,minDate:t.props.minDate,maxDate:t.props.maxDate,scrollableMonthYearDropdown:t.props.scrollableMonthYearDropdown,locale:t.props.locale})})),ye(we(t),"renderScrollMode",(function(){var e=t.state.dropdownVisible,r=[t.renderReadView(!e)];return e&&r.unshift(t.renderDropdown()),r})),ye(we(t),"onChange",(function(e){t.toggleDropdown();var r=Ye(parseInt(e));Be(t.props.date,r)&&Qe(t.props.date,r)||t.props.onChange(r);})),ye(we(t),"toggleDropdown",(function(){return t.setState({dropdownVisible:!t.state.dropdownVisible})})),t}return fe(n,[{key:"render",value:function(){var t;switch(this.props.dropdownMode){case"scroll":t=this.renderScrollMode();break;case"select":t=this.renderSelectMode();}return e__default.createElement("div",{className:"react-datepicker__month-year-dropdown-container react-datepicker__month-year-dropdown-container--".concat(this.props.dropdownMode)},t)}}]),n}(),Yt=function(t){De(o,e__default.Component);var n=be(o);function o(){var t;he(this,o);for(var a=arguments.length,s=new Array(a),i=0;i<a;i++)s[i]=arguments[i];return ye(we(t=n.call.apply(n,[this].concat(s))),"dayEl",e__default.createRef()),ye(we(t),"handleClick",(function(e){!t.isDisabled()&&t.props.onClick&&t.props.onClick(e);})),ye(we(t),"handleMouseEnter",(function(e){!t.isDisabled()&&t.props.onMouseEnter&&t.props.onMouseEnter(e);})),ye(we(t),"handleOnKeyDown",(function(e){" "===e.key&&(e.preventDefault(),e.key="Enter"),t.props.handleOnKeyDown(e);})),ye(we(t),"isSameDay",(function(e){return je(t.props.day,e)})),ye(we(t),"isKeyboardSelected",(function(){return !t.props.disabledKeyboardNavigation&&!(t.isSameDay(t.props.selected)||t.isSameWeek(t.props.selected))&&(t.isSameDay(t.props.preSelection)||t.isSameWeek(t.props.preSelection))})),ye(we(t),"isDisabled",(function(){return Ze(t.props.day,t.props)})),ye(we(t),"isExcluded",(function(){return et(t.props.day,t.props)})),ye(we(t),"isStartOfWeek",(function(){return je(t.props.day,Le(t.props.day,t.props.locale,t.props.calendarStartDay))})),ye(we(t),"isSameWeek",(function(e){return t.props.showWeekPicker&&je(e,Le(t.props.day,t.props.locale,t.props.calendarStartDay))})),ye(we(t),"getHighLightedClass",(function(){var e=t.props,r=e.day,n=e.highlightDates;if(!n)return !1;var o=Ie(r,"MM.dd.yyyy");return n.get(o)})),ye(we(t),"getHolidaysClass",(function(){var e=t.props,r=e.day,n=e.holidays;if(!n)return !1;var o=Ie(r,"MM.dd.yyyy");return n.has(o)?[n.get(o).className]:void 0})),ye(we(t),"isInRange",(function(){var e=t.props,r=e.day,n=e.startDate,o=e.endDate;return !(!n||!o)&&qe(r,n,o)})),ye(we(t),"isInSelectingRange",(function(){var e,r=t.props,n=r.day,o=r.selectsStart,a=r.selectsEnd,s=r.selectsRange,i=r.selectsDisabledDaysInRange,p=r.startDate,c=r.endDate,l=null!==(e=t.props.selectingDate)&&void 0!==e?e:t.props.preSelection;return !(!(o||a||s)||!l||!i&&t.isDisabled())&&(o&&c&&(Z(l,c)||Ve(l,c))?qe(n,l,c):(a&&p&&(X(l,p)||Ve(l,p))||!(!s||!p||c||!X(l,p)&&!Ve(l,p)))&&qe(n,p,l))})),ye(we(t),"isSelectingRangeStart",(function(){var e;if(!t.isInSelectingRange())return !1;var r=t.props,n=r.day,o=r.startDate,a=r.selectsStart,s=null!==(e=t.props.selectingDate)&&void 0!==e?e:t.props.preSelection;return je(n,a?s:o)})),ye(we(t),"isSelectingRangeEnd",(function(){var e;if(!t.isInSelectingRange())return !1;var r=t.props,n=r.day,o=r.endDate,a=r.selectsEnd,s=r.selectsRange,i=null!==(e=t.props.selectingDate)&&void 0!==e?e:t.props.preSelection;return je(n,a||s?i:o)})),ye(we(t),"isRangeStart",(function(){var e=t.props,r=e.day,n=e.startDate,o=e.endDate;return !(!n||!o)&&je(n,r)})),ye(we(t),"isRangeEnd",(function(){var e=t.props,r=e.day,n=e.startDate,o=e.endDate;return !(!n||!o)&&je(o,r)})),ye(we(t),"isWeekend",(function(){var e=w(t.props.day);return 0===e||6===e})),ye(we(t),"isAfterMonth",(function(){return void 0!==t.props.month&&(t.props.month+1)%12===C(t.props.day)})),ye(we(t),"isBeforeMonth",(function(){return void 0!==t.props.month&&(C(t.props.day)+1)%12===t.props.month})),ye(we(t),"isCurrentDay",(function(){return t.isSameDay(Ye())})),ye(we(t),"isSelected",(function(){return t.isSameDay(t.props.selected)||t.isSameWeek(t.props.selected)})),ye(we(t),"getClassNames",(function(e){var n,o=t.props.dayClassName?t.props.dayClassName(e):void 0;return r("react-datepicker__day",o,"react-datepicker__day--"+Ie(t.props.day,"ddd",n),{"react-datepicker__day--disabled":t.isDisabled(),"react-datepicker__day--excluded":t.isExcluded(),"react-datepicker__day--selected":t.isSelected(),"react-datepicker__day--keyboard-selected":t.isKeyboardSelected(),"react-datepicker__day--range-start":t.isRangeStart(),"react-datepicker__day--range-end":t.isRangeEnd(),"react-datepicker__day--in-range":t.isInRange(),"react-datepicker__day--in-selecting-range":t.isInSelectingRange(),"react-datepicker__day--selecting-range-start":t.isSelectingRangeStart(),"react-datepicker__day--selecting-range-end":t.isSelectingRangeEnd(),"react-datepicker__day--today":t.isCurrentDay(),"react-datepicker__day--weekend":t.isWeekend(),"react-datepicker__day--outside-month":t.isAfterMonth()||t.isBeforeMonth()},t.getHighLightedClass("react-datepicker__day--highlighted"),t.getHolidaysClass())})),ye(we(t),"getAriaLabel",(function(){var e=t.props,r=e.day,n=e.ariaLabelPrefixWhenEnabled,o=void 0===n?"Choose":n,a=e.ariaLabelPrefixWhenDisabled,s=void 0===a?"Not available":a,i=t.isDisabled()||t.isExcluded()?s:o;return "".concat(i," ").concat(Ie(r,"PPPP",t.props.locale))})),ye(we(t),"getTitle",(function(){var e=t.props,r=e.day,n=e.holidays,o=void 0===n?new Map:n,a=Ie(r,"MM.dd.yyyy");return o.has(a)&&o.get(a).holidayNames.length>0?o.get(a).holidayNames.join(", "):""})),ye(we(t),"getTabIndex",(function(e,r){var n=e||t.props.selected,o=r||t.props.preSelection;return (!t.props.showWeekPicker||!t.props.showWeekNumber&&t.isStartOfWeek())&&(t.isKeyboardSelected()||t.isSameDay(n)&&je(o,n))?0:-1})),ye(we(t),"handleFocusDay",(function(){var e,r=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},n=!1;0===t.getTabIndex()&&!r.isInputFocused&&t.isSameDay(t.props.preSelection)&&(document.activeElement&&document.activeElement!==document.body||(n=!0),t.props.inline&&!t.props.shouldFocusDayInline&&(n=!1),t.props.containerRef&&t.props.containerRef.current&&t.props.containerRef.current.contains(document.activeElement)&&document.activeElement.classList.contains("react-datepicker__day")&&(n=!0),t.props.monthShowsDuplicateDaysEnd&&t.isAfterMonth()&&(n=!1),t.props.monthShowsDuplicateDaysStart&&t.isBeforeMonth()&&(n=!1)),n&&(null===(e=t.dayEl.current)||void 0===e||e.focus({preventScroll:!0}));})),ye(we(t),"renderDayContents",(function(){return t.props.monthShowsDuplicateDaysEnd&&t.isAfterMonth()||t.props.monthShowsDuplicateDaysStart&&t.isBeforeMonth()?null:t.props.renderDayContents?t.props.renderDayContents(b(t.props.day),t.props.day):b(t.props.day)})),ye(we(t),"render",(function(){return e__default.createElement("div",{ref:t.dayEl,className:t.getClassNames(t.props.day),onKeyDown:t.handleOnKeyDown,onClick:t.handleClick,onMouseEnter:t.handleMouseEnter,tabIndex:t.getTabIndex(),"aria-label":t.getAriaLabel(),role:"option",title:t.getTitle(),"aria-disabled":t.isDisabled(),"aria-current":t.isCurrentDay()?"date":void 0,"aria-selected":t.isSelected()||t.isInRange()},t.renderDayContents(),""!==t.getTitle()&&e__default.createElement("span",{className:"holiday-overlay"},t.getTitle()))})),t}return fe(o,[{key:"componentDidMount",value:function(){this.handleFocusDay();}},{key:"componentDidUpdate",value:function(e){this.handleFocusDay(e);}}]),o}(),Tt=function(t){De(o,e__default.Component);var n=be(o);function o(){var t;he(this,o);for(var r=arguments.length,a=new Array(r),s=0;s<r;s++)a[s]=arguments[s];return ye(we(t=n.call.apply(n,[this].concat(a))),"weekNumberEl",e__default.createRef()),ye(we(t),"handleClick",(function(e){t.props.onClick&&t.props.onClick(e);})),ye(we(t),"handleOnKeyDown",(function(e){" "===e.key&&(e.preventDefault(),e.key="Enter"),t.props.handleOnKeyDown(e);})),ye(we(t),"isKeyboardSelected",(function(){return !t.props.disabledKeyboardNavigation&&!je(t.props.date,t.props.selected)&&je(t.props.date,t.props.preSelection)})),ye(we(t),"getTabIndex",(function(){return t.props.showWeekPicker&&t.props.showWeekNumber&&(t.isKeyboardSelected()||je(t.props.date,t.props.selected)&&je(t.props.preSelection,t.props.selected))?0:-1})),ye(we(t),"handleFocusWeekNumber",(function(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},r=!1;0===t.getTabIndex()&&!e.isInputFocused&&je(t.props.date,t.props.preSelection)&&(document.activeElement&&document.activeElement!==document.body||(r=!0),t.props.inline&&!t.props.shouldFocusDayInline&&(r=!1),t.props.containerRef&&t.props.containerRef.current&&t.props.containerRef.current.contains(document.activeElement)&&document.activeElement&&document.activeElement.classList.contains("react-datepicker__week-number")&&(r=!0)),r&&t.weekNumberEl.current&&t.weekNumberEl.current.focus({preventScroll:!0});})),t}return fe(o,[{key:"componentDidMount",value:function(){this.handleFocusWeekNumber();}},{key:"componentDidUpdate",value:function(e){this.handleFocusWeekNumber(e);}},{key:"render",value:function(){var t=this.props,n=t.weekNumber,o=t.ariaLabelPrefix,a=void 0===o?"week ":o,s={"react-datepicker__week-number":!0,"react-datepicker__week-number--clickable":!!t.onClick,"react-datepicker__week-number--selected":je(this.props.date,this.props.selected),"react-datepicker__week-number--keyboard-selected":this.isKeyboardSelected()};return e__default.createElement("div",{ref:this.weekNumberEl,className:r(s),"aria-label":"".concat(a," ").concat(this.props.weekNumber),onClick:this.handleClick,onKeyDown:this.handleOnKeyDown,tabIndex:this.getTabIndex()},n)}}],[{key:"defaultProps",get:function(){return {ariaLabelPrefix:"week "}}}]),o}(),It=function(t){De(o,e__default.Component);var n=be(o);function o(){var t;he(this,o);for(var r=arguments.length,a=new Array(r),s=0;s<r;s++)a[s]=arguments[s];return ye(we(t=n.call.apply(n,[this].concat(a))),"handleDayClick",(function(e,r){t.props.onDayClick&&t.props.onDayClick(e,r);})),ye(we(t),"handleDayMouseEnter",(function(e){t.props.onDayMouseEnter&&t.props.onDayMouseEnter(e);})),ye(we(t),"handleWeekClick",(function(e,r,n){if("function"==typeof t.props.onWeekSelect&&t.props.onWeekSelect(e,r,n),t.props.showWeekPicker){var o=Le(e,t.props.locale,t.props.calendarStartDay);t.handleDayClick(o,n);}t.props.shouldCloseOnSelect&&t.props.setOpen(!1);})),ye(we(t),"formatWeekNumber",(function(e){return t.props.formatWeekNumber?t.props.formatWeekNumber(e):function(e,t){var r=$e()&&Ge($e());return S(e,r?{locale:r}:null)}(e)})),ye(we(t),"renderDays",(function(){var r=Le(t.props.day,t.props.locale,t.props.calendarStartDay),n=[],o=t.formatWeekNumber(r);if(t.props.showWeekNumber){var a=t.props.onWeekSelect||t.props.showWeekPicker?t.handleWeekClick.bind(we(t),r,o):void 0;n.push(e__default.createElement(Tt,{key:"W",weekNumber:o,date:r,onClick:a,selected:t.props.selected,preSelection:t.props.preSelection,ariaLabelPrefix:t.props.ariaLabelPrefix,showWeekPicker:t.props.showWeekPicker,showWeekNumber:t.props.showWeekNumber,disabledKeyboardNavigation:t.props.disabledKeyboardNavigation,handleOnKeyDown:t.props.handleOnKeyDown,isInputFocused:t.props.isInputFocused,containerRef:t.props.containerRef}));}return n.concat([0,1,2,3,4,5,6].map((function(n){var o=p(r,n);return e__default.createElement(Yt,{ariaLabelPrefixWhenEnabled:t.props.chooseDayAriaLabelPrefix,ariaLabelPrefixWhenDisabled:t.props.disabledDayAriaLabelPrefix,key:o.valueOf(),day:o,month:t.props.month,onClick:t.handleDayClick.bind(we(t),o),onMouseEnter:t.handleDayMouseEnter.bind(we(t),o),minDate:t.props.minDate,maxDate:t.props.maxDate,excludeDates:t.props.excludeDates,excludeDateIntervals:t.props.excludeDateIntervals,includeDates:t.props.includeDates,includeDateIntervals:t.props.includeDateIntervals,highlightDates:t.props.highlightDates,holidays:t.props.holidays,selectingDate:t.props.selectingDate,filterDate:t.props.filterDate,preSelection:t.props.preSelection,selected:t.props.selected,selectsStart:t.props.selectsStart,selectsEnd:t.props.selectsEnd,selectsRange:t.props.selectsRange,showWeekPicker:t.props.showWeekPicker,showWeekNumber:t.props.showWeekNumber,selectsDisabledDaysInRange:t.props.selectsDisabledDaysInRange,startDate:t.props.startDate,endDate:t.props.endDate,dayClassName:t.props.dayClassName,renderDayContents:t.props.renderDayContents,disabledKeyboardNavigation:t.props.disabledKeyboardNavigation,handleOnKeyDown:t.props.handleOnKeyDown,isInputFocused:t.props.isInputFocused,containerRef:t.props.containerRef,inline:t.props.inline,shouldFocusDayInline:t.props.shouldFocusDayInline,monthShowsDuplicateDaysEnd:t.props.monthShowsDuplicateDaysEnd,monthShowsDuplicateDaysStart:t.props.monthShowsDuplicateDaysStart,locale:t.props.locale})})))})),ye(we(t),"startOfWeek",(function(){return Le(t.props.day,t.props.locale,t.props.calendarStartDay)})),ye(we(t),"isKeyboardSelected",(function(){return !t.props.disabledKeyboardNavigation&&!je(t.startOfWeek(),t.props.selected)&&je(t.startOfWeek(),t.props.preSelection)})),t}return fe(o,[{key:"render",value:function(){var t={"react-datepicker__week":!0,"react-datepicker__week--selected":je(this.startOfWeek(),this.props.selected),"react-datepicker__week--keyboard-selected":this.isKeyboardSelected()};return e__default.createElement("div",{className:r(t)},this.renderDays())}}],[{key:"defaultProps",get:function(){return {shouldCloseOnSelect:!0}}}]),o}(),Ot="two_columns",Rt="three_columns",Lt="four_columns",Ft=ye(ye(ye({},Ot,{grid:[[0,1],[2,3],[4,5],[6,7],[8,9],[10,11]],verticalNavigationOffset:2}),Rt,{grid:[[0,1,2],[3,4,5],[6,7,8],[9,10,11]],verticalNavigationOffset:3}),Lt,{grid:[[0,1,2,3],[4,5,6,7],[8,9,10,11]],verticalNavigationOffset:4});function At(e,t){return e?Lt:t?Ot:Rt}var Wt=function(t){De(o,e__default.Component);var n=be(o);function o(){var t;he(this,o);for(var a=arguments.length,s=new Array(a),i=0;i<a;i++)s[i]=arguments[i];return ye(we(t=n.call.apply(n,[this].concat(s))),"MONTH_REFS",Se(Array(12)).map((function(){return e__default.createRef()}))),ye(we(t),"QUARTER_REFS",Se(Array(4)).map((function(){return e__default.createRef()}))),ye(we(t),"isDisabled",(function(e){return Ze(e,t.props)})),ye(we(t),"isExcluded",(function(e){return et(e,t.props)})),ye(we(t),"handleDayClick",(function(e,r){t.props.onDayClick&&t.props.onDayClick(e,r,t.props.orderInDisplay);})),ye(we(t),"handleDayMouseEnter",(function(e){t.props.onDayMouseEnter&&t.props.onDayMouseEnter(e);})),ye(we(t),"handleMouseLeave",(function(){t.props.onMouseLeave&&t.props.onMouseLeave();})),ye(we(t),"isRangeStartMonth",(function(e){var r=t.props,n=r.day,o=r.startDate,a=r.endDate;return !(!o||!a)&&Qe(Y(n,e),o)})),ye(we(t),"isRangeStartQuarter",(function(e){var r=t.props,n=r.day,o=r.startDate,a=r.endDate;return !(!o||!a)&&He(T(n,e),o)})),ye(we(t),"isRangeEndMonth",(function(e){var r=t.props,n=r.day,o=r.startDate,a=r.endDate;return !(!o||!a)&&Qe(Y(n,e),a)})),ye(we(t),"isRangeEndQuarter",(function(e){var r=t.props,n=r.day,o=r.startDate,a=r.endDate;return !(!o||!a)&&He(T(n,e),a)})),ye(we(t),"isInSelectingRangeMonth",(function(e){var r,n=t.props,o=n.day,a=n.selectsStart,s=n.selectsEnd,i=n.selectsRange,p=n.startDate,c=n.endDate,l=null!==(r=t.props.selectingDate)&&void 0!==r?r:t.props.preSelection;return !(!(a||s||i)||!l)&&(a&&c?rt(l,c,e,o):(s&&p||!(!i||!p||c))&&rt(p,l,e,o))})),ye(we(t),"isSelectingMonthRangeStart",(function(e){var r;if(!t.isInSelectingRangeMonth(e))return !1;var n=t.props,o=n.day,a=n.startDate,s=n.selectsStart,i=Y(o,e),p=null!==(r=t.props.selectingDate)&&void 0!==r?r:t.props.preSelection;return Qe(i,s?p:a)})),ye(we(t),"isSelectingMonthRangeEnd",(function(e){var r;if(!t.isInSelectingRangeMonth(e))return !1;var n=t.props,o=n.day,a=n.endDate,s=n.selectsEnd,i=n.selectsRange,p=Y(o,e),c=null!==(r=t.props.selectingDate)&&void 0!==r?r:t.props.preSelection;return Qe(p,s||i?c:a)})),ye(we(t),"isInSelectingRangeQuarter",(function(e){var r,n=t.props,o=n.day,a=n.selectsStart,s=n.selectsEnd,i=n.selectsRange,p=n.startDate,c=n.endDate,l=null!==(r=t.props.selectingDate)&&void 0!==r?r:t.props.preSelection;return !(!(a||s||i)||!l)&&(a&&c?st(l,c,e,o):(s&&p||!(!i||!p||c))&&st(p,l,e,o))})),ye(we(t),"isWeekInMonth",(function(e){var r=t.props.day,n=p(e,6);return Qe(e,r)||Qe(n,r)})),ye(we(t),"isCurrentMonth",(function(e,t){return M(e)===M(Ye())&&t===C(Ye())})),ye(we(t),"isCurrentQuarter",(function(e,t){return M(e)===M(Ye())&&t===_(Ye())})),ye(we(t),"isSelectedMonth",(function(e,t,r){return C(r)===t&&M(e)===M(r)})),ye(we(t),"isSelectedQuarter",(function(e,t,r){return _(e)===t&&M(e)===M(r)})),ye(we(t),"renderWeeks",(function(){for(var r=[],n=t.props.fixedHeight,o=0,a=!1,s=Le(Fe(t.props.day),t.props.locale,t.props.calendarStartDay);r.push(e__default.createElement(It,{ariaLabelPrefix:t.props.weekAriaLabelPrefix,chooseDayAriaLabelPrefix:t.props.chooseDayAriaLabelPrefix,disabledDayAriaLabelPrefix:t.props.disabledDayAriaLabelPrefix,key:o,day:s,month:C(t.props.day),onDayClick:t.handleDayClick,onDayMouseEnter:t.handleDayMouseEnter,onWeekSelect:t.props.onWeekSelect,formatWeekNumber:t.props.formatWeekNumber,locale:t.props.locale,minDate:t.props.minDate,maxDate:t.props.maxDate,excludeDates:t.props.excludeDates,excludeDateIntervals:t.props.excludeDateIntervals,includeDates:t.props.includeDates,includeDateIntervals:t.props.includeDateIntervals,inline:t.props.inline,shouldFocusDayInline:t.props.shouldFocusDayInline,highlightDates:t.props.highlightDates,holidays:t.props.holidays,selectingDate:t.props.selectingDate,filterDate:t.props.filterDate,preSelection:t.props.preSelection,selected:t.props.selected,selectsStart:t.props.selectsStart,selectsEnd:t.props.selectsEnd,selectsRange:t.props.selectsRange,selectsDisabledDaysInRange:t.props.selectsDisabledDaysInRange,showWeekNumber:t.props.showWeekNumbers,showWeekPicker:t.props.showWeekPicker,startDate:t.props.startDate,endDate:t.props.endDate,dayClassName:t.props.dayClassName,setOpen:t.props.setOpen,shouldCloseOnSelect:t.props.shouldCloseOnSelect,disabledKeyboardNavigation:t.props.disabledKeyboardNavigation,renderDayContents:t.props.renderDayContents,handleOnKeyDown:t.props.handleOnKeyDown,isInputFocused:t.props.isInputFocused,containerRef:t.props.containerRef,calendarStartDay:t.props.calendarStartDay,monthShowsDuplicateDaysEnd:t.props.monthShowsDuplicateDaysEnd,monthShowsDuplicateDaysStart:t.props.monthShowsDuplicateDaysStart})),!a;){o++,s=c(s,1);var i=n&&o>=6,p=!n&&!t.isWeekInMonth(s);if(i||p){if(!t.props.peekNextMonth)break;a=!0;}}return r})),ye(we(t),"onMonthClick",(function(e,r){t.handleDayClick(Fe(Y(t.props.day,r)),e);})),ye(we(t),"onMonthMouseEnter",(function(e){t.handleDayMouseEnter(Fe(Y(t.props.day,e)));})),ye(we(t),"handleMonthNavigation",(function(e,r){t.isDisabled(r)||t.isExcluded(r)||(t.props.setPreSelection(r),t.MONTH_REFS[e].current&&t.MONTH_REFS[e].current.focus());})),ye(we(t),"onMonthKeyDown",(function(e,r){var n=t.props,o=n.selected,a=n.preSelection,s=n.disabledKeyboardNavigation,i=n.showTwoColumnMonthYearPicker,p=n.showFourColumnMonthYearPicker,c=n.setPreSelection,d=e.key;if("Tab"!==d&&e.preventDefault(),!s){var u=At(p,i),h=Ft[u].verticalNavigationOffset,m=Ft[u].grid;switch(d){case"Enter":t.onMonthClick(e,r),c(o);break;case"ArrowRight":t.handleMonthNavigation(11===r?0:r+1,l(a,1));break;case"ArrowLeft":t.handleMonthNavigation(0===r?11:r-1,f(a,1));break;case"ArrowUp":t.handleMonthNavigation(m[0].includes(r)?r+12-h:r-h,f(a,h));break;case"ArrowDown":t.handleMonthNavigation(m[m.length-1].includes(r)?r-12+h:r+h,l(a,h));}}})),ye(we(t),"onQuarterClick",(function(e,r){t.handleDayClick(We(T(t.props.day,r)),e);})),ye(we(t),"onQuarterMouseEnter",(function(e){t.handleDayMouseEnter(We(T(t.props.day,e)));})),ye(we(t),"handleQuarterNavigation",(function(e,r){t.isDisabled(r)||t.isExcluded(r)||(t.props.setPreSelection(r),t.QUARTER_REFS[e-1].current&&t.QUARTER_REFS[e-1].current.focus());})),ye(we(t),"onQuarterKeyDown",(function(e,r){var n=e.key;if(!t.props.disabledKeyboardNavigation)switch(n){case"Enter":t.onQuarterClick(e,r),t.props.setPreSelection(t.props.selected);break;case"ArrowRight":t.handleQuarterNavigation(4===r?1:r+1,d(t.props.preSelection,1));break;case"ArrowLeft":t.handleQuarterNavigation(1===r?4:r-1,y(t.props.preSelection,1));}})),ye(we(t),"getMonthClassNames",(function(e){var n=t.props,o=n.day,a=n.startDate,s=n.endDate,i=n.selected,p=n.minDate,c=n.maxDate,l=n.preSelection,d=n.monthClassName,u=n.excludeDates,h=n.includeDates,m=d?d(Y(o,e)):void 0,f=Y(o,e);return r("react-datepicker__month-text","react-datepicker__month-".concat(e),m,{"react-datepicker__month-text--disabled":(p||c||u||h)&&tt(f,t.props),"react-datepicker__month-text--selected":t.isSelectedMonth(o,e,i),"react-datepicker__month-text--keyboard-selected":!t.props.disabledKeyboardNavigation&&C(l)===e,"react-datepicker__month-text--in-selecting-range":t.isInSelectingRangeMonth(e),"react-datepicker__month-text--in-range":rt(a,s,e,o),"react-datepicker__month-text--range-start":t.isRangeStartMonth(e),"react-datepicker__month-text--range-end":t.isRangeEndMonth(e),"react-datepicker__month-text--selecting-range-start":t.isSelectingMonthRangeStart(e),"react-datepicker__month-text--selecting-range-end":t.isSelectingMonthRangeEnd(e),"react-datepicker__month-text--today":t.isCurrentMonth(o,e)})})),ye(we(t),"getTabIndex",(function(e){var r=C(t.props.preSelection);return t.props.disabledKeyboardNavigation||e!==r?"-1":"0"})),ye(we(t),"getQuarterTabIndex",(function(e){var r=_(t.props.preSelection);return t.props.disabledKeyboardNavigation||e!==r?"-1":"0"})),ye(we(t),"getAriaLabel",(function(e){var r=t.props,n=r.chooseDayAriaLabelPrefix,o=void 0===n?"Choose":n,a=r.disabledDayAriaLabelPrefix,s=void 0===a?"Not available":a,i=r.day,p=Y(i,e),c=t.isDisabled(p)||t.isExcluded(p)?s:o;return "".concat(c," ").concat(Ie(p,"MMMM yyyy"))})),ye(we(t),"getQuarterClassNames",(function(e){var n=t.props,o=n.day,a=n.startDate,s=n.endDate,i=n.selected,p=n.minDate,c=n.maxDate,l=n.preSelection,d=n.disabledKeyboardNavigation;return r("react-datepicker__quarter-text","react-datepicker__quarter-".concat(e),{"react-datepicker__quarter-text--disabled":(p||c)&&nt(T(o,e),t.props),"react-datepicker__quarter-text--selected":t.isSelectedQuarter(o,e,i),"react-datepicker__quarter-text--keyboard-selected":!d&&_(l)===e,"react-datepicker__quarter-text--in-selecting-range":t.isInSelectingRangeQuarter(e),"react-datepicker__quarter-text--in-range":st(a,s,e,o),"react-datepicker__quarter-text--range-start":t.isRangeStartQuarter(e),"react-datepicker__quarter-text--range-end":t.isRangeEndQuarter(e)})})),ye(we(t),"getMonthContent",(function(e){var r=t.props,n=r.showFullMonthYearPicker,o=r.renderMonthContent,a=r.locale,s=r.day,i=Xe(e,a),p=Je(e,a);return o?o(e,i,p,s):n?p:i})),ye(we(t),"getQuarterContent",(function(e){var r=t.props,n=r.renderQuarterContent,o=function(e,t){return Ie(T(Ye(),e),"QQQ",t)}(e,r.locale);return n?n(e,o):o})),ye(we(t),"renderMonths",(function(){var r=t.props,n=r.showTwoColumnMonthYearPicker,o=r.showFourColumnMonthYearPicker,a=r.day,s=r.selected;return Ft[At(o,n)].grid.map((function(r,n){return e__default.createElement("div",{className:"react-datepicker__month-wrapper",key:n},r.map((function(r,n){return e__default.createElement("div",{ref:t.MONTH_REFS[r],key:n,onClick:function(e){t.onMonthClick(e,r);},onKeyDown:function(e){t.onMonthKeyDown(e,r);},onMouseEnter:function(){return t.onMonthMouseEnter(r)},tabIndex:t.getTabIndex(r),className:t.getMonthClassNames(r),role:"option","aria-label":t.getAriaLabel(r),"aria-current":t.isCurrentMonth(a,r)?"date":void 0,"aria-selected":t.isSelectedMonth(a,r,s)},t.getMonthContent(r))})))}))})),ye(we(t),"renderQuarters",(function(){var r=t.props,n=r.day,o=r.selected;return e__default.createElement("div",{className:"react-datepicker__quarter-wrapper"},[1,2,3,4].map((function(r,a){return e__default.createElement("div",{key:a,ref:t.QUARTER_REFS[a],role:"option",onClick:function(e){t.onQuarterClick(e,r);},onKeyDown:function(e){t.onQuarterKeyDown(e,r);},onMouseEnter:function(){return t.onQuarterMouseEnter(r)},className:t.getQuarterClassNames(r),"aria-selected":t.isSelectedQuarter(n,r,o),tabIndex:t.getQuarterTabIndex(r),"aria-current":t.isCurrentQuarter(n,r)?"date":void 0},t.getQuarterContent(r))})))})),ye(we(t),"getClassNames",(function(){var e=t.props,n=e.selectingDate,o=e.selectsStart,a=e.selectsEnd,s=e.showMonthYearPicker,i=e.showQuarterYearPicker,p=e.showWeekPicker;return r("react-datepicker__month",{"react-datepicker__month--selecting-range":n&&(o||a)},{"react-datepicker__monthPicker":s},{"react-datepicker__quarterPicker":i},{"react-datepicker__weekPicker":p})})),t}return fe(o,[{key:"render",value:function(){var t=this.props,r=t.showMonthYearPicker,n=t.showQuarterYearPicker,o=t.day,a=t.ariaLabelPrefix,s=void 0===a?"month ":a;return e__default.createElement("div",{className:this.getClassNames(),onMouseLeave:this.handleMouseLeave,"aria-label":"".concat(s," ").concat(Ie(o,"yyyy-MM")),role:"listbox"},r?this.renderMonths():n?this.renderQuarters():this.renderWeeks())}}]),o}(),Kt=function(t){De(n,e__default.Component);var r=be(n);function n(){var t;he(this,n);for(var o=arguments.length,a=new Array(o),i=0;i<o;i++)a[i]=arguments[i];return ye(we(t=r.call.apply(r,[this].concat(a))),"state",{height:null}),ye(we(t),"scrollToTheSelectedTime",(function(){requestAnimationFrame((function(){t.list&&(t.list.scrollTop=t.centerLi&&n.calcCenterPosition(t.props.monthRef?t.props.monthRef.clientHeight-t.header.clientHeight:t.list.clientHeight,t.centerLi));}));})),ye(we(t),"handleClick",(function(e){(t.props.minTime||t.props.maxTime)&&lt(e,t.props)||(t.props.excludeTimes||t.props.includeTimes||t.props.filterTime)&&ct(e,t.props)||t.props.onChange(e);})),ye(we(t),"isSelectedTime",(function(e){return t.props.selected&&(r=t.props.selected,n=e,bt(r).getTime()===bt(n).getTime());var r,n;})),ye(we(t),"isDisabledTime",(function(e){return (t.props.minTime||t.props.maxTime)&&lt(e,t.props)||(t.props.excludeTimes||t.props.includeTimes||t.props.filterTime)&&ct(e,t.props)})),ye(we(t),"liClasses",(function(e){var r=["react-datepicker__time-list-item",t.props.timeClassName?t.props.timeClassName(e):void 0];return t.isSelectedTime(e)&&r.push("react-datepicker__time-list-item--selected"),t.isDisabledTime(e)&&r.push("react-datepicker__time-list-item--disabled"),t.props.injectTimes&&(60*k(e)+g(e))%t.props.intervals!=0&&r.push("react-datepicker__time-list-item--injected"),r.join(" ")})),ye(we(t),"handleOnKeyDown",(function(e,r){" "===e.key&&(e.preventDefault(),e.key="Enter"),"ArrowUp"!==e.key&&"ArrowLeft"!==e.key||!e.target.previousSibling||(e.preventDefault(),e.target.previousSibling.focus()),"ArrowDown"!==e.key&&"ArrowRight"!==e.key||!e.target.nextSibling||(e.preventDefault(),e.target.nextSibling.focus()),"Enter"===e.key&&t.handleClick(r),t.props.handleOnKeyDown(e);})),ye(we(t),"renderTimes",(function(){for(var r=[],n=t.props.format?t.props.format:"p",o=t.props.intervals,a=t.props.selected||t.props.openToDate||Ye(),i=W(a),p=t.props.injectTimes&&t.props.injectTimes.sort((function(e,t){return e-t})),c=60*function(e){var t=new Date(e.getFullYear(),e.getMonth(),e.getDate()),r=new Date(e.getFullYear(),e.getMonth(),e.getDate(),24);return Math.round((+r-+t)/36e5)}(a),l=c/o,d=0;d<l;d++){var u=s(i,d*o);if(r.push(u),p){var h=gt(i,u,d,o,p);r=r.concat(h);}}var m=r.reduce((function(e,t){return t.getTime()<=a.getTime()?t:e}),r[0]);return r.map((function(r,o){return e__default.createElement("li",{key:o,onClick:t.handleClick.bind(we(t),r),className:t.liClasses(r),ref:function(e){r===m&&(t.centerLi=e);},onKeyDown:function(e){t.handleOnKeyDown(e,r);},tabIndex:r===m?0:-1,role:"option","aria-selected":t.isSelectedTime(r)?"true":void 0,"aria-disabled":t.isDisabledTime(r)?"true":void 0},Ie(r,n,t.props.locale))}))})),t}return fe(n,[{key:"componentDidMount",value:function(){this.scrollToTheSelectedTime(),this.props.monthRef&&this.header&&this.setState({height:this.props.monthRef.clientHeight-this.header.clientHeight});}},{key:"render",value:function(){var t=this,r=this.state.height;return e__default.createElement("div",{className:"react-datepicker__time-container ".concat(this.props.todayButton?"react-datepicker__time-container--with-today-button":"")},e__default.createElement("div",{className:"react-datepicker__header react-datepicker__header--time ".concat(this.props.showTimeSelectOnly?"react-datepicker__header--time--only":""),ref:function(e){t.header=e;}},e__default.createElement("div",{className:"react-datepicker-time__header"},this.props.timeCaption)),e__default.createElement("div",{className:"react-datepicker__time"},e__default.createElement("div",{className:"react-datepicker__time-box"},e__default.createElement("ul",{className:"react-datepicker__time-list",ref:function(e){t.list=e;},style:r?{height:r}:{},role:"listbox","aria-label":this.props.timeCaption},this.renderTimes()))))}}],[{key:"defaultProps",get:function(){return {intervals:30,onTimeChange:function(){},todayButton:null,timeCaption:"Time"}}}]),n}();ye(Kt,"calcCenterPosition",(function(e,t){return t.offsetTop-(e/2-t.clientHeight/2)}));var Bt=function(t){De(o,e__default.Component);var n=be(o);function o(t){var a;return he(this,o),ye(we(a=n.call(this,t)),"YEAR_REFS",Se(Array(a.props.yearItemNumber)).map((function(){return e__default.createRef()}))),ye(we(a),"isDisabled",(function(e){return Ze(e,a.props)})),ye(we(a),"isExcluded",(function(e){return et(e,a.props)})),ye(we(a),"selectingDate",(function(){var e;return null!==(e=a.props.selectingDate)&&void 0!==e?e:a.props.preSelection})),ye(we(a),"updateFocusOnPaginate",(function(e){var t=function(){this.YEAR_REFS[e].current.focus();}.bind(we(a));window.requestAnimationFrame(t);})),ye(we(a),"handleYearClick",(function(e,t){a.props.onDayClick&&a.props.onDayClick(e,t);})),ye(we(a),"handleYearNavigation",(function(e,t){var r=a.props,n=r.date,o=r.yearItemNumber,s=wt(n,o).startPeriod;a.isDisabled(t)||a.isExcluded(t)||(a.props.setPreSelection(t),e-s==-1?a.updateFocusOnPaginate(o-1):e-s===o?a.updateFocusOnPaginate(0):a.YEAR_REFS[e-s].current.focus());})),ye(we(a),"isSameDay",(function(e,t){return je(e,t)})),ye(we(a),"isCurrentYear",(function(e){return e===M(Ye())})),ye(we(a),"isRangeStart",(function(e){return a.props.startDate&&a.props.endDate&&Be(I(Ye(),e),a.props.startDate)})),ye(we(a),"isRangeEnd",(function(e){return a.props.startDate&&a.props.endDate&&Be(I(Ye(),e),a.props.endDate)})),ye(we(a),"isInRange",(function(e){return ot(e,a.props.startDate,a.props.endDate)})),ye(we(a),"isInSelectingRange",(function(e){var t=a.props,r=t.selectsStart,n=t.selectsEnd,o=t.selectsRange,s=t.startDate,i=t.endDate;return !(!(r||n||o)||!a.selectingDate())&&(r&&i?ot(e,a.selectingDate(),i):(n&&s||!(!o||!s||i))&&ot(e,s,a.selectingDate()))})),ye(we(a),"isSelectingRangeStart",(function(e){if(!a.isInSelectingRange(e))return !1;var t=a.props,r=t.startDate,n=t.selectsStart,o=I(Ye(),e);return Be(o,n?a.selectingDate():r)})),ye(we(a),"isSelectingRangeEnd",(function(e){if(!a.isInSelectingRange(e))return !1;var t=a.props,r=t.endDate,n=t.selectsEnd,o=t.selectsRange,s=I(Ye(),e);return Be(s,n||o?a.selectingDate():r)})),ye(we(a),"isKeyboardSelected",(function(e){var t=Ae(I(a.props.date,e));return !a.props.disabledKeyboardNavigation&&!a.props.inline&&!je(t,Ae(a.props.selected))&&je(t,Ae(a.props.preSelection))})),ye(we(a),"onYearClick",(function(e,t){var r=a.props.date;a.handleYearClick(Ae(I(r,t)),e);})),ye(we(a),"onYearKeyDown",(function(e,t){var r=e.key;if(!a.props.disabledKeyboardNavigation)switch(r){case"Enter":a.onYearClick(e,t),a.props.setPreSelection(a.props.selected);break;case"ArrowRight":a.handleYearNavigation(t+1,u(a.props.preSelection,1));break;case"ArrowLeft":a.handleYearNavigation(t-1,v(a.props.preSelection,1));}})),ye(we(a),"getYearClassNames",(function(e){var t=a.props,n=t.minDate,o=t.maxDate,s=t.selected,i=t.excludeDates,p=t.includeDates,c=t.filterDate;return r("react-datepicker__year-text",{"react-datepicker__year-text--selected":e===M(s),"react-datepicker__year-text--disabled":(n||o||i||p||c)&&at(e,a.props),"react-datepicker__year-text--keyboard-selected":a.isKeyboardSelected(e),"react-datepicker__year-text--range-start":a.isRangeStart(e),"react-datepicker__year-text--range-end":a.isRangeEnd(e),"react-datepicker__year-text--in-range":a.isInRange(e),"react-datepicker__year-text--in-selecting-range":a.isInSelectingRange(e),"react-datepicker__year-text--selecting-range-start":a.isSelectingRangeStart(e),"react-datepicker__year-text--selecting-range-end":a.isSelectingRangeEnd(e),"react-datepicker__year-text--today":a.isCurrentYear(e)})})),ye(we(a),"getYearTabIndex",(function(e){return a.props.disabledKeyboardNavigation?"-1":e===M(a.props.preSelection)?"0":"-1"})),ye(we(a),"getYearContainerClassNames",(function(){var e=a.props,t=e.selectingDate,n=e.selectsStart,o=e.selectsEnd,s=e.selectsRange;return r("react-datepicker__year",{"react-datepicker__year--selecting-range":t&&(n||o||s)})})),ye(we(a),"getYearContent",(function(e){return a.props.renderYearContent?a.props.renderYearContent(e):e})),a}return fe(o,[{key:"render",value:function(){for(var t=this,r=[],n=this.props,o=n.date,a=n.yearItemNumber,s=n.onYearMouseEnter,i=n.onYearMouseLeave,p=wt(o,a),c=p.startPeriod,l=p.endPeriod,d=function(n){r.push(e__default.createElement("div",{ref:t.YEAR_REFS[n-c],onClick:function(e){t.onYearClick(e,n);},onKeyDown:function(e){t.onYearKeyDown(e,n);},tabIndex:t.getYearTabIndex(n),className:t.getYearClassNames(n),onMouseEnter:function(e){return s(e,n)},onMouseLeave:function(e){return i(e,n)},key:n,"aria-current":t.isCurrentYear(n)?"date":void 0},t.getYearContent(n)));},u=c;u<=l;u++)d(u);return e__default.createElement("div",{className:this.getYearContainerClassNames()},e__default.createElement("div",{className:"react-datepicker__year-wrapper",onMouseLeave:this.props.clearSelectingDate},r))}}]),o}(),Qt=function(t){De(n,e__default.Component);var r=be(n);function n(t){var o;return he(this,n),ye(we(o=r.call(this,t)),"onTimeChange",(function(e){o.setState({time:e});var t=o.props.date,r=t instanceof Date&&!isNaN(t)?t:new Date;r.setHours(e.split(":")[0]),r.setMinutes(e.split(":")[1]),o.props.onChange(r);})),ye(we(o),"renderTimeInput",(function(){var t=o.state.time,r=o.props,n=r.date,a=r.timeString,s=r.customTimeInput;return s?e__default.cloneElement(s,{date:n,value:t,onChange:o.onTimeChange}):e__default.createElement("input",{type:"time",className:"react-datepicker-time__input",placeholder:"Time",name:"time-input",required:!0,value:t,onChange:function(e){o.onTimeChange(e.target.value||a);}})})),o.state={time:o.props.timeString},o}return fe(n,[{key:"render",value:function(){return e__default.createElement("div",{className:"react-datepicker__input-time-container"},e__default.createElement("div",{className:"react-datepicker-time__caption"},this.props.timeInputLabel),e__default.createElement("div",{className:"react-datepicker-time__input-container"},e__default.createElement("div",{className:"react-datepicker-time__input"},this.renderTimeInput())))}}],[{key:"getDerivedStateFromProps",value:function(e,t){return e.timeString!==t.time?{time:e.timeString}:null}}]),n}();function Ht(t){var r=t.className,n=t.children,o=t.showPopperArrow,a=t.arrowProps,s=void 0===a?{}:a;return e__default.createElement("div",{className:r},o&&e__default.createElement("div",ve({className:"react-datepicker__triangle"},s)),n)}var jt=["react-datepicker__year-select","react-datepicker__month-select","react-datepicker__month-year-select"],Vt=function(t){De(o,e__default.Component);var n=be(o);function o(t){var a;return he(this,o),ye(we(a=n.call(this,t)),"handleClickOutside",(function(e){a.props.onClickOutside(e);})),ye(we(a),"setClickOutsideRef",(function(){return a.containerRef.current})),ye(we(a),"handleDropdownFocus",(function(e){(function(){var e=((arguments.length>0&&void 0!==arguments[0]?arguments[0]:{}).className||"").split(/\s+/);return jt.some((function(t){return e.indexOf(t)>=0}))})(e.target)&&a.props.onDropdownFocus();})),ye(we(a),"getDateInView",(function(){var e=a.props,t=e.preSelection,r=e.selected,n=e.openToDate,o=ft(a.props),s=yt(a.props),i=Ye(),p=n||r||t;return p||(o&&Z(i,o)?o:s&&X(i,s)?s:i)})),ye(we(a),"increaseMonth",(function(){a.setState((function(e){var t=e.date;return {date:l(t,1)}}),(function(){return a.handleMonthChange(a.state.date)}));})),ye(we(a),"decreaseMonth",(function(){a.setState((function(e){var t=e.date;return {date:f(t,1)}}),(function(){return a.handleMonthChange(a.state.date)}));})),ye(we(a),"handleDayClick",(function(e,t,r){a.props.onSelect(e,t,r),a.props.setPreSelection&&a.props.setPreSelection(e);})),ye(we(a),"handleDayMouseEnter",(function(e){a.setState({selectingDate:e}),a.props.onDayMouseEnter&&a.props.onDayMouseEnter(e);})),ye(we(a),"handleMonthMouseLeave",(function(){a.setState({selectingDate:null}),a.props.onMonthMouseLeave&&a.props.onMonthMouseLeave();})),ye(we(a),"handleYearMouseEnter",(function(e,t){a.setState({selectingDate:I(Ye(),t)}),a.props.onYearMouseEnter&&a.props.onYearMouseEnter(e,t);})),ye(we(a),"handleYearMouseLeave",(function(e,t){a.props.onYearMouseLeave&&a.props.onYearMouseLeave(e,t);})),ye(we(a),"handleYearChange",(function(e){a.props.onYearChange&&(a.props.onYearChange(e),a.setState({isRenderAriaLiveMessage:!0})),a.props.adjustDateOnChange&&(a.props.onSelect&&a.props.onSelect(e),a.props.setOpen&&a.props.setOpen(!0)),a.props.setPreSelection&&a.props.setPreSelection(e);})),ye(we(a),"handleMonthChange",(function(e){a.handleCustomMonthChange(e),a.props.adjustDateOnChange&&(a.props.onSelect&&a.props.onSelect(e),a.props.setOpen&&a.props.setOpen(!0)),a.props.setPreSelection&&a.props.setPreSelection(e);})),ye(we(a),"handleCustomMonthChange",(function(e){a.props.onMonthChange&&(a.props.onMonthChange(e),a.setState({isRenderAriaLiveMessage:!0}));})),ye(we(a),"handleMonthYearChange",(function(e){a.handleYearChange(e),a.handleMonthChange(e);})),ye(we(a),"changeYear",(function(e){a.setState((function(t){var r=t.date;return {date:I(r,e)}}),(function(){return a.handleYearChange(a.state.date)}));})),ye(we(a),"changeMonth",(function(e){a.setState((function(t){var r=t.date;return {date:Y(r,e)}}),(function(){return a.handleMonthChange(a.state.date)}));})),ye(we(a),"changeMonthYear",(function(e){a.setState((function(t){var r=t.date;return {date:I(Y(r,C(e)),M(e))}}),(function(){return a.handleMonthYearChange(a.state.date)}));})),ye(we(a),"header",(function(){var t=Le(arguments.length>0&&void 0!==arguments[0]?arguments[0]:a.state.date,a.props.locale,a.props.calendarStartDay),n=[];return a.props.showWeekNumbers&&n.push(e__default.createElement("div",{key:"W",className:"react-datepicker__day-name"},a.props.weekLabel||"#")),n.concat([0,1,2,3,4,5,6].map((function(n){var o=p(t,n),s=a.formatWeekday(o,a.props.locale),i=a.props.weekDayClassName?a.props.weekDayClassName(o):void 0;return e__default.createElement("div",{key:n,className:r("react-datepicker__day-name",i)},s)})))})),ye(we(a),"formatWeekday",(function(e,t){return a.props.formatWeekDay?function(e,t,r){return t(Ie(e,"EEEE",r))}(e,a.props.formatWeekDay,t):a.props.useWeekdaysShort?function(e,t){return Ie(e,"EEE",t)}(e,t):function(e,t){return Ie(e,"EEEEEE",t)}(e,t)})),ye(we(a),"decreaseYear",(function(){a.setState((function(e){var t=e.date;return {date:v(t,a.props.showYearPicker?a.props.yearItemNumber:1)}}),(function(){return a.handleYearChange(a.state.date)}));})),ye(we(a),"clearSelectingDate",(function(){a.setState({selectingDate:null});})),ye(we(a),"renderPreviousButton",(function(){if(!a.props.renderCustomHeader){var t;switch(!0){case a.props.showMonthYearPicker:t=ht(a.state.date,a.props);break;case a.props.showYearPicker:t=function(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},r=t.minDate,n=t.yearItemNumber,o=void 0===n?Ne:n,a=wt(Ae(v(e,o)),o).endPeriod,s=r&&M(r);return s&&s>a||!1}(a.state.date,a.props);break;default:t=dt(a.state.date,a.props);}if((a.props.forceShowMonthNavigation||a.props.showDisabledMonthNavigation||!t)&&!a.props.showTimeSelectOnly){var r=["react-datepicker__navigation","react-datepicker__navigation--previous"],n=a.decreaseMonth;(a.props.showMonthYearPicker||a.props.showQuarterYearPicker||a.props.showYearPicker)&&(n=a.decreaseYear),t&&a.props.showDisabledMonthNavigation&&(r.push("react-datepicker__navigation--previous--disabled"),n=null);var o=a.props.showMonthYearPicker||a.props.showQuarterYearPicker||a.props.showYearPicker,s=a.props,i=s.previousMonthButtonLabel,p=s.previousYearButtonLabel,c=a.props,l=c.previousMonthAriaLabel,d=void 0===l?"string"==typeof i?i:"Previous Month":l,u=c.previousYearAriaLabel,h=void 0===u?"string"==typeof p?p:"Previous Year":u;return e__default.createElement("button",{type:"button",className:r.join(" "),onClick:n,onKeyDown:a.props.handleOnKeyDown,"aria-label":o?h:d},e__default.createElement("span",{className:["react-datepicker__navigation-icon","react-datepicker__navigation-icon--previous"].join(" ")},o?a.props.previousYearButtonLabel:a.props.previousMonthButtonLabel))}}})),ye(we(a),"increaseYear",(function(){a.setState((function(e){var t=e.date;return {date:u(t,a.props.showYearPicker?a.props.yearItemNumber:1)}}),(function(){return a.handleYearChange(a.state.date)}));})),ye(we(a),"renderNextButton",(function(){if(!a.props.renderCustomHeader){var t;switch(!0){case a.props.showMonthYearPicker:t=mt(a.state.date,a.props);break;case a.props.showYearPicker:t=function(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},r=t.maxDate,n=t.yearItemNumber,o=void 0===n?Ne:n,a=wt(u(e,o),o).startPeriod,s=r&&M(r);return s&&s<a||!1}(a.state.date,a.props);break;default:t=ut(a.state.date,a.props);}if((a.props.forceShowMonthNavigation||a.props.showDisabledMonthNavigation||!t)&&!a.props.showTimeSelectOnly){var r=["react-datepicker__navigation","react-datepicker__navigation--next"];a.props.showTimeSelect&&r.push("react-datepicker__navigation--next--with-time"),a.props.todayButton&&r.push("react-datepicker__navigation--next--with-today-button");var n=a.increaseMonth;(a.props.showMonthYearPicker||a.props.showQuarterYearPicker||a.props.showYearPicker)&&(n=a.increaseYear),t&&a.props.showDisabledMonthNavigation&&(r.push("react-datepicker__navigation--next--disabled"),n=null);var o=a.props.showMonthYearPicker||a.props.showQuarterYearPicker||a.props.showYearPicker,s=a.props,i=s.nextMonthButtonLabel,p=s.nextYearButtonLabel,c=a.props,l=c.nextMonthAriaLabel,d=void 0===l?"string"==typeof i?i:"Next Month":l,h=c.nextYearAriaLabel,m=void 0===h?"string"==typeof p?p:"Next Year":h;return e__default.createElement("button",{type:"button",className:r.join(" "),onClick:n,onKeyDown:a.props.handleOnKeyDown,"aria-label":o?m:d},e__default.createElement("span",{className:["react-datepicker__navigation-icon","react-datepicker__navigation-icon--next"].join(" ")},o?a.props.nextYearButtonLabel:a.props.nextMonthButtonLabel))}}})),ye(we(a),"renderCurrentMonth",(function(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:a.state.date,r=["react-datepicker__current-month"];return a.props.showYearDropdown&&r.push("react-datepicker__current-month--hasYearDropdown"),a.props.showMonthDropdown&&r.push("react-datepicker__current-month--hasMonthDropdown"),a.props.showMonthYearDropdown&&r.push("react-datepicker__current-month--hasMonthYearDropdown"),e__default.createElement("div",{className:r.join(" ")},Ie(t,a.props.dateFormat,a.props.locale))})),ye(we(a),"renderYearDropdown",(function(){var t=arguments.length>0&&void 0!==arguments[0]&&arguments[0];if(a.props.showYearDropdown&&!t)return e__default.createElement(_t,{adjustDateOnChange:a.props.adjustDateOnChange,date:a.state.date,onSelect:a.props.onSelect,setOpen:a.props.setOpen,dropdownMode:a.props.dropdownMode,onChange:a.changeYear,minDate:a.props.minDate,maxDate:a.props.maxDate,year:M(a.state.date),scrollableYearDropdown:a.props.scrollableYearDropdown,yearDropdownItemNumber:a.props.yearDropdownItemNumber})})),ye(we(a),"renderMonthDropdown",(function(){var t=arguments.length>0&&void 0!==arguments[0]&&arguments[0];if(a.props.showMonthDropdown&&!t)return e__default.createElement(Pt,{dropdownMode:a.props.dropdownMode,locale:a.props.locale,onChange:a.changeMonth,month:C(a.state.date),useShortMonthInDropdown:a.props.useShortMonthInDropdown})})),ye(we(a),"renderMonthYearDropdown",(function(){var t=arguments.length>0&&void 0!==arguments[0]&&arguments[0];if(a.props.showMonthYearDropdown&&!t)return e__default.createElement(xt,{dropdownMode:a.props.dropdownMode,locale:a.props.locale,dateFormat:a.props.dateFormat,onChange:a.changeMonthYear,minDate:a.props.minDate,maxDate:a.props.maxDate,date:a.state.date,scrollableMonthYearDropdown:a.props.scrollableMonthYearDropdown})})),ye(we(a),"handleTodayButtonClick",(function(e){a.props.onSelect(Ke(),e),a.props.setPreSelection&&a.props.setPreSelection(Ke());})),ye(we(a),"renderTodayButton",(function(){if(a.props.todayButton&&!a.props.showTimeSelectOnly)return e__default.createElement("div",{className:"react-datepicker__today-button",onClick:function(e){return a.handleTodayButtonClick(e)}},a.props.todayButton)})),ye(we(a),"renderDefaultHeader",(function(t){var r=t.monthDate,n=t.i;return e__default.createElement("div",{className:"react-datepicker__header ".concat(a.props.showTimeSelect?"react-datepicker__header--has-time-select":"")},a.renderCurrentMonth(r),e__default.createElement("div",{className:"react-datepicker__header__dropdown react-datepicker__header__dropdown--".concat(a.props.dropdownMode),onFocus:a.handleDropdownFocus},a.renderMonthDropdown(0!==n),a.renderMonthYearDropdown(0!==n),a.renderYearDropdown(0!==n)),e__default.createElement("div",{className:"react-datepicker__day-names"},a.header(r)))})),ye(we(a),"renderCustomHeader",(function(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},r=t.monthDate,n=t.i;if(a.props.showTimeSelect&&!a.state.monthContainer||a.props.showTimeSelectOnly)return null;var o=dt(a.state.date,a.props),s=ut(a.state.date,a.props),i=ht(a.state.date,a.props),p=mt(a.state.date,a.props),c=!a.props.showMonthYearPicker&&!a.props.showQuarterYearPicker&&!a.props.showYearPicker;return e__default.createElement("div",{className:"react-datepicker__header react-datepicker__header--custom",onFocus:a.props.onDropdownFocus},a.props.renderCustomHeader(de(de({},a.state),{},{customHeaderCount:n,monthDate:r,changeMonth:a.changeMonth,changeYear:a.changeYear,decreaseMonth:a.decreaseMonth,increaseMonth:a.increaseMonth,decreaseYear:a.decreaseYear,increaseYear:a.increaseYear,prevMonthButtonDisabled:o,nextMonthButtonDisabled:s,prevYearButtonDisabled:i,nextYearButtonDisabled:p})),c&&e__default.createElement("div",{className:"react-datepicker__day-names"},a.header(r)))})),ye(we(a),"renderYearHeader",(function(){var t=a.state.date,r=a.props,n=r.showYearPicker,o=wt(t,r.yearItemNumber),s=o.startPeriod,i=o.endPeriod;return e__default.createElement("div",{className:"react-datepicker__header react-datepicker-year-header"},n?"".concat(s," - ").concat(i):M(t))})),ye(we(a),"renderHeader",(function(e){switch(!0){case void 0!==a.props.renderCustomHeader:return a.renderCustomHeader(e);case a.props.showMonthYearPicker||a.props.showQuarterYearPicker||a.props.showYearPicker:return a.renderYearHeader(e);default:return a.renderDefaultHeader(e)}})),ye(we(a),"renderMonths",(function(){var t;if(!a.props.showTimeSelectOnly&&!a.props.showYearPicker){for(var r=[],n=a.props.showPreviousMonths?a.props.monthsShown-1:0,o=f(a.state.date,n),s=null!==(t=a.props.monthSelectedIn)&&void 0!==t?t:n,i=0;i<a.props.monthsShown;++i){var p=l(o,i-s+n),c="month-".concat(i),d=i<a.props.monthsShown-1,u=i>0;r.push(e__default.createElement("div",{key:c,ref:function(e){a.monthContainer=e;},className:"react-datepicker__month-container"},a.renderHeader({monthDate:p,i:i}),e__default.createElement(Wt,{chooseDayAriaLabelPrefix:a.props.chooseDayAriaLabelPrefix,disabledDayAriaLabelPrefix:a.props.disabledDayAriaLabelPrefix,weekAriaLabelPrefix:a.props.weekAriaLabelPrefix,ariaLabelPrefix:a.props.monthAriaLabelPrefix,onChange:a.changeMonthYear,day:p,dayClassName:a.props.dayClassName,calendarStartDay:a.props.calendarStartDay,monthClassName:a.props.monthClassName,onDayClick:a.handleDayClick,handleOnKeyDown:a.props.handleOnDayKeyDown,onDayMouseEnter:a.handleDayMouseEnter,onMouseLeave:a.handleMonthMouseLeave,onWeekSelect:a.props.onWeekSelect,orderInDisplay:i,formatWeekNumber:a.props.formatWeekNumber,locale:a.props.locale,minDate:a.props.minDate,maxDate:a.props.maxDate,excludeDates:a.props.excludeDates,excludeDateIntervals:a.props.excludeDateIntervals,highlightDates:a.props.highlightDates,holidays:a.props.holidays,selectingDate:a.state.selectingDate,includeDates:a.props.includeDates,includeDateIntervals:a.props.includeDateIntervals,inline:a.props.inline,shouldFocusDayInline:a.props.shouldFocusDayInline,fixedHeight:a.props.fixedHeight,filterDate:a.props.filterDate,preSelection:a.props.preSelection,setPreSelection:a.props.setPreSelection,selected:a.props.selected,selectsStart:a.props.selectsStart,selectsEnd:a.props.selectsEnd,selectsRange:a.props.selectsRange,selectsDisabledDaysInRange:a.props.selectsDisabledDaysInRange,showWeekNumbers:a.props.showWeekNumbers,startDate:a.props.startDate,endDate:a.props.endDate,peekNextMonth:a.props.peekNextMonth,setOpen:a.props.setOpen,shouldCloseOnSelect:a.props.shouldCloseOnSelect,renderDayContents:a.props.renderDayContents,renderMonthContent:a.props.renderMonthContent,renderQuarterContent:a.props.renderQuarterContent,renderYearContent:a.props.renderYearContent,disabledKeyboardNavigation:a.props.disabledKeyboardNavigation,showMonthYearPicker:a.props.showMonthYearPicker,showFullMonthYearPicker:a.props.showFullMonthYearPicker,showTwoColumnMonthYearPicker:a.props.showTwoColumnMonthYearPicker,showFourColumnMonthYearPicker:a.props.showFourColumnMonthYearPicker,showYearPicker:a.props.showYearPicker,showQuarterYearPicker:a.props.showQuarterYearPicker,showWeekPicker:a.props.showWeekPicker,isInputFocused:a.props.isInputFocused,containerRef:a.containerRef,monthShowsDuplicateDaysEnd:d,monthShowsDuplicateDaysStart:u})));}return r}})),ye(we(a),"renderYears",(function(){if(!a.props.showTimeSelectOnly)return a.props.showYearPicker?e__default.createElement("div",{className:"react-datepicker__year--container"},a.renderHeader(),e__default.createElement(Bt,ve({onDayClick:a.handleDayClick,selectingDate:a.state.selectingDate,clearSelectingDate:a.clearSelectingDate,date:a.state.date},a.props,{onYearMouseEnter:a.handleYearMouseEnter,onYearMouseLeave:a.handleYearMouseLeave}))):void 0})),ye(we(a),"renderTimeSection",(function(){if(a.props.showTimeSelect&&(a.state.monthContainer||a.props.showTimeSelectOnly))return e__default.createElement(Kt,{selected:a.props.selected,openToDate:a.props.openToDate,onChange:a.props.onTimeChange,timeClassName:a.props.timeClassName,format:a.props.timeFormat,includeTimes:a.props.includeTimes,intervals:a.props.timeIntervals,minTime:a.props.minTime,maxTime:a.props.maxTime,excludeTimes:a.props.excludeTimes,filterTime:a.props.filterTime,timeCaption:a.props.timeCaption,todayButton:a.props.todayButton,showMonthDropdown:a.props.showMonthDropdown,showMonthYearDropdown:a.props.showMonthYearDropdown,showYearDropdown:a.props.showYearDropdown,withPortal:a.props.withPortal,monthRef:a.state.monthContainer,injectTimes:a.props.injectTimes,locale:a.props.locale,handleOnKeyDown:a.props.handleOnKeyDown,showTimeSelectOnly:a.props.showTimeSelectOnly})})),ye(we(a),"renderInputTimeSection",(function(){var t=new Date(a.props.selected),r=Te(t)&&Boolean(a.props.selected)?"".concat(kt(t.getHours()),":").concat(kt(t.getMinutes())):"";if(a.props.showTimeInput)return e__default.createElement(Qt,{date:t,timeString:r,timeInputLabel:a.props.timeInputLabel,onChange:a.props.onTimeChange,customTimeInput:a.props.customTimeInput})})),ye(we(a),"renderAriaLiveRegion",(function(){var t,r=wt(a.state.date,a.props.yearItemNumber),n=r.startPeriod,o=r.endPeriod;return t=a.props.showYearPicker?"".concat(n," - ").concat(o):a.props.showMonthYearPicker||a.props.showQuarterYearPicker?M(a.state.date):"".concat(Je(C(a.state.date),a.props.locale)," ").concat(M(a.state.date)),e__default.createElement("span",{role:"alert","aria-live":"polite",className:"react-datepicker__aria-live"},a.state.isRenderAriaLiveMessage&&t)})),ye(we(a),"renderChildren",(function(){if(a.props.children)return e__default.createElement("div",{className:"react-datepicker__children-container"},a.props.children)})),a.containerRef=e__default.createRef(),a.state={date:a.getDateInView(),selectingDate:null,monthContainer:null,isRenderAriaLiveMessage:!1},a}return fe(o,[{key:"componentDidMount",value:function(){var e=this;this.props.showTimeSelect&&(this.assignMonthContainer=void e.setState({monthContainer:e.monthContainer}));}},{key:"componentDidUpdate",value:function(e){var t=this;if(!this.props.preSelection||je(this.props.preSelection,e.preSelection)&&this.props.monthSelectedIn===e.monthSelectedIn)this.props.openToDate&&!je(this.props.openToDate,e.openToDate)&&this.setState({date:this.props.openToDate});else {var r=!Qe(this.state.date,this.props.preSelection);this.setState({date:this.props.preSelection},(function(){return r&&t.handleCustomMonthChange(t.state.date)}));}}},{key:"render",value:function(){var t=this.props.container||Ht;return e__default.createElement("div",{style:{display:"contents"},ref:this.containerRef},e__default.createElement(t,{className:r("react-datepicker",this.props.className,{"react-datepicker--time-only":this.props.showTimeSelectOnly}),showPopperArrow:this.props.showPopperArrow,arrowProps:this.props.arrowProps},this.renderAriaLiveRegion(),this.renderPreviousButton(),this.renderNextButton(),this.renderMonths(),this.renderYears(),this.renderTodayButton(),this.renderTimeSection(),this.renderInputTimeSection(),this.renderChildren()))}}],[{key:"defaultProps",get:function(){return {onDropdownFocus:function(){},monthsShown:1,forceShowMonthNavigation:!1,timeCaption:"Time",previousYearButtonLabel:"Previous Year",nextYearButtonLabel:"Next Year",previousMonthButtonLabel:"Previous Month",nextMonthButtonLabel:"Next Month",customTimeInput:null,yearItemNumber:Ne}}}]),o}(),qt=function(t){var r=t.icon,n=t.className,o=void 0===n?"":n,a=t.onClick,s="react-datepicker__calendar-icon";return e__default.isValidElement(r)?e__default.cloneElement(r,{className:"".concat(r.props.className||""," ").concat(s," ").concat(o),onClick:function(e){"function"==typeof r.props.onClick&&r.props.onClick(e),"function"==typeof a&&a(e);}}):"string"==typeof r?e__default.createElement("i",{className:"".concat(s," ").concat(r," ").concat(o),"aria-hidden":"true",onClick:a}):e__default.createElement("svg",{className:"".concat(s," ").concat(o),xmlns:"http://www.w3.org/2000/svg",viewBox:"0 0 448 512",onClick:a},e__default.createElement("path",{d:"M96 32V64H48C21.5 64 0 85.5 0 112v48H448V112c0-26.5-21.5-48-48-48H352V32c0-17.7-14.3-32-32-32s-32 14.3-32 32V64H160V32c0-17.7-14.3-32-32-32S96 14.3 96 32zM448 192H0V464c0 26.5 21.5 48 48 48H400c26.5 0 48-21.5 48-48V192z"}))},Ut=function(t){De(n,e__default.Component);var r=be(n);function n(e){var t;return he(this,n),(t=r.call(this,e)).el=document.createElement("div"),t}return fe(n,[{key:"componentDidMount",value:function(){this.portalRoot=(this.props.portalHost||document).getElementById(this.props.portalId),this.portalRoot||(this.portalRoot=document.createElement("div"),this.portalRoot.setAttribute("id",this.props.portalId),(this.props.portalHost||document.body).appendChild(this.portalRoot)),this.portalRoot.appendChild(this.el);}},{key:"componentWillUnmount",value:function(){this.portalRoot.removeChild(this.el);}},{key:"render",value:function(){return ReactDOM__default.createPortal(this.props.children,this.el)}}]),n}(),zt=function(e){return !e.disabled&&-1!==e.tabIndex},$t=function(t){De(n,e__default.Component);var r=be(n);function n(t){var o;return he(this,n),ye(we(o=r.call(this,t)),"getTabChildren",(function(){return Array.prototype.slice.call(o.tabLoopRef.current.querySelectorAll("[tabindex], a, button, input, select, textarea"),1,-1).filter(zt)})),ye(we(o),"handleFocusStart",(function(){var e=o.getTabChildren();e&&e.length>1&&e[e.length-1].focus();})),ye(we(o),"handleFocusEnd",(function(){var e=o.getTabChildren();e&&e.length>1&&e[0].focus();})),o.tabLoopRef=e__default.createRef(),o}return fe(n,[{key:"render",value:function(){return this.props.enableTabLoop?e__default.createElement("div",{className:"react-datepicker__tab-loop",ref:this.tabLoopRef},e__default.createElement("div",{className:"react-datepicker__tab-loop__start",tabIndex:"0",onFocus:this.handleFocusStart}),this.props.children,e__default.createElement("div",{className:"react-datepicker__tab-loop__end",tabIndex:"0",onFocus:this.handleFocusEnd})):this.props.children}}],[{key:"defaultProps",get:function(){return {enableTabLoop:!0}}}]),n}(),Gt=function(t){De(o,e__default.Component);var n=be(o);function o(){return he(this,o),n.apply(this,arguments)}return fe(o,[{key:"render",value:function(){var t,n=this.props,o=n.className,a=n.wrapperClassName,s=n.hidePopper,i=n.popperComponent,p=n.popperModifiers,c=n.popperPlacement,l=n.popperProps,d=n.targetComponent,u=n.enableTabLoop,h=n.popperOnKeyDown,m=n.portalId,f=n.portalHost;if(!s){var y=r("react-datepicker-popper",o);t=e__default.createElement(Popper,ve({modifiers:p,placement:c},l),(function(t){var r=t.ref,n=t.style,o=t.placement,a=t.arrowProps;return e__default.createElement($t,{enableTabLoop:u},e__default.createElement("div",{ref:r,style:n,className:y,"data-placement":o,onKeyDown:h},e__default.cloneElement(i,{arrowProps:a})))}));}this.props.popperContainer&&(t=e__default.createElement(this.props.popperContainer,{},t)),m&&!s&&(t=e__default.createElement(Ut,{portalId:m,portalHost:f},t));var v=r("react-datepicker-wrapper",a);return e__default.createElement(Manager,{className:"react-datepicker-manager"},e__default.createElement(Reference,null,(function(t){var r=t.ref;return e__default.createElement("div",{ref:r,className:v},d)})),t)}}],[{key:"defaultProps",get:function(){return {hidePopper:!0,popperModifiers:[],popperProps:{},popperPlacement:"bottom-start"}}}]),o}(),Jt="react-datepicker-ignore-onclickoutside",Xt=onClickOutsideHOC(Vt);var Zt="Date input not valid.",er=function(t){De(s,e__default.Component);var a=be(s);function s(t){var i;return he(this,s),ye(we(i=a.call(this,t)),"getPreSelection",(function(){return i.props.openToDate?i.props.openToDate:i.props.selectsEnd&&i.props.startDate?i.props.startDate:i.props.selectsStart&&i.props.endDate?i.props.endDate:Ye()})),ye(we(i),"modifyHolidays",(function(){var e;return null===(e=i.props.holidays)||void 0===e?void 0:e.reduce((function(e,t){var r=new Date(t.date);return o(r)?[].concat(Se(e),[de(de({},t),{},{date:r})]):e}),[])})),ye(we(i),"calcInitialState",(function(){var e,t=i.getPreSelection(),r=ft(i.props),n=yt(i.props),o=r&&Z(t,W(r))?r:n&&X(t,j(n))?n:t;return {open:i.props.startOpen||!1,preventFocus:!1,preSelection:null!==(e=i.props.selectsRange?i.props.startDate:i.props.selected)&&void 0!==e?e:o,highlightDates:vt(i.props.highlightDates),focused:!1,shouldFocusDayInline:!1,isRenderAriaLiveMessage:!1}})),ye(we(i),"clearPreventFocusTimeout",(function(){i.preventFocusTimeout&&clearTimeout(i.preventFocusTimeout);})),ye(we(i),"setFocus",(function(){i.input&&i.input.focus&&i.input.focus({preventScroll:!0});})),ye(we(i),"setBlur",(function(){i.input&&i.input.blur&&i.input.blur(),i.cancelFocusInput();})),ye(we(i),"setOpen",(function(e){var t=arguments.length>1&&void 0!==arguments[1]&&arguments[1];i.setState({open:e,preSelection:e&&i.state.open?i.state.preSelection:i.calcInitialState().preSelection,lastPreSelectChange:rr},(function(){e||i.setState((function(e){return {focused:!!t&&e.focused}}),(function(){!t&&i.setBlur(),i.setState({inputValue:null});}));}));})),ye(we(i),"inputOk",(function(){return n(i.state.preSelection)})),ye(we(i),"isCalendarOpen",(function(){return void 0===i.props.open?i.state.open&&!i.props.disabled&&!i.props.readOnly:i.props.open})),ye(we(i),"handleFocus",(function(e){i.state.preventFocus||(i.props.onFocus(e),i.props.preventOpenOnFocus||i.props.readOnly||i.setOpen(!0)),i.setState({focused:!0});})),ye(we(i),"sendFocusBackToInput",(function(){i.preventFocusTimeout&&i.clearPreventFocusTimeout(),i.setState({preventFocus:!0},(function(){i.preventFocusTimeout=setTimeout((function(){i.setFocus(),i.setState({preventFocus:!1});}));}));})),ye(we(i),"cancelFocusInput",(function(){clearTimeout(i.inputFocusTimeout),i.inputFocusTimeout=null;})),ye(we(i),"deferFocusInput",(function(){i.cancelFocusInput(),i.inputFocusTimeout=setTimeout((function(){return i.setFocus()}),1);})),ye(we(i),"handleDropdownFocus",(function(){i.cancelFocusInput();})),ye(we(i),"handleBlur",(function(e){(!i.state.open||i.props.withPortal||i.props.showTimeInput)&&i.props.onBlur(e),i.setState({focused:!1});})),ye(we(i),"handleCalendarClickOutside",(function(e){i.props.inline||i.setOpen(!1),i.props.onClickOutside(e),i.props.withPortal&&e.preventDefault();})),ye(we(i),"handleChange",(function(){for(var e=arguments.length,t=new Array(e),r=0;r<e;r++)t[r]=arguments[r];var n=t[0];if(!i.props.onChangeRaw||(i.props.onChangeRaw.apply(we(i),t),"function"==typeof n.isDefaultPrevented&&!n.isDefaultPrevented())){i.setState({inputValue:n.target.value,lastPreSelectChange:tr});var o,a,s,p,c,l,d,u,h=(o=n.target.value,a=i.props.dateFormat,s=i.props.locale,p=i.props.strictParsing,c=i.props.minDate,l=null,d=Ge(s)||Ge($e()),u=!0,Array.isArray(a)?(a.forEach((function(e){var t=re(o,e,new Date,{locale:d});p&&(u=Te(t,c)&&o===Ie(t,e,s)),Te(t,c)&&u&&(l=t);})),l):(l=re(o,a,new Date,{locale:d}),p?u=Te(l)&&o===Ie(l,a,s):Te(l)||(a=a.match(xe).map((function(e){var t=e[0];return "p"===t||"P"===t?d?(0, Ee[t])(e,d.formatLong):t:e})).join(""),o.length>0&&(l=re(o,a.slice(0,o.length),new Date)),Te(l)||(l=new Date(o))),Te(l)&&u?l:null));i.props.showTimeSelectOnly&&i.props.selected&&h&&!je(h,i.props.selected)&&(h=ce(i.props.selected,{hours:k(h),minutes:g(h),seconds:D(h)})),!h&&n.target.value||(i.props.showWeekPicker&&(h=Le(h,i.props.locale,i.props.calendarStartDay)),i.setSelected(h,n,!0));}})),ye(we(i),"handleSelect",(function(e,t,r){if(i.props.shouldCloseOnSelect&&!i.props.showTimeSelect&&i.sendFocusBackToInput(),i.props.onChangeRaw&&i.props.onChangeRaw(t),i.props.showWeekPicker&&(e=Le(e,i.props.locale,i.props.calendarStartDay)),i.setSelected(e,t,!1,r),i.props.showDateSelect&&i.setState({isRenderAriaLiveMessage:!0}),!i.props.shouldCloseOnSelect||i.props.showTimeSelect)i.setPreSelection(e);else if(!i.props.inline){i.props.selectsRange||i.setOpen(!1);var n=i.props,o=n.startDate,a=n.endDate;!o||a||Z(e,o)||i.setOpen(!1);}})),ye(we(i),"setSelected",(function(e,t,r,n){var o=e;if(i.props.showYearPicker){if(null!==o&&at(M(o),i.props))return}else if(i.props.showMonthYearPicker){if(null!==o&&tt(o,i.props))return}else if(null!==o&&Ze(o,i.props))return;var a=i.props,s=a.onChange,p=a.selectsRange,c=a.startDate,l=a.endDate;if(!Ve(i.props.selected,o)||i.props.allowSameDay||p)if(null!==o&&(!i.props.selected||r&&(i.props.showTimeSelect||i.props.showTimeSelectOnly||i.props.showTimeInput)||(o=Re(o,{hour:k(i.props.selected),minute:g(i.props.selected),second:D(i.props.selected)})),i.props.inline||i.setState({preSelection:o}),i.props.focusSelectedMonth||i.setState({monthSelectedIn:n})),p){var d=c&&!l,u=c&&l;!c&&!l?s([o,null],t):d&&(Z(o,c)?s([o,null],t):s([c,o],t)),u&&s([o,null],t);}else s(o,t);r||(i.props.onSelect(o,t),i.setState({inputValue:null}));})),ye(we(i),"setPreSelection",(function(e){var t=void 0!==i.props.minDate,r=void 0!==i.props.maxDate,n=!0;if(e){i.props.showWeekPicker&&(e=Le(e,i.props.locale,i.props.calendarStartDay));var o=W(e);if(t&&r)n=qe(e,i.props.minDate,i.props.maxDate);else if(t){var a=W(i.props.minDate);n=X(e,a)||Ve(o,a);}else if(r){var s=j(i.props.maxDate);n=Z(e,s)||Ve(o,s);}}n&&i.setState({preSelection:e});})),ye(we(i),"toggleCalendar",(function(){i.setOpen(!i.state.open);})),ye(we(i),"handleTimeChange",(function(e){var t=i.props.selected?i.props.selected:i.getPreSelection(),r=i.props.selected?e:Re(t,{hour:k(e),minute:g(e)});i.setState({preSelection:r}),i.props.onChange(r),i.props.shouldCloseOnSelect&&(i.sendFocusBackToInput(),i.setOpen(!1)),i.props.showTimeInput&&i.setOpen(!0),(i.props.showTimeSelectOnly||i.props.showTimeSelect)&&i.setState({isRenderAriaLiveMessage:!0}),i.setState({inputValue:null});})),ye(we(i),"onInputClick",(function(){i.props.disabled||i.props.readOnly||i.setOpen(!0),i.props.onInputClick();})),ye(we(i),"onInputKeyDown",(function(e){i.props.onKeyDown(e);var t=e.key;if(i.state.open||i.props.inline||i.props.preventOpenOnFocus){if(i.state.open){if("ArrowDown"===t||"ArrowUp"===t){e.preventDefault();var r=i.props.showWeekPicker&&i.props.showWeekNumbers?'.react-datepicker__week-number[tabindex="0"]':'.react-datepicker__day[tabindex="0"]',n=i.calendar.componentNode&&i.calendar.componentNode.querySelector(r);return void(n&&n.focus({preventScroll:!0}))}var o=Ye(i.state.preSelection);"Enter"===t?(e.preventDefault(),i.inputOk()&&i.state.lastPreSelectChange===rr?(i.handleSelect(o,e),!i.props.shouldCloseOnSelect&&i.setPreSelection(o)):i.setOpen(!1)):"Escape"===t?(e.preventDefault(),i.sendFocusBackToInput(),i.setOpen(!1)):"Tab"===t&&i.setOpen(!1),i.inputOk()||i.props.onInputError({code:1,msg:Zt});}}else "ArrowDown"!==t&&"ArrowUp"!==t&&"Enter"!==t||i.onInputClick();})),ye(we(i),"onPortalKeyDown",(function(e){"Escape"===e.key&&(e.preventDefault(),i.setState({preventFocus:!0},(function(){i.setOpen(!1),setTimeout((function(){i.setFocus(),i.setState({preventFocus:!1});}));})));})),ye(we(i),"onDayKeyDown",(function(e){i.props.onKeyDown(e);var t=e.key,r=Ye(i.state.preSelection);if("Enter"===t)e.preventDefault(),i.handleSelect(r,e),!i.props.shouldCloseOnSelect&&i.setPreSelection(r);else if("Escape"===t)e.preventDefault(),i.setOpen(!1),i.inputOk()||i.props.onInputError({code:1,msg:Zt});else if(!i.props.disabledKeyboardNavigation){var n;switch(t){case"ArrowLeft":n=i.props.showWeekPicker?m(r,1):h(r,1);break;case"ArrowRight":n=i.props.showWeekPicker?c(r,1):p(r,1);break;case"ArrowUp":n=m(r,1);break;case"ArrowDown":n=c(r,1);break;case"PageUp":n=f(r,1);break;case"PageDown":n=l(r,1);break;case"Home":n=v(r,1);break;case"End":n=u(r,1);break;default:n=null;}if(!n)return void(i.props.onInputError&&i.props.onInputError({code:1,msg:Zt}));if(e.preventDefault(),i.setState({lastPreSelectChange:rr}),i.props.adjustDateOnChange&&i.setSelected(n),i.setPreSelection(n),i.props.inline){var o=C(r),a=C(n),s=M(r),d=M(n);o!==a||s!==d?i.setState({shouldFocusDayInline:!0}):i.setState({shouldFocusDayInline:!1});}}})),ye(we(i),"onPopperKeyDown",(function(e){"Escape"===e.key&&(e.preventDefault(),i.sendFocusBackToInput());})),ye(we(i),"onClearClick",(function(e){e&&e.preventDefault&&e.preventDefault(),i.sendFocusBackToInput(),i.props.selectsRange?i.props.onChange([null,null],e):i.props.onChange(null,e),i.setState({inputValue:null});})),ye(we(i),"clear",(function(){i.onClearClick();})),ye(we(i),"onScroll",(function(e){"boolean"==typeof i.props.closeOnScroll&&i.props.closeOnScroll?e.target!==document&&e.target!==document.documentElement&&e.target!==document.body||i.setOpen(!1):"function"==typeof i.props.closeOnScroll&&i.props.closeOnScroll(e)&&i.setOpen(!1);})),ye(we(i),"renderCalendar",(function(){return i.props.inline||i.isCalendarOpen()?e__default.createElement(Xt,{ref:function(e){i.calendar=e;},locale:i.props.locale,calendarStartDay:i.props.calendarStartDay,chooseDayAriaLabelPrefix:i.props.chooseDayAriaLabelPrefix,disabledDayAriaLabelPrefix:i.props.disabledDayAriaLabelPrefix,weekAriaLabelPrefix:i.props.weekAriaLabelPrefix,monthAriaLabelPrefix:i.props.monthAriaLabelPrefix,adjustDateOnChange:i.props.adjustDateOnChange,setOpen:i.setOpen,shouldCloseOnSelect:i.props.shouldCloseOnSelect,dateFormat:i.props.dateFormatCalendar,useWeekdaysShort:i.props.useWeekdaysShort,formatWeekDay:i.props.formatWeekDay,dropdownMode:i.props.dropdownMode,selected:i.props.selected,preSelection:i.state.preSelection,onSelect:i.handleSelect,onWeekSelect:i.props.onWeekSelect,openToDate:i.props.openToDate,minDate:i.props.minDate,maxDate:i.props.maxDate,selectsStart:i.props.selectsStart,selectsEnd:i.props.selectsEnd,selectsRange:i.props.selectsRange,startDate:i.props.startDate,endDate:i.props.endDate,excludeDates:i.props.excludeDates,excludeDateIntervals:i.props.excludeDateIntervals,filterDate:i.props.filterDate,onClickOutside:i.handleCalendarClickOutside,formatWeekNumber:i.props.formatWeekNumber,highlightDates:i.state.highlightDates,holidays:Dt(i.modifyHolidays()),includeDates:i.props.includeDates,includeDateIntervals:i.props.includeDateIntervals,includeTimes:i.props.includeTimes,injectTimes:i.props.injectTimes,inline:i.props.inline,shouldFocusDayInline:i.state.shouldFocusDayInline,peekNextMonth:i.props.peekNextMonth,showMonthDropdown:i.props.showMonthDropdown,showPreviousMonths:i.props.showPreviousMonths,useShortMonthInDropdown:i.props.useShortMonthInDropdown,showMonthYearDropdown:i.props.showMonthYearDropdown,showWeekNumbers:i.props.showWeekNumbers,showYearDropdown:i.props.showYearDropdown,withPortal:i.props.withPortal,forceShowMonthNavigation:i.props.forceShowMonthNavigation,showDisabledMonthNavigation:i.props.showDisabledMonthNavigation,scrollableYearDropdown:i.props.scrollableYearDropdown,scrollableMonthYearDropdown:i.props.scrollableMonthYearDropdown,todayButton:i.props.todayButton,weekLabel:i.props.weekLabel,outsideClickIgnoreClass:Jt,fixedHeight:i.props.fixedHeight,monthsShown:i.props.monthsShown,monthSelectedIn:i.state.monthSelectedIn,onDropdownFocus:i.handleDropdownFocus,onMonthChange:i.props.onMonthChange,onYearChange:i.props.onYearChange,dayClassName:i.props.dayClassName,weekDayClassName:i.props.weekDayClassName,monthClassName:i.props.monthClassName,timeClassName:i.props.timeClassName,showDateSelect:i.props.showDateSelect,showTimeSelect:i.props.showTimeSelect,showTimeSelectOnly:i.props.showTimeSelectOnly,onTimeChange:i.handleTimeChange,timeFormat:i.props.timeFormat,timeIntervals:i.props.timeIntervals,minTime:i.props.minTime,maxTime:i.props.maxTime,excludeTimes:i.props.excludeTimes,filterTime:i.props.filterTime,timeCaption:i.props.timeCaption,className:i.props.calendarClassName,container:i.props.calendarContainer,yearItemNumber:i.props.yearItemNumber,yearDropdownItemNumber:i.props.yearDropdownItemNumber,previousMonthAriaLabel:i.props.previousMonthAriaLabel,previousMonthButtonLabel:i.props.previousMonthButtonLabel,nextMonthAriaLabel:i.props.nextMonthAriaLabel,nextMonthButtonLabel:i.props.nextMonthButtonLabel,previousYearAriaLabel:i.props.previousYearAriaLabel,previousYearButtonLabel:i.props.previousYearButtonLabel,nextYearAriaLabel:i.props.nextYearAriaLabel,nextYearButtonLabel:i.props.nextYearButtonLabel,timeInputLabel:i.props.timeInputLabel,disabledKeyboardNavigation:i.props.disabledKeyboardNavigation,renderCustomHeader:i.props.renderCustomHeader,popperProps:i.props.popperProps,renderDayContents:i.props.renderDayContents,renderMonthContent:i.props.renderMonthContent,renderQuarterContent:i.props.renderQuarterContent,renderYearContent:i.props.renderYearContent,onDayMouseEnter:i.props.onDayMouseEnter,onMonthMouseLeave:i.props.onMonthMouseLeave,onYearMouseEnter:i.props.onYearMouseEnter,onYearMouseLeave:i.props.onYearMouseLeave,selectsDisabledDaysInRange:i.props.selectsDisabledDaysInRange,showTimeInput:i.props.showTimeInput,showMonthYearPicker:i.props.showMonthYearPicker,showFullMonthYearPicker:i.props.showFullMonthYearPicker,showTwoColumnMonthYearPicker:i.props.showTwoColumnMonthYearPicker,showFourColumnMonthYearPicker:i.props.showFourColumnMonthYearPicker,showYearPicker:i.props.showYearPicker,showQuarterYearPicker:i.props.showQuarterYearPicker,showWeekPicker:i.props.showWeekPicker,showPopperArrow:i.props.showPopperArrow,excludeScrollbar:i.props.excludeScrollbar,handleOnKeyDown:i.props.onKeyDown,handleOnDayKeyDown:i.onDayKeyDown,isInputFocused:i.state.focused,customTimeInput:i.props.customTimeInput,setPreSelection:i.setPreSelection},i.props.children):null})),ye(we(i),"renderAriaLiveRegion",(function(){var t,r=i.props,n=r.dateFormat,o=r.locale,a=i.props.showTimeInput||i.props.showTimeSelect?"PPPPp":"PPPP";return t=i.props.selectsRange?"Selected start date: ".concat(Oe(i.props.startDate,{dateFormat:a,locale:o}),". ").concat(i.props.endDate?"End date: "+Oe(i.props.endDate,{dateFormat:a,locale:o}):""):i.props.showTimeSelectOnly?"Selected time: ".concat(Oe(i.props.selected,{dateFormat:n,locale:o})):i.props.showYearPicker?"Selected year: ".concat(Oe(i.props.selected,{dateFormat:"yyyy",locale:o})):i.props.showMonthYearPicker?"Selected month: ".concat(Oe(i.props.selected,{dateFormat:"MMMM yyyy",locale:o})):i.props.showQuarterYearPicker?"Selected quarter: ".concat(Oe(i.props.selected,{dateFormat:"yyyy, QQQ",locale:o})):"Selected date: ".concat(Oe(i.props.selected,{dateFormat:a,locale:o})),e__default.createElement("span",{role:"alert","aria-live":"polite",className:"react-datepicker__aria-live"},t)})),ye(we(i),"renderDateInput",(function(){var t,n=r(i.props.className,ye({},Jt,i.state.open)),o=i.props.customInput||e__default.createElement("input",{type:"text"}),a=i.props.customInputRef||"ref",s="string"==typeof i.props.value?i.props.value:"string"==typeof i.state.inputValue?i.state.inputValue:i.props.selectsRange?function(e,t,r){if(!e)return "";var n=Oe(e,r),o=t?Oe(t,r):"";return "".concat(n," - ").concat(o)}(i.props.startDate,i.props.endDate,i.props):Oe(i.props.selected,i.props);return e__default.cloneElement(o,(ye(ye(ye(ye(ye(ye(ye(ye(ye(ye(t={},a,(function(e){i.input=e;})),"value",s),"onBlur",i.handleBlur),"onChange",i.handleChange),"onClick",i.onInputClick),"onFocus",i.handleFocus),"onKeyDown",i.onInputKeyDown),"id",i.props.id),"name",i.props.name),"form",i.props.form),ye(ye(ye(ye(ye(ye(ye(ye(ye(ye(t,"autoFocus",i.props.autoFocus),"placeholder",i.props.placeholderText),"disabled",i.props.disabled),"autoComplete",i.props.autoComplete),"className",r(o.props.className,n)),"title",i.props.title),"readOnly",i.props.readOnly),"required",i.props.required),"tabIndex",i.props.tabIndex),"aria-describedby",i.props.ariaDescribedBy),ye(ye(ye(t,"aria-invalid",i.props.ariaInvalid),"aria-labelledby",i.props.ariaLabelledBy),"aria-required",i.props.ariaRequired)))})),ye(we(i),"renderClearButton",(function(){var t=i.props,n=t.isClearable,o=t.disabled,a=t.selected,s=t.startDate,p=t.endDate,c=t.clearButtonTitle,l=t.clearButtonClassName,d=void 0===l?"":l,u=t.ariaLabelClose,h=void 0===u?"Close":u;return !n||null==a&&null==s&&null==p?null:e__default.createElement("button",{type:"button",className:r("react-datepicker__close-icon",d,{"react-datepicker__close-icon--disabled":o}),disabled:o,"aria-label":h,onClick:i.onClearClick,title:c,tabIndex:-1})})),i.state=i.calcInitialState(),i.preventFocusTimeout=null,i}return fe(s,[{key:"componentDidMount",value:function(){window.addEventListener("scroll",this.onScroll,!0);}},{key:"componentDidUpdate",value:function(e,t){var r,n;e.inline&&(r=e.selected,n=this.props.selected,r&&n?C(r)!==C(n)||M(r)!==M(n):r!==n)&&this.setPreSelection(this.props.selected),void 0!==this.state.monthSelectedIn&&e.monthsShown!==this.props.monthsShown&&this.setState({monthSelectedIn:0}),e.highlightDates!==this.props.highlightDates&&this.setState({highlightDates:vt(this.props.highlightDates)}),t.focused||Ve(e.selected,this.props.selected)||this.setState({inputValue:null}),t.open!==this.state.open&&(!1===t.open&&!0===this.state.open&&this.props.onCalendarOpen(),!0===t.open&&!1===this.state.open&&this.props.onCalendarClose());}},{key:"componentWillUnmount",value:function(){this.clearPreventFocusTimeout(),window.removeEventListener("scroll",this.onScroll,!0);}},{key:"renderInputContainer",value:function(){var t=this.props,r=t.showIcon,n=t.icon,o=t.calendarIconClassname,a=t.toggleCalendarOnIconClick,s=this.state.open;return e__default.createElement("div",{className:"react-datepicker__input-container".concat(r?" react-datepicker__view-calendar-icon":"")},r&&e__default.createElement(qt,ve({icon:n,className:"".concat(o," ").concat(s&&"react-datepicker-ignore-onclickoutside")},a?{onClick:this.toggleCalendar}:null)),this.state.isRenderAriaLiveMessage&&this.renderAriaLiveRegion(),this.renderDateInput(),this.renderClearButton())}},{key:"render",value:function(){var t=this.renderCalendar();if(this.props.inline)return t;if(this.props.withPortal){var r=this.state.open?e__default.createElement($t,{enableTabLoop:this.props.enableTabLoop},e__default.createElement("div",{className:"react-datepicker__portal",tabIndex:-1,onKeyDown:this.onPortalKeyDown},t)):null;return this.state.open&&this.props.portalId&&(r=e__default.createElement(Ut,{portalId:this.props.portalId,portalHost:this.props.portalHost},r)),e__default.createElement("div",null,this.renderInputContainer(),r)}return e__default.createElement(Gt,{className:this.props.popperClassName,wrapperClassName:this.props.wrapperClassName,hidePopper:!this.isCalendarOpen(),portalId:this.props.portalId,portalHost:this.props.portalHost,popperModifiers:this.props.popperModifiers,targetComponent:this.renderInputContainer(),popperContainer:this.props.popperContainer,popperComponent:t,popperPlacement:this.props.popperPlacement,popperProps:this.props.popperProps,popperOnKeyDown:this.onPopperKeyDown,enableTabLoop:this.props.enableTabLoop})}}],[{key:"defaultProps",get:function(){return {allowSameDay:!1,dateFormat:"MM/dd/yyyy",dateFormatCalendar:"LLLL yyyy",onChange:function(){},disabled:!1,disabledKeyboardNavigation:!1,dropdownMode:"scroll",onFocus:function(){},onBlur:function(){},onKeyDown:function(){},onInputClick:function(){},onSelect:function(){},onClickOutside:function(){},onMonthChange:function(){},onCalendarOpen:function(){},onCalendarClose:function(){},preventOpenOnFocus:!1,onYearChange:function(){},onInputError:function(){},monthsShown:1,readOnly:!1,withPortal:!1,selectsDisabledDaysInRange:!1,shouldCloseOnSelect:!0,showTimeSelect:!1,showTimeInput:!1,showPreviousMonths:!1,showMonthYearPicker:!1,showFullMonthYearPicker:!1,showTwoColumnMonthYearPicker:!1,showFourColumnMonthYearPicker:!1,showYearPicker:!1,showQuarterYearPicker:!1,showWeekPicker:!1,strictParsing:!1,timeIntervals:30,timeCaption:"Time",previousMonthAriaLabel:"Previous Month",previousMonthButtonLabel:"Previous Month",nextMonthAriaLabel:"Next Month",nextMonthButtonLabel:"Next Month",previousYearAriaLabel:"Previous Year",previousYearButtonLabel:"Previous Year",nextYearAriaLabel:"Next Year",nextYearButtonLabel:"Next Year",timeInputLabel:"Time",enableTabLoop:!0,yearItemNumber:Ne,focusSelectedMonth:!1,showPopperArrow:!0,excludeScrollbar:!0,customTimeInput:null,calendarStartDay:void 0,toggleCalendarOnIconClick:!1}}}]),s}(),tr="input",rr="navigate";

/**
 * This is a generated file. It is made by converting the raw CSS file that comes with the react-datepicker library
 * from CSS to JSS.
 */
var useStylesReactDatepicker = createMemoStyles({
  reactDatepicker: {
    boxSizing: 'border-box',
    '& .react-datepicker__year-read-view--down-arrow, & .react-datepicker__month-read-view--down-arrow, & .react-datepicker__month-year-read-view--down-arrow, & .react-datepicker__navigation-icon::before': {
      borderColor: '#ccc',
      borderStyle: 'solid',
      borderWidth: '3px 3px 0 0',
      content: '""',
      display: 'block',
      height: '9px',
      position: 'absolute',
      top: '6px',
      width: '9px'
    },
    '& .react-datepicker-popper[data-placement^=top] .react-datepicker__triangle, & .react-datepicker-popper[data-placement^=bottom] .react-datepicker__triangle': {
      marginLeft: '-4px',
      position: 'absolute',
      width: '0'
    },
    '& .react-datepicker-popper[data-placement^=top] .react-datepicker__triangle::before, & .react-datepicker-popper[data-placement^=bottom] .react-datepicker__triangle::before, & .react-datepicker-popper[data-placement^=top] .react-datepicker__triangle::after, & .react-datepicker-popper[data-placement^=bottom] .react-datepicker__triangle::after': {
      boxSizing: 'content-box',
      position: 'absolute',
      border: '8px solid transparent',
      height: '0',
      width: '1px',
      content: '""',
      zIndex: '-1',
      borderWidth: '8px',
      left: '-8px'
    },
    '& .react-datepicker-popper[data-placement^=top] .react-datepicker__triangle::before, & .react-datepicker-popper[data-placement^=bottom] .react-datepicker__triangle::before': {
      borderBottomColor: '#aeaeae'
    },
    '& .react-datepicker-popper[data-placement^=bottom] .react-datepicker__triangle': {
      top: '0',
      marginTop: '-8px'
    },
    '& .react-datepicker-popper[data-placement^=bottom] .react-datepicker__triangle::before, & .react-datepicker-popper[data-placement^=bottom] .react-datepicker__triangle::after': {
      borderTop: 'none',
      borderBottomColor: '#f0f0f0'
    },
    '& .react-datepicker-popper[data-placement^=bottom] .react-datepicker__triangle::after': {
      top: '0'
    },
    '& .react-datepicker-popper[data-placement^=bottom] .react-datepicker__triangle::before': {
      top: '-1px',
      borderBottomColor: '#aeaeae'
    },
    '& .react-datepicker-popper[data-placement^=top] .react-datepicker__triangle': {
      bottom: '0',
      marginBottom: '-8px'
    },
    '& .react-datepicker-popper[data-placement^=top] .react-datepicker__triangle::before, & .react-datepicker-popper[data-placement^=top] .react-datepicker__triangle::after': {
      borderBottom: 'none',
      borderTopColor: '#fff'
    },
    '& .react-datepicker-popper[data-placement^=top] .react-datepicker__triangle::after': {
      bottom: '0'
    },
    '& .react-datepicker-popper[data-placement^=top] .react-datepicker__triangle::before': {
      bottom: '-1px',
      borderTopColor: '#aeaeae'
    },
    '& .react-datepicker-wrapper': {
      display: 'inline-block',
      padding: '0',
      border: '0',
      width: '100%'
    },
    '& .react-datepicker': {
      fontFamily: '"Helvetica Neue", helvetica, arial, sans-serif',
      fontSize: '0.8rem',
      backgroundColor: '#fff',
      color: '#000',
      border: '1px solid #aeaeae',
      borderRadius: '0.3rem',
      display: 'inline-block',
      position: 'relative'
    },
    '& .react-datepicker--time-only .react-datepicker__triangle': {
      left: '35px'
    },
    '& .react-datepicker--time-only .react-datepicker__time-container': {
      borderLeft: '0'
    },
    '& .react-datepicker--time-only .react-datepicker__time, & .react-datepicker--time-only .react-datepicker__time-box': {
      borderBottomLeftRadius: '0.3rem',
      borderBottomRightRadius: '0.3rem'
    },
    '& .react-datepicker__triangle': {
      position: 'absolute',
      left: '50px'
    },
    '& .react-datepicker-popper': {
      zIndex: '1'
    },
    '& .react-datepicker-popper[data-placement^=bottom]': {
      paddingTop: '10px'
    },
    '& .react-datepicker-popper[data-placement=bottom-end] .react-datepicker__triangle, & .react-datepicker-popper[data-placement=top-end] .react-datepicker__triangle': {
      left: 'auto',
      right: '50px'
    },
    '& .react-datepicker-popper[data-placement^=top]': {
      paddingBottom: '10px'
    },
    '& .react-datepicker-popper[data-placement^=right]': {
      paddingLeft: '8px'
    },
    '& .react-datepicker-popper[data-placement^=right] .react-datepicker__triangle': {
      left: 'auto',
      right: '42px'
    },
    '& .react-datepicker-popper[data-placement^=left]': {
      paddingRight: '8px'
    },
    '& .react-datepicker-popper[data-placement^=left] .react-datepicker__triangle': {
      left: '42px',
      right: 'auto'
    },
    '& .react-datepicker__header': {
      textAlign: 'center',
      backgroundColor: '#f0f0f0',
      borderBottom: '1px solid #aeaeae',
      borderTopLeftRadius: '0.3rem',
      padding: '8px 0',
      position: 'relative'
    },
    '& .react-datepicker__header--time': {
      paddingBottom: '8px',
      paddingLeft: '5px',
      paddingRight: '5px'
    },
    '& .react-datepicker__header--time:not(.react-datepicker__header--time--only)': {
      borderTopLeftRadius: '0'
    },
    '& .react-datepicker__header:not(.react-datepicker__header--has-time-select)': {
      borderTopRightRadius: '0.3rem'
    },
    '& .react-datepicker__year-dropdown-container--select, & .react-datepicker__month-dropdown-container--select, & .react-datepicker__month-year-dropdown-container--select, & .react-datepicker__year-dropdown-container--scroll, & .react-datepicker__month-dropdown-container--scroll, & .react-datepicker__month-year-dropdown-container--scroll': {
      display: 'inline-block',
      margin: '0 15px'
    },
    '& .react-datepicker__current-month, & .react-datepicker-time__header, & .react-datepicker-year-header': {
      marginTop: '0',
      color: '#000',
      fontWeight: 'bold',
      fontSize: '0.944rem'
    },
    '& .react-datepicker-time__header': {
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
      overflow: 'hidden'
    },
    '& .react-datepicker__navigation': {
      alignItems: 'center',
      background: 'none',
      display: 'flex',
      justifyContent: 'center',
      textAlign: 'center',
      cursor: 'pointer',
      position: 'absolute',
      top: '2px',
      padding: '0',
      border: 'none',
      zIndex: '1',
      height: '32px',
      width: '32px',
      textIndent: '-999em',
      overflow: 'hidden'
    },
    '& .react-datepicker__navigation--previous': {
      left: '2px'
    },
    '& .react-datepicker__navigation--next': {
      right: '2px'
    },
    '& .react-datepicker__navigation--next--with-time:not(.react-datepicker__navigation--next--with-today-button)': {
      right: '85px'
    },
    '& .react-datepicker__navigation--years': {
      position: 'relative',
      top: '0',
      display: 'block',
      marginLeft: 'auto',
      marginRight: 'auto'
    },
    '& .react-datepicker__navigation--years-previous': {
      top: '4px'
    },
    '& .react-datepicker__navigation--years-upcoming': {
      top: '-4px'
    },
    '& .react-datepicker__navigation:hover *::before': {
      borderColor: '#a6a6a6'
    },
    '& .react-datepicker__navigation-icon': {
      position: 'relative',
      top: '-1px',
      fontSize: '20px',
      width: '0'
    },
    '& .react-datepicker__navigation-icon--next': {
      left: '-2px'
    },
    '& .react-datepicker__navigation-icon--next::before': {
      transform: 'rotate(45deg)',
      left: '-7px'
    },
    '& .react-datepicker__navigation-icon--previous': {
      right: '-2px'
    },
    '& .react-datepicker__navigation-icon--previous::before': {
      transform: 'rotate(225deg)',
      right: '-7px'
    },
    '& .react-datepicker__month-container': {
      float: 'left'
    },
    '& .react-datepicker__year': {
      margin: '0.4rem',
      textAlign: 'center'
    },
    '& .react-datepicker__year-wrapper': {
      display: 'flex',
      flexWrap: 'wrap',
      maxWidth: '180px'
    },
    '& .react-datepicker__year .react-datepicker__year-text': {
      display: 'inline-block',
      width: '4rem',
      margin: '2px'
    },
    '& .react-datepicker__month': {
      margin: '0.4rem',
      textAlign: 'center'
    },
    '& .react-datepicker__month .react-datepicker__month-text, & .react-datepicker__month .react-datepicker__quarter-text': {
      display: 'inline-block',
      width: '4rem',
      margin: '2px'
    },
    '& .react-datepicker__input-time-container': {
      clear: 'both',
      width: '100%',
      float: 'left',
      margin: '5px 0 10px 15px',
      textAlign: 'left'
    },
    '& .react-datepicker__input-time-container .react-datepicker-time__caption': {
      display: 'inline-block'
    },
    '& .react-datepicker__input-time-container .react-datepicker-time__input-container': {
      display: 'inline-block'
    },
    '& .react-datepicker__input-time-container .react-datepicker-time__input-container .react-datepicker-time__input': {
      display: 'inline-block',
      marginLeft: '10px'
    },
    '& .react-datepicker__input-time-container .react-datepicker-time__input-container .react-datepicker-time__input input': {
      width: 'auto'
    },
    '& .react-datepicker__input-time-container .react-datepicker-time__input-container .react-datepicker-time__input input[type=time]::-webkit-inner-spin-button, & .react-datepicker__input-time-container .react-datepicker-time__input-container .react-datepicker-time__input input[type=time]::-webkit-outer-spin-button': {
      webkitAppearance: 'none',
      margin: '0'
    },
    '& .react-datepicker__input-time-container .react-datepicker-time__input-container .react-datepicker-time__input input[type=time]': {
      mozAppearance: 'textfield'
    },
    '& .react-datepicker__input-time-container .react-datepicker-time__input-container .react-datepicker-time__delimiter': {
      marginLeft: '5px',
      display: 'inline-block'
    },
    '& .react-datepicker__time-container': {
      float: 'right',
      borderLeft: '1px solid #aeaeae',
      width: '85px'
    },
    '& .react-datepicker__time-container--with-today-button': {
      display: 'inline',
      border: '1px solid #aeaeae',
      borderRadius: '0.3rem',
      position: 'absolute',
      right: '-87px',
      top: '0'
    },
    '& .react-datepicker__time-container .react-datepicker__time': {
      position: 'relative',
      background: 'white',
      borderBottomRightRadius: '0.3rem'
    },
    '& .react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box': {
      width: '85px',
      overflowX: 'hidden',
      margin: '0 auto',
      textAlign: 'center',
      borderBottomRightRadius: '0.3rem'
    },
    '& .react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list': {
      listStyle: 'none',
      margin: '0',
      height: 'calc(195px + (1.7rem / 2))',
      overflowY: 'scroll',
      paddingRight: '0',
      paddingLeft: '0',
      width: '100%',
      boxSizing: 'content-box'
    },
    '& .react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list li.react-datepicker__time-list-item': {
      height: '30px',
      padding: '5px 10px',
      whiteSpace: 'nowrap'
    },
    '& .react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list li.react-datepicker__time-list-item:hover': {
      cursor: 'pointer',
      backgroundColor: '#f0f0f0'
    },
    '& .react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list li.react-datepicker__time-list-item--selected': {
      backgroundColor: '#216ba5',
      color: 'white',
      fontWeight: 'bold'
    },
    '& .react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list li.react-datepicker__time-list-item--selected:hover': {
      backgroundColor: '#216ba5'
    },
    '& .react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list li.react-datepicker__time-list-item--disabled': {
      color: '#ccc'
    },
    '& .react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list li.react-datepicker__time-list-item--disabled:hover': {
      cursor: 'default',
      backgroundColor: 'transparent'
    },
    '& .react-datepicker__week-number': {
      color: '#ccc',
      display: 'inline-block',
      width: '1.7rem',
      lineHeight: '1.7rem',
      textAlign: 'center',
      margin: '0.166rem'
    },
    '& .react-datepicker__week-number.react-datepicker__week-number--clickable': {
      cursor: 'pointer'
    },
    '& .react-datepicker__week-number.react-datepicker__week-number--clickable:hover': {
      borderRadius: '0.3rem',
      backgroundColor: '#f0f0f0'
    },
    '& .react-datepicker__day-names, & .react-datepicker__week': {
      whiteSpace: 'nowrap'
    },
    '& .react-datepicker__day-names': {
      marginBottom: '-8px'
    },
    '& .react-datepicker__day-name, & .react-datepicker__day, & .react-datepicker__time-name': {
      color: '#000',
      display: 'inline-block',
      width: '1.7rem',
      lineHeight: '1.7rem',
      textAlign: 'center',
      margin: '0.166rem'
    },
    '& .react-datepicker__month--selected, & .react-datepicker__month--in-selecting-range, & .react-datepicker__month--in-range, & .react-datepicker__quarter--selected, & .react-datepicker__quarter--in-selecting-range, & .react-datepicker__quarter--in-range': {
      borderRadius: '0.3rem',
      backgroundColor: '#216ba5',
      color: '#fff'
    },
    '& .react-datepicker__month--selected:hover, & .react-datepicker__month--in-selecting-range:hover, & .react-datepicker__month--in-range:hover, & .react-datepicker__quarter--selected:hover, & .react-datepicker__quarter--in-selecting-range:hover, & .react-datepicker__quarter--in-range:hover': {
      backgroundColor: '#1d5d90'
    },
    '& .react-datepicker__month--disabled, & .react-datepicker__quarter--disabled': {
      color: '#ccc',
      pointerEvents: 'none'
    },
    '& .react-datepicker__month--disabled:hover, & .react-datepicker__quarter--disabled:hover': {
      cursor: 'default',
      backgroundColor: 'transparent'
    },
    '& .react-datepicker__day, & .react-datepicker__month-text, & .react-datepicker__quarter-text, & .react-datepicker__year-text': {
      cursor: 'pointer'
    },
    '& .react-datepicker__day:hover, & .react-datepicker__month-text:hover, & .react-datepicker__quarter-text:hover, & .react-datepicker__year-text:hover': {
      borderRadius: '0.3rem',
      backgroundColor: '#f0f0f0'
    },
    '& .react-datepicker__day--today, & .react-datepicker__month-text--today, & .react-datepicker__quarter-text--today, & .react-datepicker__year-text--today': {
      fontWeight: 'bold'
    },
    '& .react-datepicker__day--highlighted, & .react-datepicker__month-text--highlighted, & .react-datepicker__quarter-text--highlighted, & .react-datepicker__year-text--highlighted': {
      borderRadius: '0.3rem',
      backgroundColor: '#3dcc4a',
      color: '#fff'
    },
    '& .react-datepicker__day--highlighted:hover, & .react-datepicker__month-text--highlighted:hover, & .react-datepicker__quarter-text--highlighted:hover, & .react-datepicker__year-text--highlighted:hover': {
      backgroundColor: '#32be3f'
    },
    '& .react-datepicker__day--highlighted-custom-1, & .react-datepicker__month-text--highlighted-custom-1, & .react-datepicker__quarter-text--highlighted-custom-1, & .react-datepicker__year-text--highlighted-custom-1': {
      color: 'magenta'
    },
    '& .react-datepicker__day--highlighted-custom-2, & .react-datepicker__month-text--highlighted-custom-2, & .react-datepicker__quarter-text--highlighted-custom-2, & .react-datepicker__year-text--highlighted-custom-2': {
      color: 'green'
    },
    '& .react-datepicker__day--selected, & .react-datepicker__day--in-selecting-range, & .react-datepicker__day--in-range, & .react-datepicker__month-text--selected, & .react-datepicker__month-text--in-selecting-range, & .react-datepicker__month-text--in-range, & .react-datepicker__quarter-text--selected, & .react-datepicker__quarter-text--in-selecting-range, & .react-datepicker__quarter-text--in-range, & .react-datepicker__year-text--selected, & .react-datepicker__year-text--in-selecting-range, & .react-datepicker__year-text--in-range': {
      borderRadius: '0.3rem',
      backgroundColor: '#216ba5',
      color: '#fff'
    },
    '& .react-datepicker__day--selected:hover, & .react-datepicker__day--in-selecting-range:hover, & .react-datepicker__day--in-range:hover, & .react-datepicker__month-text--selected:hover, & .react-datepicker__month-text--in-selecting-range:hover, & .react-datepicker__month-text--in-range:hover, & .react-datepicker__quarter-text--selected:hover, & .react-datepicker__quarter-text--in-selecting-range:hover, & .react-datepicker__quarter-text--in-range:hover, & .react-datepicker__year-text--selected:hover, & .react-datepicker__year-text--in-selecting-range:hover, & .react-datepicker__year-text--in-range:hover': {
      backgroundColor: '#1d5d90'
    },
    '& .react-datepicker__day--keyboard-selected, & .react-datepicker__month-text--keyboard-selected, & .react-datepicker__quarter-text--keyboard-selected, & .react-datepicker__year-text--keyboard-selected': {
      borderRadius: '0.3rem',
      backgroundColor: '#bad9f1',
      color: 'rgb(0, 0, 0)'
    },
    '& .react-datepicker__day--keyboard-selected:hover, & .react-datepicker__month-text--keyboard-selected:hover, & .react-datepicker__quarter-text--keyboard-selected:hover, & .react-datepicker__year-text--keyboard-selected:hover': {
      backgroundColor: '#1d5d90'
    },
    '& .react-datepicker__day--in-selecting-range:not(.react-datepicker__day--in-range,\n.react-datepicker__month-text--in-range,\n.react-datepicker__quarter-text--in-range,\n.react-datepicker__year-text--in-range), & .react-datepicker__month-text--in-selecting-range:not(.react-datepicker__day--in-range,\n.react-datepicker__month-text--in-range,\n.react-datepicker__quarter-text--in-range,\n.react-datepicker__year-text--in-range), & .react-datepicker__quarter-text--in-selecting-range:not(.react-datepicker__day--in-range,\n.react-datepicker__month-text--in-range,\n.react-datepicker__quarter-text--in-range,\n.react-datepicker__year-text--in-range), & .react-datepicker__year-text--in-selecting-range:not(.react-datepicker__day--in-range,\n.react-datepicker__month-text--in-range,\n.react-datepicker__quarter-text--in-range,\n.react-datepicker__year-text--in-range)': {
      backgroundColor: 'rgba(33, 107, 165, 0.5)'
    },
    '& .react-datepicker__month--selecting-range .react-datepicker__day--in-range:not(.react-datepicker__day--in-selecting-range,\n.react-datepicker__month-text--in-selecting-range,\n.react-datepicker__quarter-text--in-selecting-range,\n.react-datepicker__year-text--in-selecting-range), & .react-datepicker__month--selecting-range .react-datepicker__month-text--in-range:not(.react-datepicker__day--in-selecting-range,\n.react-datepicker__month-text--in-selecting-range,\n.react-datepicker__quarter-text--in-selecting-range,\n.react-datepicker__year-text--in-selecting-range), & .react-datepicker__month--selecting-range .react-datepicker__quarter-text--in-range:not(.react-datepicker__day--in-selecting-range,\n.react-datepicker__month-text--in-selecting-range,\n.react-datepicker__quarter-text--in-selecting-range,\n.react-datepicker__year-text--in-selecting-range), & .react-datepicker__month--selecting-range .react-datepicker__year-text--in-range:not(.react-datepicker__day--in-selecting-range,\n.react-datepicker__month-text--in-selecting-range,\n.react-datepicker__quarter-text--in-selecting-range,\n.react-datepicker__year-text--in-selecting-range)': {
      backgroundColor: '#f0f0f0',
      color: '#000'
    },
    '& .react-datepicker__day--disabled, & .react-datepicker__month-text--disabled, & .react-datepicker__quarter-text--disabled, & .react-datepicker__year-text--disabled': {
      cursor: 'default',
      color: '#ccc'
    },
    '& .react-datepicker__day--disabled:hover, & .react-datepicker__month-text--disabled:hover, & .react-datepicker__quarter-text--disabled:hover, & .react-datepicker__year-text--disabled:hover': {
      backgroundColor: 'transparent'
    },
    '& .react-datepicker__month-text.react-datepicker__month--selected:hover, & .react-datepicker__month-text.react-datepicker__month--in-range:hover, & .react-datepicker__month-text.react-datepicker__quarter--selected:hover, & .react-datepicker__month-text.react-datepicker__quarter--in-range:hover, & .react-datepicker__quarter-text.react-datepicker__month--selected:hover, & .react-datepicker__quarter-text.react-datepicker__month--in-range:hover, & .react-datepicker__quarter-text.react-datepicker__quarter--selected:hover, & .react-datepicker__quarter-text.react-datepicker__quarter--in-range:hover': {
      backgroundColor: '#216ba5'
    },
    '& .react-datepicker__month-text:hover, & .react-datepicker__quarter-text:hover': {
      backgroundColor: '#f0f0f0'
    },
    '& .react-datepicker__input-container': {
      position: 'relative',
      display: 'inline-block',
      width: '100%'
    },
    '& .react-datepicker__year-read-view, & .react-datepicker__month-read-view, & .react-datepicker__month-year-read-view': {
      border: '1px solid transparent',
      borderRadius: '0.3rem',
      position: 'relative'
    },
    '& .react-datepicker__year-read-view:hover, & .react-datepicker__month-read-view:hover, & .react-datepicker__month-year-read-view:hover': {
      cursor: 'pointer'
    },
    '& .react-datepicker__year-read-view:hover .react-datepicker__year-read-view--down-arrow, & .react-datepicker__year-read-view:hover .react-datepicker__month-read-view--down-arrow, & .react-datepicker__month-read-view:hover .react-datepicker__year-read-view--down-arrow, & .react-datepicker__month-read-view:hover .react-datepicker__month-read-view--down-arrow, & .react-datepicker__month-year-read-view:hover .react-datepicker__year-read-view--down-arrow, & .react-datepicker__month-year-read-view:hover .react-datepicker__month-read-view--down-arrow': {
      borderTopColor: '#b3b3b3'
    },
    '& .react-datepicker__year-read-view--down-arrow, & .react-datepicker__month-read-view--down-arrow, & .react-datepicker__month-year-read-view--down-arrow': {
      transform: 'rotate(135deg)',
      right: '-16px',
      top: '0'
    },
    '& .react-datepicker__year-dropdown, & .react-datepicker__month-dropdown, & .react-datepicker__month-year-dropdown': {
      backgroundColor: '#f0f0f0',
      position: 'absolute',
      width: '50%',
      left: '25%',
      top: '30px',
      zIndex: '1',
      textAlign: 'center',
      borderRadius: '0.3rem',
      border: '1px solid #aeaeae'
    },
    '& .react-datepicker__year-dropdown:hover, & .react-datepicker__month-dropdown:hover, & .react-datepicker__month-year-dropdown:hover': {
      cursor: 'pointer'
    },
    '& .react-datepicker__year-dropdown--scrollable, & .react-datepicker__month-dropdown--scrollable, & .react-datepicker__month-year-dropdown--scrollable': {
      height: '150px',
      overflowY: 'scroll'
    },
    '& .react-datepicker__year-option, & .react-datepicker__month-option, & .react-datepicker__month-year-option': {
      lineHeight: '20px',
      width: '100%',
      display: 'block',
      marginLeft: 'auto',
      marginRight: 'auto'
    },
    '& .react-datepicker__year-option:first-of-type, & .react-datepicker__month-option:first-of-type, & .react-datepicker__month-year-option:first-of-type': {
      borderTopLeftRadius: '0.3rem',
      borderTopRightRadius: '0.3rem'
    },
    '& .react-datepicker__year-option:last-of-type, & .react-datepicker__month-option:last-of-type, & .react-datepicker__month-year-option:last-of-type': {
      webkitUserSelect: 'none',
      mozUserSelect: 'none',
      msUserSelect: 'none',
      userSelect: 'none',
      borderBottomLeftRadius: '0.3rem',
      borderBottomRightRadius: '0.3rem'
    },
    '& .react-datepicker__year-option:hover, & .react-datepicker__month-option:hover, & .react-datepicker__month-year-option:hover': {
      backgroundColor: '#ccc'
    },
    '& .react-datepicker__year-option:hover .react-datepicker__navigation--years-upcoming, & .react-datepicker__month-option:hover .react-datepicker__navigation--years-upcoming, & .react-datepicker__month-year-option:hover .react-datepicker__navigation--years-upcoming': {
      borderBottomColor: '#b3b3b3'
    },
    '& .react-datepicker__year-option:hover .react-datepicker__navigation--years-previous, & .react-datepicker__month-option:hover .react-datepicker__navigation--years-previous, & .react-datepicker__month-year-option:hover .react-datepicker__navigation--years-previous': {
      borderTopColor: '#b3b3b3'
    },
    '& .react-datepicker__year-option--selected, & .react-datepicker__month-option--selected, & .react-datepicker__month-year-option--selected': {
      position: 'absolute',
      left: '15px'
    },
    '& .react-datepicker__close-icon': {
      cursor: 'pointer',
      backgroundColor: 'transparent',
      border: '0',
      outline: '0',
      padding: '0 6px 0 0',
      position: 'absolute',
      top: '0',
      right: '0',
      height: '100%',
      display: 'table-cell',
      verticalAlign: 'middle'
    },
    '& .react-datepicker__close-icon::after': {
      cursor: 'pointer',
      backgroundColor: '#216ba5',
      color: '#fff',
      borderRadius: '50%',
      height: '16px',
      width: '16px',
      padding: '2px',
      fontSize: '12px',
      lineHeight: '1',
      textAlign: 'center',
      display: 'table-cell',
      verticalAlign: 'middle',
      content: '"×"'
    },
    '& .react-datepicker__today-button': {
      background: '#f0f0f0',
      borderTop: '1px solid #aeaeae',
      cursor: 'pointer',
      textAlign: 'center',
      fontWeight: 'bold',
      padding: '5px 0',
      clear: 'left'
    },
    '& .react-datepicker__portal': {
      position: 'fixed',
      width: '100vw',
      height: '100vh',
      backgroundColor: 'rgba(0, 0, 0, 0.8)',
      left: '0',
      top: '0',
      justifyContent: 'center',
      alignItems: 'center',
      display: 'flex',
      zIndex: '2147483647'
    },
    '& .react-datepicker__portal .react-datepicker__day-name, & .react-datepicker__portal .react-datepicker__day, & .react-datepicker__portal .react-datepicker__time-name': {
      width: '3rem',
      lineHeight: '3rem'
    },
    '@media (max-width: 400px), (max-height: 550px)': {
      '& .react-datepicker__portal .react-datepicker__day-name, & .react-datepicker__portal .react-datepicker__day, & .react-datepicker__portal .react-datepicker__time-name': {
        width: '2rem',
        lineHeight: '2rem'
      }
    },
    '& .react-datepicker__portal .react-datepicker__current-month, & .react-datepicker__portal .react-datepicker-time__header': {
      fontSize: '1.44rem'
    },
    '& .react-datepicker__children-container': {
      width: '13.8rem',
      margin: '0.4rem',
      paddingRight: '0.2rem',
      paddingLeft: '0.2rem',
      height: 'auto'
    },
    '& .react-datepicker__aria-live': {
      position: 'absolute',
      clipPath: 'circle(0)',
      border: '0',
      height: '1px',
      margin: '-1px',
      overflow: 'hidden',
      padding: '0',
      width: '1px',
      whiteSpace: 'nowrap'
    }
  }
});

var useStyles = createMemoStyles(function (theme) {
  var _a, _b;
  var border = theme.border,
    palette = theme.palette,
    shadow = theme.shadow,
    spacing = theme.spacing,
    type = theme.type,
    breakpoints = theme.breakpoints;
  var input = {
    height: {
      sm: spacing[6],
      md: 40,
      lg: spacing[7]
    },
    padding: {
      sm: spacing[2],
      md: spacing[4],
      lg: spacing[4]
    }
  };
  var dateInputStyles = {
    wrenchDateInputButton: __assign(__assign(__assign({}, defaultBaseline), defaultFonts(theme)), {
      display: 'inline-flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      outline: 'none',
      appearance: 'none',
      boxShadow: 'none',
      padding: function (_a) {
        var size = _a.size;
        return size ? [[0, input.padding[size]]] : undefined;
      },
      height: function (_a) {
        var size = _a.size;
        return size ? input.height[size] : undefined;
      },
      width: function (_a) {
        var stretched = _a.stretched;
        return stretched ? '100%' : undefined;
      },
      color: palette.text.dark,
      border: function (_a) {
        var noBorder = _a.noBorder;
        return !noBorder ? [border.main] : 'none';
      },
      borderColor: function (_a) {
        var noBorder = _a.noBorder,
          showMenu = _a.showMenu;
        if (showMenu) return palette.border.hover;
        if (!noBorder) return palette.border.main;
        return 'none';
      },
      background: function (_a) {
        var noBorder = _a.noBorder;
        return !noBorder ? [palette.background.light] : 'none';
      },
      borderRadius: '4px',
      pointerEvents: function (_a) {
        var disabled = _a.disabled;
        return disabled ? 'none' : 'default';
      },
      opacity: function (_a) {
        var disabled = _a.disabled;
        return disabled ? 0.4 : 'default';
      },
      '&:hover': {
        borderColor: function (_a) {
          var noBorder = _a.noBorder;
          return !noBorder ? palette.border.hover : 'none';
        },
        boxShadow: shadow.sky,
        transition: ['border-color 100ms', 'box-shadow 100ms'],
        cursor: 'pointer'
      },
      '&:focus': {
        borderColor: palette.border.hover
      },
      '& > div': {
        margin: "0 ".concat(spacing[4], "px")
      },
      '& > svg': {
        margin: '0'
      }
    }),
    wrenchDateInput: {
      '& .popper-display-none': {
        display: 'none'
      },
      '& .react-datepicker__year-read-view--down-arrow, & .react-datepicker__month-read-view--down-arrow, & .react-datepicker__month-year-read-view--down-arrow, & .react-datepicker__navigation-icon::before': {
        borderColor: palette.secondary.main,
        borderWidth: '1px 1px 0 0',
        height: spacing[3],
        width: spacing[3]
      },
      '& .react-datepicker-popper[data-placement^=top] .react-datepicker__triangle, & .react-datepicker-popper[data-placement^=bottom] .react-datepicker__triangle': {
        display: 'none'
      },
      '& .react-datepicker-popper[data-placement^=top] .react-datepicker__triangle::before, & .react-datepicker-popper[data-placement^=bottom] .react-datepicker__triangle::before': {
        borderBottomColor: palette.border.main
      },
      '& .react-datepicker-popper[data-placement^=bottom] .react-datepicker__triangle': {
        display: 'none'
      },
      '& .react-datepicker-popper[data-placement^=bottom] .react-datepicker__triangle::before, & .react-datepicker-popper[data-placement^=bottom] .react-datepicker__triangle::after': {
        borderBottomColor: palette.background.primary.medium
      },
      '& .react-datepicker-popper[data-placement^=bottom] .react-datepicker__triangle::before': {
        borderBottomColor: palette.border.main
      },
      '& .react-datepicker-popper[data-placement^=top] .react-datepicker__triangle::before': {
        borderTopColor: palette.border.main
      },
      '& .react-datepicker-wrapper': {
        marginBottom: spacing[2]
      },
      '& .react-datepicker': {
        fontSize: '1rem',
        fontWeight: type.fontWeight.medium,
        color: palette.text.dark,
        border: function (_a) {
          var inline = _a.inline,
            range = _a.range;
          return inline || range ? "solid 1px ".concat(palette.border.muted) : 'none';
        },
        borderRadius: 0,
        padding: function (_a) {
          var range = _a.range;
          return range ? 0 : '8px';
        },
        boxShadow: function (_a) {
          var inline = _a.inline,
            range = _a.range;
          return !inline && !range ? shadow.sky : 'none';
        },
        opacity: function (_a) {
          var inline = _a.inline,
            disabled = _a.disabled;
          return inline && disabled ? 0.5 : 1;
        },
        pointerEvents: function (_a) {
          var inline = _a.inline,
            disabled = _a.disabled;
          return inline && disabled ? 'none' : 'auto';
        }
      },
      '& .react-datepicker__header': {
        backgroundColor: palette.background.main,
        borderBottom: border.muted,
        borderTopLeftRadius: 0,
        padding: '8px'
      },
      '& .react-datepicker__header:not(.react-datepicker__header--has-time-select)': {
        borderTopRightRadius: 0
      },
      '& .react-datepicker__current-month, & .react-datepicker-time__header, & .react-datepicker-year-header': {
        color: palette.text.dark,
        fontWeight: type.fontWeight.medium,
        fontSize: '1rem'
      },
      '& .react-datepicker__time-container': {
        borderLeft: border.main
      },
      '& .react-datepicker__time-container--with-today-button': {
        border: border.main,
        borderRadius: '0rem'
      },
      '& .react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list li.react-datepicker__time-list-item': {
        height: 'auto',
        padding: '4px 8px'
      },
      '& .react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list li.react-datepicker__time-list-item:hover': {
        backgroundColor: palette.background.primary.medium
      },
      '& .react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list li.react-datepicker__time-list-item--selected': {
        backgroundColor: palette.primary.main,
        fontWeight: type.fontWeight.medium
      },
      '& .react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list li.react-datepicker__time-list-item--selected:hover': {
        backgroundColor: palette.primary.main
      },
      '& .react-datepicker__week-number': {
        width: '2rem',
        lineHeight: '2rem'
      },
      '& .react-datepicker__week-number.react-datepicker__week-number--clickable:hover': {
        borderRadius: '0rem',
        backgroundColor: palette.background.primary.medium
      },
      '& .react-datepicker__day-name, & .react-datepicker__day, & .react-datepicker__time-name': {
        color: palette.text.dark,
        width: '2rem',
        lineHeight: '2rem',
        margin: '1px 1px 0 0 '
      },
      '&  .react-datepicker__day--outside-month': {
        color: palette.text.darkMuted
      },
      '& .react-datepicker__month--selected, & .react-datepicker__month--in-selecting-range, & .react-datepicker__month--in-range, & .react-datepicker__quarter--selected, & .react-datepicker__quarter--in-selecting-range, & .react-datepicker__quarter--in-range': {
        borderRadius: '0',
        backgroundColor: palette.primary.main
      },
      '& .react-datepicker__month--selected:hover, & .react-datepicker__month--in-selecting-range:hover, & .react-datepicker__month--in-range:hover, & .react-datepicker__quarter--selected:hover, & .react-datepicker__quarter--in-selecting-range:hover, & .react-datepicker__quarter--in-range:hover': {
        backgroundColor: palette.primary.main
      },
      '& .react-datepicker__day:hover, & .react-datepicker__month-text:hover, & .react-datepicker__quarter-text:hover, & .react-datepicker__year-text:hover': {
        borderRadius: '0rem',
        backgroundColor: palette.background.primary.medium
      },
      '& .react-datepicker__day--today, & .react-datepicker__month-text--today, & .react-datepicker__quarter-text--today, & .react-datepicker__year-text--today': {
        fontWeight: type.fontWeight.medium
      },
      '& .react-datepicker__day--highlighted, & .react-datepicker__month-text--highlighted, & .react-datepicker__quarter-text--highlighted, & .react-datepicker__year-text--highlighted': {
        borderRadius: '0'
      },
      '& .react-datepicker__day--selected, & .react-datepicker__day--in-selecting-range, & .react-datepicker__day--in-range, & .react-datepicker__month-text--selected, & .react-datepicker__month-text--in-selecting-range, & .react-datepicker__month-text--in-range, & .react-datepicker__quarter-text--selected, & .react-datepicker__quarter-text--in-selecting-range, & .react-datepicker__quarter-text--in-range, & .react-datepicker__year-text--selected, & .react-datepicker__year-text--in-selecting-range, & .react-datepicker__year-text--in-range': {
        borderRadius: '0rem',
        backgroundColor: palette.background.primary.medium,
        color: palette.text.dark
      },
      '& .react-datepicker__day--selected:hover, & .react-datepicker__day--in-selecting-range:hover, & .react-datepicker__day--in-range:hover, & .react-datepicker__month-text--selected:hover, & .react-datepicker__month-text--in-selecting-range:hover, & .react-datepicker__month-text--in-range:hover, & .react-datepicker__quarter-text--selected:hover, & .react-datepicker__quarter-text--in-selecting-range:hover, & .react-datepicker__quarter-text--in-range:hover, & .react-datepicker__year-text--selected:hover, & .react-datepicker__year-text--in-selecting-range:hover, & .react-datepicker__year-text--in-range:hover': {
        backgroundColor: palette.background.primary.medium
      },
      '& .react-datepicker__day--range-start, & .react-datepicker__day--range-start:hover, & .react-datepicker__day--range-end, & .react-datepicker__day--range-end:hover': {
        backgroundColor: palette.primary.main,
        color: '#fff'
      },
      '& .react-datepicker__day--keyboard-selected, & .react-datepicker__month-text--keyboard-selected, & .react-datepicker__quarter-text--keyboard-selected, & .react-datepicker__year-text--keyboard-selected': {
        borderRadius: '0rem'
      },
      '& .react-datepicker__day--keyboard-selected:hover, & .react-datepicker__month-text--keyboard-selected:hover, & .react-datepicker__quarter-text--keyboard-selected:hover, & .react-datepicker__year-text--keyboard-selected:hover': {
        backgroundColor: palette.primary.main
      },
      '& .react-datepicker__day--in-selecting-range:not(.react-datepicker__day--in-range,\n.react-datepicker__month-text--in-range,\n.react-datepicker__quarter-text--in-range,\n.react-datepicker__year-text--in-range), & .react-datepicker__month-text--in-selecting-range:not(.react-datepicker__day--in-range,\n.react-datepicker__month-text--in-range,\n.react-datepicker__quarter-text--in-range,\n.react-datepicker__year-text--in-range), & .react-datepicker__quarter-text--in-selecting-range:not(.react-datepicker__day--in-range,\n.react-datepicker__month-text--in-range,\n.react-datepicker__quarter-text--in-range,\n.react-datepicker__year-text--in-range), & .react-datepicker__year-text--in-selecting-range:not(.react-datepicker__day--in-range,\n.react-datepicker__month-text--in-range,\n.react-datepicker__quarter-text--in-range,\n.react-datepicker__year-text--in-range)': {
        backgroundColor: palette.background.primary.medium
      },
      '& .react-datepicker__month--selecting-range .react-datepicker__day--in-range:not(.react-datepicker__day--in-selecting-range,\n  .react-datepicker__month-text--in-selecting-range,\n  .react-datepicker__quarter-text--in-selecting-range,\n  .react-datepicker__year-text--in-selecting-range), & .react-datepicker__month--selecting-range .react-datepicker__month-text--in-range:not(.react-datepicker__day--in-selecting-range,\n  .react-datepicker__month-text--in-selecting-range,\n  .react-datepicker__quarter-text--in-selecting-range,\n  .react-datepicker__year-text--in-selecting-range), & .react-datepicker__month--selecting-range .react-datepicker__quarter-text--in-range:not(.react-datepicker__day--in-selecting-range,\n  .react-datepicker__month-text--in-selecting-range,\n  .react-datepicker__quarter-text--in-selecting-range,\n  .react-datepicker__year-text--in-selecting-range), & .react-datepicker__month--selecting-range .react-datepicker__year-text--in-range:not(.react-datepicker__day--in-selecting-range,\n  .react-datepicker__month-text--in-selecting-range,\n  .react-datepicker__quarter-text--in-selecting-range,\n  .react-datepicker__year-text--in-selecting-range)': {
        backgroundColor: palette.background.primary.medium,
        color: palette.text.dark
      },
      '& .react-datepicker__month-text.react-datepicker__month--selected:hover, & .react-datepicker__month-text.react-datepicker__month--in-range:hover, & .react-datepicker__month-text.react-datepicker__quarter--selected:hover, & .react-datepicker__month-text.react-datepicker__quarter--in-range:hover, & .react-datepicker__quarter-text.react-datepicker__month--selected:hover, & .react-datepicker__quarter-text.react-datepicker__month--in-range:hover, & .react-datepicker__quarter-text.react-datepicker__quarter--selected:hover, & .react-datepicker__quarter-text.react-datepicker__quarter--in-range:hover': {
        backgroundColor: palette.primary.main
      },
      '& .react-datepicker__month-text:hover, & .react-datepicker__quarter-text:hover': {
        backgroundColor: palette.background.primary.medium
      },
      '& .react-datepicker__year-read-view, & .react-datepicker__month-read-view, & .react-datepicker__month-year-read-view': {
        borderRadius: '0rem'
      },
      '& .react-datepicker__year-dropdown, & .react-datepicker__month-dropdown, & .react-datepicker__month-year-dropdown': {
        backgroundColor: palette.background.primary.medium,
        borderRadius: '0rem',
        border: border.main
      },
      '& .react-datepicker__close-icon::after': {
        backgroundColor: palette.primary.main
      },
      '& .react-datepicker__today-button': {
        background: palette.background.primary.medium,
        borderTop: border.main,
        fontWeight: type.fontWeight.medium
      },
      '& .date-input-month-button': {
        backgroundColor: 'transparent',
        border: 'none',
        height: '40px',
        width: '40px'
      },
      '& .date-input-month-button:hover': {
        backgroundColor: 'white',
        cursor: 'pointer'
      },
      '& .date-input-year-select': {
        backgroundColor: 'transparent',
        border: 'none',
        height: '40px',
        color: palette.text.dark,
        fontSize: type.fontSize.body,
        fontFamily: type.fontFamily.base,
        fontWeight: type.fontWeight.medium
      },
      '& .date-input-year-select--range': (_a = {
        position: 'absolute',
        left: '218px',
        zIndex: '1'
      }, _a["@media (max-width: ".concat(breakpoints.sm, "px)")] = {
        position: 'relative',
        left: 0
      }, _a),
      '& .react-datepicker .react-datepicker__day--selected, & .react-datepicker .react-datepicker__day--selected:hover': {
        backgroundColor: palette.primary.main,
        color: '#ffffff'
      },
      '& .react-datepicker__day--selected:not(.react-datepicker__day--in-range,\n.react-datepicker__month-text--in-range,\n.react-datepicker__quarter-text--in-range,\n.react-datepicker__year-text--in-range)': {
        backgroundColor: palette.primary.main,
        color: '#fff'
      },
      '& .react-datepicker__day--disabled': {
        opacity: 0.5
      },
      '& .react-datepicker__day--disabled:hover': {
        backgroundColor: 'white'
      },
      '& .react-datepicker__input-container > div': {
        background: function (_a) {
          var noBorder = _a.noBorder;
          return noBorder ? 'none' : undefined;
        },
        border: function (_a) {
          var noBorder = _a.noBorder;
          return noBorder ? 'none' : undefined;
        }
      }
    },
    wrenchDateRangeContainer: (_b = {}, _b["@media (min-width: ".concat(breakpoints.sm, "px)")] = {
      minWidth: 500
    }, _b)
  };
  return dateInputStyles;
});

var DateInputHeader$1 = function DateInputHeader(_a) {
  var locale = _a.locale,
    labelPreviousMonth = _a.labelPreviousMonth,
    labelNextMonth = _a.labelNextMonth,
    years = _a.years;
  return function (_a) {
    var date = _a.date,
      changeYear = _a.changeYear,
      increaseMonth = _a.increaseMonth,
      decreaseMonth = _a.decreaseMonth,
      prevMonthButtonDisabled = _a.prevMonthButtonDisabled,
      nextMonthButtonDisabled = _a.nextMonthButtonDisabled;
    var monthString = date.toLocaleString(locale, {
      month: 'long'
    });
    return jsxs(Box, {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      children: [jsx("button", {
        type: "button",
        className: "date-input-month-button",
        onClick: decreaseMonth,
        disabled: prevMonthButtonDisabled,
        "aria-label": labelPreviousMonth,
        children: jsx(IconArrowLeft, {
          title: labelPreviousMonth
        })
      }), jsx(Typography, {
        weight: "medium",
        children: monthString
      }), jsx("select", {
        className: "date-input-year-select",
        value: getYear(date),
        onChange: function (_a) {
          var value = _a.target.value;
          return changeYear(parseInt(value, 10));
        },
        children: years.map(function (option) {
          return jsx("option", {
            value: option,
            children: option
          }, option);
        })
      }), jsx("button", {
        type: "button",
        className: "date-input-month-button",
        onClick: increaseMonth,
        disabled: nextMonthButtonDisabled,
        "aria-label": labelNextMonth,
        children: jsx(IconArrowRight, {
          title: labelNextMonth
        })
      })]
    });
  };
};

function getRange(start, end, step) {
  if (step === void 0) {
    step = 1;
  }
  var index = -1;
  var length = Math.max(Math.ceil((end - start + (step > 0 ? 1 : -1)) / step), 0);
  var result = new Array(length);
  var value = start;
  while (length) {
    length -= 1;
    index += 1;
    result[index] = value;
    value += step;
  }
  return result;
}

var localeMap = {
  en: en,
  'zh-tw': zhTW,
  'pt-br': ptBR,
  da: da,
  nl: nl,
  fi: fi,
  fr: fr,
  de: de$1,
  it: it$1,
  ja: ja,
  ko: ko,
  no: nn,
  ru: ru,
  es: es,
  sv: sv,
  tr: tr$1
};
function registerLocales() {
  SITE_WIDE_LOCALE_CODES.forEach(function (locale) {
    Ue(locale, localeMap[locale]);
  });
}

registerLocales();
var WrenchInput$1 = /*#__PURE__*/forwardRef(function (props, ref) {
  var inputType = props.inputType;
    props.inputRef;
    var inputId = props.inputId,
    label = props.label,
    rest = __rest(props, ["inputType", "inputRef", "inputId", "label"]);
  return jsxs(InputGroup, {
    disabled: props.disabled,
    stretched: props.stretched,
    label: label,
    id: inputId,
    children: [jsx(InputGroupAddon, {
      children: inputType === 'time' ? jsx(IconClock, {
        title: "Clock icon"
      }) : jsx(IconCalendar, {
        title: "Calendar icon"
      })
    }), jsx(Input, __assign({}, rest, {
      id: inputId,
      ref: ref
    }))]
  });
});
var getDefaultRange$1 = function getDefaultRange() {
  var year = new Date().getFullYear();
  return getRange(year - 10, year);
};
var todaysDate$1 = new Date();
var initialDate = new Date(todaysDate$1);
var DateInput = function DateInput(_a) {
  var id = _a.id,
    label = _a.label,
    ariaLabel = _a.ariaLabel,
    _b = _a.selectedDate,
    selectedDate = _b === void 0 ? initialDate : _b,
    onChange = _a.onChange,
    _c = _a.type,
    type = _c === void 0 ? 'date' : _c,
    _d = _a.inline,
    inline = _d === void 0 ? false : _d,
    _e = _a.size,
    size = _e === void 0 ? 'md' : _e,
    _f = _a.disabled,
    disabled = _f === void 0 ? false : _f,
    _g = _a.stretched,
    stretched = _g === void 0 ? false : _g,
    _h = _a.locale,
    locale = _h === void 0 ? 'en' : _h,
    _j = _a.labelTime,
    labelTime = _j === void 0 ? 'Time' : _j,
    _k = _a.labelPreviousMonth,
    labelPreviousMonth = _k === void 0 ? 'Previous month' : _k,
    _l = _a.labelNextMonth,
    labelNextMonth = _l === void 0 ? 'Next month' : _l,
    _m = _a.years,
    years = _m === void 0 ? getDefaultRange$1() : _m,
    _o = _a.noBorder,
    noBorder = _o === void 0 ? false : _o,
    rest = __rest(_a, ["id", "label", "ariaLabel", "selectedDate", "onChange", "type", "inline", "size", "disabled", "stretched", "locale", "labelTime", "labelPreviousMonth", "labelNextMonth", "years", "noBorder"]);
  var range = false;
  var showMenu = inline;
  var reactDatepicker = useStylesReactDatepicker().reactDatepicker;
  var wrenchDateInput = useStyles({
    inline: inline,
    size: size,
    disabled: disabled,
    stretched: stretched,
    range: range,
    showMenu: showMenu,
    noBorder: noBorder
  }).wrenchDateInput;
  var inputRef = useRef(null);
  var dateInputID = useMemo(function () {
    return id !== null && id !== void 0 ? id : uniqueId('input');
  }, [id]);
  var showTime;
  var timeOnly;
  var dateFormat;
  switch (type) {
    case 'time':
      timeOnly = true;
      showTime = true;
      dateFormat = 'pp';
      break;
    case 'date':
      showTime = false;
      timeOnly = false;
      dateFormat = 'PP';
      break;
    case 'datetime':
      showTime = true;
      timeOnly = false;
      dateFormat = 'Pp';
      break;
  }
  return jsx("div", {
    className: reactDatepicker,
    children: jsxs("div", {
      className: wrenchDateInput,
      children: [inline && jsx(er, __assign({
        selected: selectedDate,
        onChange: onChange,
        disabled: disabled,
        customInput: jsx(WrenchInput$1, {
          size: size,
          disabled: disabled,
          stretched: stretched,
          inputRef: inputRef,
          inputType: type,
          inputId: dateInputID,
          label: label,
          ariaLabel: ariaLabel
        }),
        locale: locale,
        showTimeSelect: showTime,
        timeFormat: showTime ? 'p' : undefined,
        timeIntervals: showTime ? 15 : undefined,
        showTimeSelectOnly: timeOnly,
        dateFormat: dateFormat,
        popperClassName: "popper-display-none"
      }, safeRest(rest))), jsx(er, __assign({
        selected: selectedDate,
        onChange: onChange,
        disabled: disabled,
        customInput: inline ? null : jsx(WrenchInput$1, {
          size: size,
          disabled: disabled,
          stretched: stretched,
          inputRef: inputRef,
          inputType: type,
          inputId: dateInputID,
          label: label,
          ariaLabel: ariaLabel
        }),
        locale: locale,
        showTimeSelect: showTime,
        timeIntervals: showTime ? 15 : undefined,
        showTimeSelectOnly: timeOnly,
        dateFormat: dateFormat,
        timeCaption: labelTime,
        inline: inline,
        renderCustomHeader: DateInputHeader$1({
          years: years,
          locale: locale,
          labelPreviousMonth: labelPreviousMonth,
          labelNextMonth: labelNextMonth
        })
      }, safeRest(rest)))]
    })
  });
};

var DateInputHeader = function DateInputHeader(_a) {
  var locale = _a.locale,
    labelPreviousMonth = _a.labelPreviousMonth,
    labelNextMonth = _a.labelNextMonth,
    years = _a.years;
  return function (_a) {
    var date = _a.date,
      monthDate = _a.monthDate,
      customHeaderCount = _a.customHeaderCount,
      changeYear = _a.changeYear,
      increaseMonth = _a.increaseMonth,
      decreaseMonth = _a.decreaseMonth,
      prevMonthButtonDisabled = _a.prevMonthButtonDisabled,
      nextMonthButtonDisabled = _a.nextMonthButtonDisabled;
    return jsx(Box, {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      children: jsx(Responsive, {
        minWidth: "sm",
        children: function (isDesktop) {
          return jsxs(Fragment, {
            children: [jsx("button", {
              type: "button",
              "aria-label": "Previous Month",
              className: "date-input-month-button",
              style: customHeaderCount === 1 ? {
                visibility: 'hidden'
              } : undefined,
              onClick: decreaseMonth,
              disabled: prevMonthButtonDisabled,
              children: jsx(IconArrowLeft, {
                title: labelPreviousMonth
              })
            }), jsx("span", {
              className: "react-datepicker__current-month",
              children: monthDate.toLocaleString(locale, {
                month: 'long'
              })
            }), jsx("select", {
              className: "date-input-year-select date-input-year-select--range",
              value: getYear(date),
              onChange: function (_a) {
                var value = _a.target.value;
                return changeYear(parseInt(value, 10));
              },
              style: {
                display: customHeaderCount === 1 ? 'none' : undefined
              },
              children: years.map(function (option) {
                return jsx("option", {
                  value: option,
                  children: option
                }, option);
              })
            }), jsx("button", {
              type: "button",
              "aria-label": "Next Month",
              className: "date-input-month-button",
              style: customHeaderCount === 0 && isDesktop ? {
                visibility: 'hidden'
              } : undefined,
              onClick: increaseMonth,
              disabled: nextMonthButtonDisabled,
              children: jsx(IconArrowRight, {
                title: labelNextMonth
              })
            })]
          });
        }
      })
    });
  };
};

registerLocales();
var WrenchInput = /*#__PURE__*/forwardRef(function (props, ref) {
  props.inputRef;
    var inputId = props.inputId,
    rest = __rest(props, ["inputRef", "inputId"]);
  return jsxs(InputGroup, {
    disabled: props.disabled,
    stretched: true,
    children: [jsx(InputGroupAddon, {
      children: jsx(IconCalendar, {
        title: "Calendar icon"
      })
    }), jsx(Input, __assign({}, rest, {
      id: inputId,
      ref: ref
    }))]
  });
});
var getDefaultRange = function getDefaultRange() {
  var year = new Date().getFullYear();
  return getRange(year - 10, year);
};
var todaysDate = new Date();
var initialStartDate = new Date(todaysDate);
var initialEndDate = new Date(addWeeks(todaysDate, 2));
var DateRange = function DateRange(_a) {
  var _b;
  var id = _a.id,
    _c = _a.size,
    size = _c === void 0 ? 'md' : _c,
    _d = _a.disabled,
    disabled = _d === void 0 ? false : _d,
    _e = _a.stretched,
    stretched = _e === void 0 ? false : _e,
    _f = _a.locale,
    locale = _f === void 0 ? 'en' : _f,
    label = _a.label,
    _g = _a.labelPreviousMonth,
    labelPreviousMonth = _g === void 0 ? 'Previous month' : _g,
    _h = _a.labelNextMonth,
    labelNextMonth = _h === void 0 ? 'Next month' : _h,
    _j = _a.labelStartDate,
    labelStartDate = _j === void 0 ? 'Start date' : _j,
    _k = _a.labelEndDate,
    labelEndDate = _k === void 0 ? 'End date' : _k,
    _l = _a.labelDoneButton,
    labelDoneButton = _l === void 0 ? 'Done' : _l,
    _m = _a.years,
    years = _m === void 0 ? getDefaultRange() : _m,
    _o = _a.selectedStartDate,
    selectedStartDate = _o === void 0 ? initialStartDate : _o,
    _p = _a.selectedEndDate,
    selectedEndDate = _p === void 0 ? initialEndDate : _p,
    minDate = _a.minDate,
    maxDate = _a.maxDate,
    onChangeStartDate = _a.onChangeStartDate,
    onChangeEndDate = _a.onChangeEndDate,
    quickOptions = _a.quickOptions,
    _q = _a.labelCustomRange,
    labelCustomRange = _q === void 0 ? 'Custom date range' : _q,
    placement = _a.placement,
    _r = _a.show,
    show = _r === void 0 ? false : _r,
    renderTo = _a.renderTo,
    _s = _a.noBorder,
    noBorder = _s === void 0 ? false : _s,
    startDateInputProps = _a.startDateInputProps,
    endDateInputProps = _a.endDateInputProps;
  var _t = useState(false),
    showCustomDates = _t[0],
    setShowCustomDates = _t[1];
  var _u = useState(show),
    showMenu = _u[0],
    setShowMenu = _u[1];
  var range = true;
  var inline = false;
  var selectedQuickOption = quickOptions === null || quickOptions === void 0 ? void 0 : quickOptions.find(function (quickOption) {
    return (selectedStartDate === null || selectedStartDate === void 0 ? void 0 : selectedStartDate.getTime()) === quickOption.startDate.getTime() && (selectedEndDate === null || selectedEndDate === void 0 ? void 0 : selectedEndDate.getTime()) === quickOption.endDate.getTime();
  });
  var reactDatepicker = useStylesReactDatepicker().reactDatepicker;
  var _v = useStyles({
      inline: inline,
      size: size,
      disabled: disabled,
      stretched: stretched,
      range: range,
      showMenu: showMenu,
      noBorder: noBorder
    }),
    wrenchDateInput = _v.wrenchDateInput,
    wrenchDateInputButton = _v.wrenchDateInputButton,
    wrenchDateRangeContainer = _v.wrenchDateRangeContainer;
  var inputRef = useRef(null);
  var dateInputID = useMemo(function () {
    return id !== null && id !== void 0 ? id : uniqueId('input');
  }, [id]);
  var formattedStartDate = selectedStartDate ? format(selectedStartDate, 'PP', {
    locale: localeMap[locale]
  }) : '';
  var formattedEndDate = selectedEndDate ? format(selectedEndDate, 'PP', {
    locale: localeMap[locale]
  }) : '';
  var displayedRange = (_b = selectedQuickOption === null || selectedQuickOption === void 0 ? void 0 : selectedQuickOption.label) !== null && _b !== void 0 ? _b : "".concat(formattedStartDate, " - ").concat(formattedEndDate);
  return jsxs(Fragment, {
    children: [label && jsx(Label, {
      htmlFor: dateInputID,
      children: label
    }), jsx("div", {
      className: reactDatepicker,
      children: jsx("div", {
        className: wrenchDateInput,
        children: jsxs(Menu, {
          show: showMenu,
          onChange: function () {
            return setShowMenu(!showMenu);
          },
          menuTrigger: jsxs("button", {
            type: "button",
            className: wrenchDateInputButton,
            onClick: function () {
              return setShowMenu(!showMenu);
            },
            children: [jsx(IconCalendar, {
              title: "image"
            }), jsx(Typography, {
              children: displayedRange
            }), jsx(IconCaretDown, {
              title: "caret"
            })]
          }),
          noRules: true,
          autoClose: false,
          stretched: true,
          noMaxHeight: true,
          placement: placement,
          renderTo: renderTo,
          children: [quickOptions && !showCustomDates && jsxs(Fragment, {
            children: [quickOptions.map(function (option) {
              return jsx(Menu.Item, {
                addOnLeft: option === selectedQuickOption ? jsx(IconCheck, {
                  color: "success",
                  title: "Checkmark icon."
                }) : null,
                interactive: true,
                onClick: function (e) {
                  onChangeStartDate(option.startDate, e);
                  onChangeEndDate(option.endDate, e);
                  setShowMenu(false);
                },
                children: jsxs(Box, {
                  style: {
                    minWidth: '300px'
                  },
                  display: "flex",
                  justifyContent: "space-between",
                  children: [jsx(Typography, {
                    variant: "bodySm",
                    children: option.label
                  }), jsxs(Typography, {
                    color: "darkMuted",
                    variant: "bodySm",
                    children: [format(option.startDate, 'PP', {
                      locale: localeMap[locale]
                    }), ' ', "-", ' ', format(option.endDate, 'PP', {
                      locale: localeMap[locale]
                    })]
                  })]
                })
              }, option.label);
            }), jsx(Menu.Item, {
              addOnLeft: !selectedQuickOption ? jsx(IconCheck, {
                color: "success",
                title: "Checkmark icon."
              }) : null,
              interactive: true,
              onClick: function () {
                setShowCustomDates(!showCustomDates);
              },
              children: jsx(Typography, {
                variant: "bodySm",
                color: "link",
                children: labelCustomRange
              })
            })]
          }), (!quickOptions || showCustomDates) && jsxs(Fragment, {
            children: [quickOptions && jsx(Menu.Item, {
              interactive: true,
              onClick: function () {
                return setShowCustomDates(!showCustomDates);
              },
              children: jsxs(Box, {
                display: "flex",
                justifyContent: "start",
                alignItems: "center",
                children: [jsx(Box, {
                  mr: 4,
                  children: jsx(IconArrowLeft, {
                    title: "back button"
                  })
                }), jsx(Typography, {
                  variant: "cardTitle",
                  component: "span",
                  children: labelCustomRange
                })]
              })
            }), jsx(Menu.Item, {
              interactive: false,
              children: jsxs(Box, {
                my: 4,
                className: wrenchDateRangeContainer,
                children: [jsxs(Box, {
                  children: [jsx(Box, {
                    children: jsxs(Box, {
                      display: "flex",
                      gap: 3,
                      justifyContent: "space-between",
                      children: [jsxs(Box, {
                        children: [jsx(Label, {
                          htmlFor: "".concat(dateInputID, "-start"),
                          children: labelStartDate
                        }), jsx(er, __assign({
                          customInput: jsx(WrenchInput, {
                            inputRef: inputRef,
                            inputId: "".concat(dateInputID, "-start")
                          }),
                          locale: locale,
                          dateFormat: "P",
                          selected: selectedStartDate,
                          onChange: onChangeStartDate,
                          popperClassName: "popper-display-none",
                          minDate: minDate,
                          maxDate: maxDate
                        }, startDateInputProps))]
                      }), jsxs(Box, {
                        children: [jsx(Label, {
                          htmlFor: "".concat(dateInputID, "-end"),
                          children: labelEndDate
                        }), jsx(er, __assign({
                          customInput: jsx(WrenchInput, {
                            inputRef: inputRef,
                            inputId: "".concat(dateInputID, "-end")
                          }),
                          locale: locale,
                          dateFormat: "P",
                          selected: selectedEndDate,
                          onChange: onChangeEndDate,
                          popperClassName: "popper-display-none",
                          minDate: minDate,
                          maxDate: maxDate
                        }, endDateInputProps))]
                      })]
                    })
                  }), jsx(Box, {
                    display: "flex",
                    justifyContent: "center",
                    children: jsx(Responsive, {
                      minWidth: "sm",
                      children: function (matches) {
                        return jsx(er, {
                          selected: selectedStartDate,
                          onChange: function (_a, event) {
                            var startDate = _a[0],
                              endDate = _a[1];
                            onChangeStartDate(startDate, event);
                            onChangeEndDate(endDate, event);
                          },
                          startDate: selectedStartDate,
                          endDate: selectedEndDate,
                          minDate: minDate,
                          maxDate: maxDate,
                          disabledKeyboardNavigation: true,
                          selectsRange: true,
                          monthsShown: matches ? 2 : 1,
                          customInput: jsx("div", {}),
                          inline: true,
                          locale: locale,
                          renderCustomHeader: DateInputHeader({
                            years: years,
                            locale: locale,
                            labelPreviousMonth: labelPreviousMonth,
                            labelNextMonth: labelNextMonth
                          }),
                          id: dateInputID
                        });
                      }
                    })
                  })]
                }), jsx(Box, {
                  display: "flex",
                  justifyContent: "end",
                  alignContent: "center",
                  mt: 4,
                  children: jsx(Button, {
                    color: "success",
                    onClick: function () {
                      return setShowMenu(false);
                    },
                    children: labelDoneButton
                  })
                })]
              })
            })]
          })]
        })
      })
    })]
  });
};

export { DateInput, DateRange, getRange };
